import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from 'react';

import {
  View,
  Text,
  Image,
  TouchableOpacity,
  Animated,
  ScrollView,
  Dimensions,
  Easing,
  Platform,
  InteractionManager,
  ImageBackground,
  Pressable
} from 'react-native';


import TakeSeatSvg from '../assets/inGameAssets/takeSeat.svg';
import EmptySeat from '../assets/inGameAssets/emptySeat.svg';

import ChatSvg from '../assets/inGameAssets/chat.svg';

import HandHistorySvg from '../assets/inGameAssets/handHistory.svg';
import RealTimeResultsSvg from '../assets/inGameAssets/realTimeResults.svg';
import MenuSvg from '../assets/inGameAssets/menu.svg';
import ExitTableSvg from '../assets/inGameAssets/exitTable.svg';
import SitOutSvg from '../assets/inGameAssets/sitOut.svg';
import MoveTableSvg from '../assets/inGameAssets/moveTable.svg';
import LineSvg from '../assets/inGameAssets/line.svg';
import CurrencyExchangeSvg from '../assets/inGameAssets/currencyExchange.svg';
import { styles } from './style';

import colors from '../constants/colors';

import {
  cardPositionAngles,
  cardsPositions,
  ChatrawPositions,
  rawPositions,
  seatMapWithAnlge,
  verticalOffsets,
  NLHChatseatGroups,
} from '../constants/cardPositions/nlh/positions';
import { cardImages } from '../constants/cardImages/cardImages';





import TableInfo from '../components/inGame/tableInfo';
import PotInfo from '../components/inGame/potInfo';



// import Ionicons from 'react-native-vector-icons/Ionicons';


//socket


import {
  ACK_END_HAND,
  ACTION_SITTED,
  BB_POST,
  BB_POSTED,
  BETTING_ACTION,
  BOMB_POT,
  BUY_IN_CANCEL,
  BUY_IN_CONFIRM,
  CALL,
  CARD_REVEAL,
  CHECK,
  DO_RABBIT,
  END_HAND,
  FETCH_LOBBY_INFO,
  FOLD,
  GET_RABBIT_CARDS,
  JOIN_GAME_CHAT,
  JOIN_TABLE,
  LEAVE_TABLE,
  PREPLAY_ACTION,
  RAISE,
  REAL_TIME_RESULTS,
  RECEIVE_MESSAGES,
  ROUND_CHANGED,
  SEAT_EXIT_TABLE,
  SEATS_UPDATE,
  SEND_MESSAGES,
  SIT_DOWN,
  SITTING_IN,
  SITTING_OUT,
  STAND_UP,
  STRADDLE_UPDATE,
  TABLE_BUY_IN_RES,
  TABLE_UPDATED,
  TOGGLE_STRADDLE,
  STRADDLE_POST,
  STRADDLE_CANCEL,
  GET_TABLE,
  DEPOSIT_RELEASE,
  RIT_ASK_PLAYERS,
  RIT_ASK_WINNER,
  RIT_STATUS,
  RIT_TAKE_ACTION,
  SUSHI_START,
  SQUID_ROUND_START,
  INSURANCE_ASK_WINNER,
  INSURANCE_STATUS,
  INSURANCE_PURCHASED,
  INSURANCE_TAKE_ACTION,
  INSURANCE_CLAIM,
  SEATS_REBUY,
  JOINED_TOURNAMENT,
  JOIN_TOURNAMENT,
  GET_TOURNAMENT,
  TOURNAMENT_DETAILS,
  CANCEL_REBUY,
  TOURNAMENT_CANCELLED,
  TOURNAMENT_END,
  ADDON_WILL_START,
  ADDON_STARTED,
  ADDON_END,
  FTDEAL_UPDATE,
  FTDEAL_ACTION,
  FTDEAL_ASK,
  DO_SWITCH_TABLE,
  BREAK_END,
  BREAK_START,
  CLEAR_TABLE,
  BUBBLE_STARTED,
  ITM_STARTED,
  CHECK_KO_EARN,
  SEND_STICKERS,
  RECEIVE_STICKERS,
  MTT_PLAYERS_REMOVED,
  SWITCH_TABLE,
  RISK_CONTROL,
 
  RISK_CONTROL_ACTION,
  RISK_STATUS,
} from '../socket/events';
// import { useDispatch, useSelector } from 'react-redux';








const Table = forwardRef((props, ref) => {
  
  const { route, tableId, sendRemainTime, currentPageTable, sendFlash,userId,handHistoryId,replay } = props;

  console.log('tableId---', tableId,replay);
  const insTimeoutRef = useRef(null);
  
    const [replayData,setReplayData] =useState({});
    const [originalReplay,setOriginalReplay]=useState(null);
    const getReplayData = async () => {
  try {
    const url = replay;

    const response = await fetch(url);
    console.log("response to replay", response)

    const text = await response.text();

    const jsonData = JSON.parse(text);

     setOriginalReplay(jsonData)

     // first TABLE_UPDATED event
const firstTableUpdated = jsonData.replay.find(
  item => item.type === "TABLE_UPDATED"
);

    console.log("Replay JSON:", jsonData,);
     setNumberOfCards(firstTableUpdated?.table?.noOfHoleCards);
     setNumberOfSeats(firstTableUpdated?.table?.maxPlayers)

    

   const startIndex = jsonData.replay.findIndex(
  item => item.message === "New hand started"
);
const newHandEvent =
  startIndex !== -1 ? jsonData.replay[startIndex] : null;

const replayFromNewHand =
  startIndex !== -1 ? jsonData.replay.slice(startIndex) : [];
const filteredReplay = replayFromNewHand.filter(
  item => item.type !== "PLAYERS_CARDS_UPDATED"
);

const filteredData = {
  ...jsonData,
  replay:
    firstTableUpdated && newHandEvent
      ? [
          {
            ...firstTableUpdated,
            eventTimestamp: newHandEvent.eventTimestamp - 200,
          },
          ...filteredReplay,
        ]
      : filteredReplay,
};

console.log("Filtered JSON:", filteredData);




    setReplayData(filteredData);
  } catch (error) {
    console.log("Error reading replay file:", error);
  }
};
useEffect(()=>{
  getReplayData()
},[replay])

  const tableData = replayData?.replay?.find(
  e => e.message === "New hand started"
)?.table;
  const tourData = {}

  const chatDataGlobal = {}

  const renderCount = useRef(0);
  renderCount.current += 1;

  console.log('Table render count:', renderCount.current);

  const translateYSquidTable = useRef(new Animated.Value(2000)).current; // Start below the screen
  const [squidTableanimationDone, setSquidTableAnimationDone] = useState(false);

  const {
    tables = [],
    clubTables,
    currentClubId,
  } =  {};
  const [showDealer, setShowDealer] = useState(false);
  const [showClaimReturn, setShowClaimReturn] = useState(true);
  const [flash, setFlash] = useState(false);
  const bombPotPlayedRef = useRef(false);
  const koBountyPlayedRef = useRef(false);
  const itmPlayedRef = useRef(false);
  const InsurancePlayedRef = useRef(false);
  const [showKeypad, setShowKeypad] = useState(false);
  const [value, setValue] = useState(0);
  const [tableIndex, setTableIndex] = useState(null);



  const [net, setNet] = useState(null);
  const [serverTimeOffset, setServerTimeOffset] = useState(0);
  const [listenerKey, setListenerKey] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // Start on page 1
  const [checkedPlayer, setCheckedPlayer] = useState(true);

  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [isFetching, setIsFetching] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [latestMsgs, setLatestMsgs] = useState({}); // { userId: msg }
  const [sliderKey, setSliderKey] = useState(0);
  const [sliderINSKey, setSliderINSKey] = useState(0);
  const [squidCountdown, setSquidCountdown] = useState(0);
  const prevSquidWinnerLenRef = useRef(0);
  const [tableReady, setTableReady] = useState(false);

 
//   const stickersSelf = useSelector(state => state.stickers.self);
//   const stickersOpponent = useSelector(state => state.stickers.opponent);
//   const stickersIsFetching = useSelector(state => state.stickers.isFetching);


  // Queue to handle audio sequentially
  const audioQueue = useRef(Promise.resolve());
 

  
  const [calculateDone, setCalculateDone] = useState(false);
  const user = {user:{id:userId}};

  const appState = {};
  const btnClickRef = useRef(false);
  const btnClickRefRabbit = useRef(false);
  const [timerKey, setTimerKey] = useState(0);
  const flipAnimShowDown = useRef(new Animated.Value(0)).current;
  const [showdownReveal, setShowdownReveal] = useState(false);
  const [showSushiDeposit, setShowSushiDeposit] = useState(false);
  const [showSquidWin, setShowSquidWin] = useState(false);
  const [squidWinTxt, setSquidWinTxt] = useState('');
  const [showSquidSettlement, setShowSquidSettlement] = useState(false);
  const [chopCards, setChopCards] = useState([]);
  const [isInsuranceAnimationCompleted, setIsInsuranceAnimationCompleted] =
    useState(false);
  const [isValueChanged, setIsValueChanged] = useState(false);

  //Tournments
  const [timeLeft, setTimeLeft] = useState({});
  const [timeLeftAddon, setTimeLeftAddon] = useState({});
  const [timeLeftBreak, setTimeLeftBreak] = useState({});
  const [finalTime, setFinalTime] = useState(null);
  const timerRef = useRef(null);
  const timerRefAddon = useRef(null);
  const [showMTTRebuy, setShowMTTRebuy] = useState(false);
  const [showAddOn, setShowAddOn] = useState(false);
  const [showBreak, setShowBreak] = useState(false);
  const [showFtModal1, setShowFTModal1] = useState(false);
  const [showFtModal2, setShowFTModal2] = useState(false);
  const prevFTDealExpRef = useRef(null);
  const [showAicon, setShowAIcon] = useState(false);



  //MTT - to start time

//   useEffect(() => {
//     let unsubscribe;

//     // ✅ get global base (from Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!finalTime || !baseNativeTime) return;

//     const finalTarget = Date.parse(finalTime);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 use global synced time (no re-init)
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = finalTarget - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setTimeLeft(prev => {
//           if (prev?.ended) return prev;
//           return { ended: true };
//         });
//         return;
//       }

//       // ❌ no buffer needed anymore
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       const hours = Math.floor(totalSeconds / 3600);
//       const minutes = Math.floor((totalSeconds % 3600) / 60);
//       const seconds = totalSeconds % 60;

//       setTimeLeft(prev => {
//         if (
//           prev?.hours === hours &&
//           prev?.minutes === minutes &&
//           prev?.seconds === seconds
//         )
//           return prev;

//         return { hours, minutes, seconds };
//       });
//     });

//     return () => unsubscribe?.();
//   }, [finalTime]);

  // flip animations for all players and their cards
  const flipAnims = useRef({});

//   const dispatch = useDispatch();

  const handleTablePress = table => {
    const nav = {
      '13-POKER': 'ThirteenPokerGame',
      Bull: 'BullBullTable',
      Lucky: 'Lucky6Game',
      Pusoy: 'PusoyGame',
      Maubinh: 'MaubinhGame',
      OFC: 'OFCGame',
      NLH: 'Table',
    };
   // navigation.navigate(nav[table] || 'Table', { activeTable: table });
  };

  // Initialize flipAnims safely using seat IDs
  const initializeFlipAnims = () => {
    if (!currentTable || !numberOfCards) return;

    const maxCards = numberOfCards;

    // Ensure parent container exists
    if (!flipAnims.current) flipAnims.current = {};

    Object.entries(currentTable.seats ?? {}).forEach(([seatId, seat]) => {
      // Create seat array if seat is newly added
      if (!flipAnims.current[seatId]) {
        flipAnims.current[seatId] = [];
      }

      // Ensure card indexes exist
      for (let i = 0; i < maxCards; i++) {
        if (!flipAnims.current[seatId][i]) {
          flipAnims.current[seatId][i] = new Animated.Value(0);
        }
      }

      // If seat has fewer cards, ensure other stored indexes remain safe
      // (We do NOT delete them, because animation cleanup is expensive)
    });
  };

  const formatNumber = val => {
    const num = Number(val);
    const decimal = num % 1;

    if (decimal === 0) return num;

    // round down if decimal < 0.05
    if (decimal < 0.05) return Math.floor(num);

    return Number(num.toFixed(2));
  };
  const showSquidTable = () => {
    const currentY = translateYSquidTable.__getValue(); // get current value

    if (currentY !== 0) {
      // Start countdown 3 -> 2 -> 1
      if (currentTable?.squidStart) {
        setSquidCountdown(3);

        let count = 3;
        const interval = setInterval(() => {
          count--;
          setSquidCountdown(count);

          if (count === 0) {
            clearInterval(interval);
          }
        }, 1000);
      }

      // only animate if not already at 0
      Animated.timing(translateYSquidTable, {
        toValue: 0,
        duration: 2800,
        useNativeDriver: true,
      }).start(() => {
        setSquidTableAnimationDone(true);
      });
    }
  };

  //  Function 2: Animate top → bottom
  const hideSquidTable = () => {
    const currentY = translateYSquidTable.__getValue(); // get current animated value

    if (currentY !== 2000) {
      // only animate if not already hidden
      Animated.timing(translateYSquidTable, {
        toValue: 2000,
        duration: 2800,
        useNativeDriver: true,
      }).start(() => {
        setSquidTableAnimationDone(true);
      });
    }
  };

  // Reset flip animations for a new hand
  const resetFlipAnims = () => {
    Object.values(flipAnims.current).forEach(playerArray => {
      playerArray.forEach(anim => anim.setValue(0));
    });
    setShowdownReveal(false);
  };

  //console.log('app state table.js ----------', appState);

  //modals
  const [isModalVisible, setIsModalVisible] = useState({
    sidePanel: false,
    chatPanel: false,
    handHistoryPanel: false,
    rtrPanel: false,
    buyin: false,
    raise: false,
    showExitConfirm: false,
    foldConfirm: false,
    chat: false,
    straddleAllInConfirm: false,
  });
  const [ritModalVisible, setRitModalVisible] = useState(false);
   const [riskModalVisible, setRiskModalVisible] = useState(false);
  const [ritMsg, setRitMsg] = useState('');
  const [insMsg, setInsMsg] = useState('');
  const [mttMsg, setMttMsg] = useState('');
  const [riskMsg,setRiskMsg] = useState('')

  //Insurnace
  const [InsuranceModalVisible, setInsuranceModalVisible] = useState(false);
  const [insuranceMsg, setInsuranceMsg] = useState('');
  const [insSelectedPot, setInsSelectedPot] = useState('mainpot');
  const [premium, setPremium] = useState(0);
  const [tempPremium, setTempPremium] = useState(0);
  const [claim, setClaim] = useState(0);
  const [iosValue, setIosValue] = useState(0);

  const [handHistoryDrawerVisible, setHandHistoryDrawerVisible] =
    useState(false);
  const [handHistoryModalVisible, setHandHistoryModalVisible] = useState(false);
  const [selectedHandData, setSelectedHandData] = useState(null);
  const [showRabbitButton, setShowRabbit] = useState(false);
  const [marginRaiseBar, setMarginRaiseBar] = useState(0);
  const [layoutHeight, setLayoutHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [raiseCompVisible, setRaiseCompVisible] = useState({
    keypad: false,
    multiplier: true,
    slider: false,
  });
  const [isPlayBombpot, setIsPlayBombPot] = useState(false);
  const [isPlayKoBounty, setIsPlayKoBounty] = useState(false);
  const [isPlayITM, setIsPlayITM] = useState(false);

  const [isPlayCrackCard, setIsPlayCrackCard] = useState(false);
  const [isPlayInsurace, setIsPlayInsurance] = useState(false);

  const [backupSeats, setBackupSeats] = useState(null);
  const [raiseBarValue, setRaiseBarValue] = useState(0);
  const [communityCardWidth, setCommunityCardWidth] = useState(40);
  const [layout, setLayout] = useState(null);
  //action time to play turn
  const lastPlayedRef = useRef(0); // slide audio playe
  const [actionTime, setActionTime] = useState(0);
  const [blink, setblink] = useState(false);
  const [remainTime, setRemainTime] = useState(0); // in seconds
  const [remainTimeRIT, setRemainTimeRIT] = useState(0); // in seconds RIT
  const [remainTimeRisk, setRemainTimeRisk] = useState(0); // in seconds RIT
  const [remainTimeIns, setRemainTimeIns] = useState(0); // in seconds insurance
  const [remainTimeLevel, setRemainTimeLevel] = useState(0); // in seconds insurance
  const [remainTimeFTDEAL, setRemainTimeFTDEAL] = useState(0); // in seconds insurance
  const intervalRef = useRef(null);
  const intervalRefRIT = useRef(null);
  const intervalRefIns = useRef(null);
  const intervalRefLevel = useRef(null);
  const intervalRefFTDEAL = useRef(null);
  const blinkRef = useRef(null);

  const [numberOfSeats, setNumberOfSeats] = useState(0);
  const [numberOfCards, setNumberOfCards] = useState(0);
  const [seatPositions, setSeatPositions] = useState([]);
  const [originalPostion, setOriginalPositions] = useState([]);
  const [cardAnims, setCardAnims] = useState([]);
  const [receiverId, setReceiverId] = useState('');

  // Sticker profile modal state
  const [isProfileModalVisible, setIsProfileModalVisible] = useState(false);
  const [profileModalData, setProfileModalData] = useState(null);
  const [modalType, setModalType] = useState('own');
  const [profileModalTargetSeatId, setProfileModalTargetSeatId] =
    useState(null);
  const [isBuyStickerModalVisible, setIsBuyStickerModalVisible] =
    useState(false);
  const [selectedStickerToBuy, setSelectedStickerToBuy] = useState(null);
  // Sticker animation state (optimized with ref to minimize re-renders)

 
  const [, forceRender] = useState(0);
  const getAnimatedValue = initialValue => {
    return new Animated.Value(initialValue);
  };

  const releaseAnimatedValue = val => {
    if (val) {
      val.removeAllListeners?.();
      val.stopAnimation?.();
    }
  };

  const updateStickers = () => forceRender(n => n + 1);

  // Debug useEffect for route params - only runs whe\n route params change
  useEffect(() => {
    console.log('Table component - route params:', route?.params);
    console.log('Table component - currentTableId:', route?.params?.tableId);
  }, [route?.params]);

  //gameplay with socket variables
  const [currentTableId, setCurrentTableId] = useState(tableId);
  const seatsTemp = useRef([]);
 // const [currentTable, setCurrentTable] = useState({"id":4941407459,"name":"Bombpot","limit":1000,"maxPlayers":9,"gameType":"TEXAS_HOLDEM","players":[],"seats":{"1":null,"2":null,"3":null,"4":null,"5":null,"6":null,"7":null,"8":null,"9":null},"backupSeatBets":[],"board":[],"board2":[],"board3":[],"winType":"high","deck":{"suits":["s","h","d","c"],"ranks":["A","K","Q","J","T","9","8","7","6","5","4","3","2"],"rng":{"csprng":{},"drbg":{"key":{"type":"Buffer","data":[113,66,28,48,140,181,193,55,103,156,74,104,99,14,87,186,1,77,19,34,230,24,191,74,84,115,143,120,28,53,92,239]},"counter":{"type":"Buffer","data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51]}},"seedId":"6673f564","calls":51,"nextReseed":329},"shuffler":{"rng":{"csprng":{},"drbg":{"key":{"type":"Buffer","data":[113,66,28,48,140,181,193,55,103,156,74,104,99,14,87,186,1,77,19,34,230,24,191,74,84,115,143,120,28,53,92,239]},"counter":{"type":"Buffer","data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51]}},"seedId":"6673f564","calls":51,"nextReseed":329}},"_testRNG":{"csprng":{},"drbg":{"key":{"type":"Buffer","data":[113,66,28,48,140,181,193,55,103,156,74,104,99,14,87,186,1,77,19,34,230,24,191,74,84,115,143,120,28,53,92,239]},"counter":{"type":"Buffer","data":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51]}},"seedId":"6673f564","calls":51,"nextReseed":329},"cards":[{"suit":"c","rank":"7"},{"suit":"s","rank":"4"},{"suit":"c","rank":"J"},{"suit":"d","rank":"9"},{"suit":"h","rank":"K"},{"suit":"c","rank":"Q"},{"suit":"d","rank":"J"},{"suit":"s","rank":"7"},{"suit":"h","rank":"3"},{"suit":"c","rank":"8"},{"suit":"d","rank":"5"},{"suit":"c","rank":"5"},{"suit":"c","rank":"T"},{"suit":"d","rank":"7"},{"suit":"h","rank":"6"},{"suit":"s","rank":"6"},{"suit":"s","rank":"9"},{"suit":"h","rank":"A"},{"suit":"c","rank":"3"},{"suit":"d","rank":"3"},{"suit":"c","rank":"9"},{"suit":"c","rank":"2"},{"suit":"d","rank":"2"},{"suit":"h","rank":"4"},{"suit":"d","rank":"K"},{"suit":"d","rank":"A"},{"suit":"c","rank":"4"},{"suit":"d","rank":"T"},{"suit":"s","rank":"2"},{"suit":"c","rank":"K"},{"suit":"h","rank":"J"},{"suit":"h","rank":"2"},{"suit":"c","rank":"6"},{"suit":"s","rank":"Q"},{"suit":"d","rank":"4"},{"suit":"d","rank":"Q"},{"suit":"s","rank":"K"},{"suit":"c","rank":"A"},{"suit":"s","rank":"A"}]},"lastButton":7,"skipButtonRotaion":false,"button":null,"originalButton":7,"skipCanBBPosition":null,"waitSeatBB":null,"postedSeat":null,"turn":null,"pot":0,"mainPot":0,"tablePot":0,"callAmount":null,"multiBoard":1,"withoutBlinds":false,"isCardRevealed":false,"totalInitialBet":0,"actionTime":20,"SB":7,"BB":1,"handOver":true,"winMessages":[],"winDetails":[],"sushiDetails":[],"squidWinDetails":[],"wentToShowdown":false,"sidePots":[],"squidWinners":[],"history":[],"noOfHoleCards":2,"isAllinFold":false,"prePlayActionTypes":["FOLD","CALL","CHECK","CALLANY"],"rake":0,"winTheBtn":false,"waitList":[],"handCount":1,"isAnonymous":false,"ante":0,"anteType":"","anteCount":0,"remainingTimes":{"1":15,"7":18},"ritRemainingTimes":{},"callTimes":{},"isCallTime":false,"callTime":60000,"isEndWithoutShowDown":false,"endBeforeShowDown":false,"handHistoryId":"4941407459_2026-05-19_05-40-56_1","handHistory":{"tableId":4941407459,"reverseOrder":false,"blindStructure":{},"handActions":[{"dealerPosition":7,"playerId":"","handNo":1,"street":"","action":"HAND_START","timestamp":"2026-05-19T05:40:56.375Z"},{"street":"blinds","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"SB","amount":1,"pot":3,"tablePot":3,"timestamp":"2026-05-19T05:40:56.377Z"},{"street":"blinds","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"BB","amount":2,"pot":3,"tablePot":3,"timestamp":"2026-05-19T05:40:56.377Z"},{"street":"blinds","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"Bomb","amount":4,"pot":5,"tablePot":5,"timestamp":"2026-05-19T05:40:56.389Z"},{"street":"blinds","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"Bomb","amount":4,"pot":8,"tablePot":8,"timestamp":"2026-05-19T05:40:56.390Z"},{"seatId":1,"street":"","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"HOLE_CARDS","cards":[{"suit":"s","rank":"8"},{"suit":"h","rank":"T"}],"timestamp":"2026-05-19T05:40:56.393Z"},{"seatId":7,"street":"","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"HOLE_CARDS","cards":[{"suit":"s","rank":"5"},{"suit":"s","rank":"3"}],"timestamp":"2026-05-19T05:40:56.394Z"},{"street":"flop","action":"CARDS","cards":[{"suit":"h","rank":"Q"},{"suit":"h","rank":"5"},{"suit":"h","rank":"9"}],"timestamp":"2026-05-19T05:40:56.396Z"},{"seatId":1,"street":"","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"HOLE_CARDS","cards":[{"suit":"s","rank":"J"},{"suit":"h","rank":"8"}],"timestamp":"2026-05-19T05:40:56.529Z"},{"seatId":7,"street":"","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"HOLE_CARDS","cards":[{"suit":"d","rank":"8"},{"suit":"h","rank":"7"}],"timestamp":"2026-05-19T05:40:56.529Z"},{"street":"flop","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"check","amount":0,"pot":8,"tablePot":8,"sidePots":[],"timestamp":"2026-05-19T05:41:07.412Z"},{"street":"flop","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"check","amount":0,"pot":8,"tablePot":8,"sidePots":[],"timestamp":"2026-05-19T05:41:09.153Z"},{"street":"turn","action":"CARDS","cards":[{"suit":"d","rank":"6"}],"timestamp":"2026-05-19T05:41:09.159Z"},{"street":"turn","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"check","amount":0,"pot":8,"tablePot":8,"sidePots":[],"timestamp":"2026-05-19T05:41:14.836Z"},{"street":"turn","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"check","amount":0,"pot":8,"tablePot":8,"sidePots":[],"timestamp":"2026-05-19T05:41:17.434Z"},{"street":"river","action":"CARDS","cards":[{"suit":"s","rank":"T"}],"timestamp":"2026-05-19T05:41:17.439Z"},{"street":"river","playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","action":"check","amount":0,"pot":8,"tablePot":8,"sidePots":[],"timestamp":"2026-05-19T05:41:22.470Z"},{"street":"river","playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","action":"check","amount":0,"pot":8,"tablePot":8,"sidePots":[],"timestamp":"2026-05-19T05:41:24.985Z"},{"seatId":1,"playerName":"Ashwini","handRank":"straight","amountWon":8,"holeCards":[{"rank":"J","suit":"s"},{"rank":"8","suit":"h"}],"bestCards":[{"rank":"Q","suit":"h"},{"rank":"J","suit":"s"},{"rank":"10","suit":"s"},{"rank":"9","suit":"h"},{"rank":"8","suit":"h"}],"timestamp":"2026-05-19T05:41:25.003Z"}],"winDetails":[{"pot":"mainpot","potAmount":8,"isSplit":false,"sidePotsAmount":[],"winAmount":8,"finalWinAmt":8,"insuranceDeduction":0,"displayWinAmount":4,"actualDisplayWinAmount":4,"handDesc":"straight queen high","handRank":"STRAIGHT","seatId":1,"winningStack":24,"player":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playingCards":[{"rank":"Q","suit":"h","type":"board"},{"rank":"J","suit":"s","type":"hand"},{"rank":"T","suit":"s","type":"board"},{"rank":"9","suit":"h","type":"board"},{"rank":"8","suit":"h","type":"hand"}],"boardId":1,"message":"Ashwini wins $4.00 with straight queen high"}],"insuranceLosers":[],"rake":0,"streetWisePot":[{"street":"blinds","pot":8},{"street":"flop","pot":8},{"street":"turn","pot":8},{"street":"river","pot":8}],"roles":[],"sushiDetails":[],"handId":1,"isAllinFold":false,"dealerPosition":7,"timestamp":"2026-05-19T05:40:56.375Z","players":[{"playerId":"de17400c-e8ce-4878-b2e9-ad4f9e2dd697","playerName":"Ashwini","seatNumber":1,"startingStack":20,"totalBet":0,"holeCards":[{"suit":"s","rank":"J"},{"suit":"h","rank":"8"}],"isWinner":true,"ante":0,"profilePic":"https://poker-all-data.s3.ap-south-1.amazonaws.com/profileImages/profile3.png","profileFrame":"https://poker-all-data.s3.ap-south-1.amazonaws.com/frames/Ellipse4.png"},{"playerId":"ef684b90-a481-4997-b816-316bf01d12a7","playerName":"mayurikundalwal","seatNumber":7,"startingStack":20,"totalBet":0,"holeCards":[{"suit":"d","rank":"8"},{"suit":"h","rank":"7"}],"isWinner":false,"ante":0,"profilePic":"https://poker-all-data.s3.ap-south-1.amazonaws.com/profileImages/profile3.png","profileFrame":"https://poker-all-data.s3.ap-south-1.amazonaws.com/frames/Ellipse2.png"}],"communityCards":[{"board":1,"flop":[{"suit":"h","rank":"Q"},{"suit":"h","rank":"5"},{"suit":"h","rank":"9"}],"turn":[{"suit":"d","rank":"6"}],"river":[{"suit":"s","rank":"T"}]},{"board":2,"flop":[],"turn":[],"river":[]},{"board":3,"flop":[],"turn":[],"river":[]}],"rtlRuns":1,"roundsOrder":["preflop","flop","turn","river"],"currentRoundIndex":3,"gameType":"TEXAS_HOLDEM"},"replayHistory":{"tableId":4941407459,"replay":[]},"isStraddle":false,"straddleAmount":0,"straddleType":"BUTTON","straddleDuration":8000,"straddleRunning":false,"straddleAmountToPost":0,"straddledBy":[],"stopStraddleIncrease":false,"isReStr":false,"isAllinCapped":false,"isAllinCappedAmount":500,"realTimeResultsData":{"gameType":"TEXAS_HOLDEM","blinds":"1/2","maxPlayers":9,"callTime":0,"details":[{"playerName":"Ashwini","buyin":20,"stack":24,"winnings":"+4"},{"playerName":"mayurikundalwal","buyin":20,"stack":16,"winnings":"-4"}],"observers":[],"waitlist":[]},"isBombPot":true,"bombPotMinAnte":2,"bombPotMaxAnte":5,"bombPotType":"HANDS","bombPotMinFrequency":1,"bombPotMaxFrequency":0,"isBombPotPerform":false,"bombValue":4,"bombNextTime":0,"bombNextPlayed":false,"isSushi":false,"initAnte":0,"SBAnte":0,"sushi_SB_Dealer":false,"lstSushiWinSeatId":null,"sushiPot":0,"isSevenDeuce":false,"isSevenDueceWinnerBB":0,"club":null,"badBeatjackpot":null,"AoFjackpot":null,"squidDeposit":0,"squidValue":0,"squidType":"CLASSIC","squid":null,"squidCount":4,"squidCurrentCount":0,"isSquid":false,"squidRunning":false,"squidHandCount":1,"squidStart":false,"APP_JP_INST":null,"isBadBeatJackpot":false,"isAofJackpot":false,"activePlayersCount":0,"currentGameRound":"SHOWDOWN","isInsurance":false,"startInsurance":false,"insAskDetails":[],"insurancePotWiseWin":[],"potContest":[],"insuranceRoundWiseAction":[],"insMsg":"","formatChoice":"RANDOM","formatFrequency":1,"smallBlind":1,"bigBlind":2,"minBet":2,"minRaise":0,"lastRaise":0,"prevRaise":0,"prevStep":2,"isFirstRaise":true,"isRit":false,"ritType":"PLAYERSCHOICE","ritPlayersChoice":"","isRitExecuted":false,"isRitDecesionPending":false,"ritWaitForWinner":false,"ritWaitForPlayers":false,"ritWinnerSeat":null,"isRitAlreadyAsked":false,"ritAskDetails":{},"riskStatus":null,"riskInsuranceAsked":false,"prevBoard":[{"suit":"h","rank":"Q"},{"suit":"h","rank":"5"},{"suit":"h","rank":"9"},{"suit":"d","rank":"6"},{"suit":"s","rank":"T"}],"prevBoard2":[],"prevBoard3":[],"realTimeResultsType":"ALL","minBuyIn":20,"maxBuyIn":6000,"isSNG":false,"sngBuyIn":0,"sngFee":0,"sngStartingChips":0,"snglevelsMin":2,"sngBlindStructure":"STANDARD","prizeDisrtibution":"DEFAULT","appliedForBBPost":[],"appliedForBBPostBackup":[],"depositSidePot":[],"topupRequests":[],"handStarting":false,"isRoundChanging":false,"seatsToActLength":2,"actionBy":7,"turnExp":1779169302477,"straddleTurnExp":null,"ritExp":null,"ritMsg":null,"insExp":null,"depositRelease":false,"potContribution":[],"isAnyActionComplete":false,"sidePotAdded":false,"isPrePlayHappened":false,"isSushiDeposit":false,"handOverEmit":false,"rebuyAsked":false,"dealerEmptyKeep":false,"tempBoard":[],"isInsuranceAsked":false,"potWiseInsurance":[],"insuranceLosers":[],"pendingStackInsuranceToReturn":[],"tournamentId":null,"onBubbblePlayers":[],"prevSidePotLength":null,"currentSidePotLength":null,"riskExp":null,"riskMsg":null,"isStraddlePerfomed":false,"lastWinAmount":0});
  const [currentTable,setCurrentTable]=useState(null)
  const [currentTour, setCurrentTour] = useState(null);
  const [currentTableReplica, setCurrentTableReplica] = useState(null);
  const [winIndex, setWinIndex] = useState(null);
  const [isMultiBoard, setIsMultiBoard] = useState(false);
  const [handDesc, setHandDesc] = useState(false);
  const [winMsg, setWinMsg] = useState(false);
  const [currentWindetails, setCurrentWinDetails] = useState(null);
  const [currentWinObj, setCurrentWinObj] = useState(null);
  const [totalWinObj, setTotalWinObj] = useState(null);
  const [lastScoketEvent, setLastSocketEvent] = useState('');
  const [lastEventTimeStamp, setLastEventTimeStamp] = useState('');
  const [lastEventMTTTimeStamp, setLastEventMTTTimeStamp] = useState('');
  const [currentMessage, setCurrentMessage] = useState('');
  const [myPlayer, setMyplayer] = useState(null);
  const [myPlayerKoEarn, setMyplayerKoEarn] = useState(false);
  const [showBB, setShowBB] = useState(false);
  const [isDistributed, setIsDistributed] = useState(false);
  const [startWinning, setStartWinning] = useState(false);
  const [currentSelectedSeatBuyIn, setCurrentSelectedSeatBuyIn] =
    useState(null);

  //buy-in and rebuy
  const buyInTimerRef = useRef(null);
  const [countdown, setCountdown] = useState(null); // null means no timer

  const currentTableRef = useRef(null);
  const backSeatsRef = useRef(null);
  const [currentSelectedPreplay, setCurrentSelectedPrePlay] = useState('');
  const seatPositionsRef = useRef([]);
  const seatRanksRef = useRef({});
  const [gettable, setGetTable] = useState('');
  //
  const [msg, setMsg] = useState('');
  const [alertVisible, setAlertVisible] = useState(false);
  const [showPotInfo, setShowPotInfo] = useState(true);

  const [fadeAnim] = useState(new Animated.Value(0.3));

  // animated values
  const board1Conainter = useRef(new Animated.Value(0)).current; // initial Y for red
  const board2Conainter = useRef(new Animated.Value(55)).current; // initial Y for blue (100 + 50 + 20)
  const board3Conainter = useRef(new Animated.Value(110)).current;

  const flipAnimations = useRef([]); // Don't use `.current` directly in init
  const slideAnimations = useRef([]);

  const flipAnimations2 = useRef([]); // Don't use `.current` directly in init
  const slideAnimations2 = useRef([]);

  const flipAnimations3 = useRef([]); // Don't use `.current` directly in init
  const slideAnimations3 = useRef([]);

  const [animatedChips, setAnimatedChips] = useState([]);
  const [animatedChips2, setAnimatedChips2] = useState([]);

  const winPointAnimations = useRef([]);
  const winPointSlideAnimations = useRef([]);
  const winPointOpacitis = useRef([]);
  const translateY = useRef(new Animated.Value(-30)).current;
  const opacityBouunce = useRef(new Animated.Value(0)).current;

  const translateYL = useRef(new Animated.Value(-30)).current;
  const opacityBouunceL = useRef(new Animated.Value(0)).current;

  const lastAnimatedCard = useRef(0);
  const lastAnimatedCardB2 = useRef(0);
  const lastAnimatedCardB3 = useRef(0);

  const translateYWinPoint = useRef(new Animated.Value(-50)).current;
  const opacities = useRef([]);
  const opacities2 = useRef([]);
  const opacities3 = useRef([]);
  const [triggerAnimation, setTriggerAnimation] = useState(false);

  const [title, setTitle] = useState('');

  const [sushiWinner, setSushiWinner] = useState([]);

  const animationCompleted = useRef(true); // Declare at top of component

  const seats = useRef([]);
  const dotsForStadium = [];

  const depositHandled = useRef(false);

  //chat ui variable
  const { width: SCREEN_W } = Dimensions.get('window');
  const [bubbleHeights, setBubbleHeights] = useState({});
  const [messageWidths, setMessageWidths] = useState({});

  const [pendingSticker, setPendingSticker] = useState(null);


  const [currentAction, setCurrentAction] = useState(null);




const MAX_DELAY = 5000;
const FIRST_EVENT_DELAY =0;

useEffect(() => {
  if (!replayData?.replay?.length) return;

  if (currentAction === null) {
    setCurrentAction(0);
    return;
  }

  const replay = replayData.replay;

  if (currentAction >= replay.length - 1) return;

  const currentEvent = replay[currentAction];
  const nextEvent = replay[currentAction + 1];

  let replayDelay;

  if (currentAction === 0) {
    // Give first event time to render table/cards
    replayDelay = FIRST_EVENT_DELAY;
  } else {
    const originalDelay =
      nextEvent?.eventTimestamp && currentEvent?.eventTimestamp
        ? nextEvent.eventTimestamp - currentEvent.eventTimestamp
        : 1000;

    replayDelay = Math.min(
      originalDelay / REPLAY_SPEED,
      MAX_DELAY,
    );
  }

  const timer = setTimeout(() => {
    setCurrentAction(prev => prev + 1);
  }, replayDelay);

  return () => clearTimeout(timer);
}, [replayData, currentAction]);

useEffect(() => {
  if (!replayData?.replay?.length) return;

  replayData.replay.forEach((event, index) => {
    const nextEvent = replayData.replay[index + 1];

    if (!nextEvent) return;

    const diffMs = nextEvent.eventTimestamp - event.eventTimestamp;
    const diffSec = diffMs / 1000;

    console.log(
      `Event ${index} -> ${index + 1}`,
      event.type,
      "to",
      nextEvent.type,
      "diff:",
      diffMs,
      "ms",
      diffSec,
      "sec"
    );
  });
}, [replayData]);

  const getPositionAtAngle = (id, angle, layout) => {
    const centerX = (layout.width - 5) / 2;
    const centerY = (layout.height - 80) / 2;
    const r = (layout.width - 5) * 0.4;
    const straightHeight = (layout.height - 80) * 0.32;

    let x = centerX;
    let y = centerY;

    angle = angle % 360;

    if (angle >= 0 && angle < 90) {
      const progress = angle / 90;
      x = centerX - r;
      y = centerY + straightHeight / 2 - progress * straightHeight;
    } else if (angle >= 90 && angle < 180) {
      const theta = ((angle - 90) * Math.PI) / 90;
      x = centerX - r * Math.cos(theta);
      y = centerY - straightHeight / 2 - r * Math.sin(theta);
    } else if (angle >= 180 && angle < 270) {
      const progress = (angle - 180) / 90;
      x = centerX + r;
      y = centerY - straightHeight / 2 + progress * straightHeight;
    } else {
      const theta = ((angle - 270) * Math.PI) / 90;
      x = centerX + r * Math.cos(theta);
      y = centerY + straightHeight / 2 + r * Math.sin(theta);
    }

    return { id, x, y, angle };
  };

  // useEffect(() => {
  //   if (Platform.OS !== 'ios') return;
  //   if (!InsuranceModalVisible) return;
  //   if (Platform.OS === 'ios' && InsuranceModalVisible) {
  //     let active = true;

  //     const timeout = setTimeout(() => {
  //       if (!active) return;

  //       // reset only once per remount
  //       setIosValue(tempPremium);
  //       //setPremium(tempPremium);
  //     }, 120); // allow native slider to mount

  //     return () => {
  //       active = false;
  //       clearTimeout(timeout);
  //     };
  //   }
  // }, [tempPremium, InsuranceModalVisible]); // ✅ ONLY depends on sliderKey

  // calculation of bazier curve
  useEffect(() => {
    console.log(
      'incalcaultion------',
      'myplayer-------',
      myPlayer,
      'layout----',
      layout,
    );
    console.log('layout-------------------', layout, numberOfSeats);

    if (!layout || numberOfSeats == 0) return;

    setCalculateDone(false);
    console.log('reset seat postion from useEffect----',numberOfSeats,layout.width,layout.height,Dimensions.get("screen"),Dimensions.get("window"));

    const seatMap = seatMapWithAnlge[numberOfSeats];

    const centerX = (390 ) / 2;
    const centerY = (844) / 2;
    const r = (390 ) * 0.4;
    const straightHeight = (844 ) * 0.32;

    const generateDots = () => {
      for (let i = 0; i <= 30; i++) {
        const progress = i / 30;
        const angle = 90 * progress;
        const x = centerX - r;
        const y = centerY + straightHeight / 2 - progress * straightHeight;
        dotsForStadium.push({ x, y, angle });
      }

      for (let i = 0; i <= 72; i++) {
        const angle = 90 + (i * 90) / 72;
        const theta = ((angle - 90) * Math.PI) / 90;
        const x = centerX - r * Math.cos(theta);
        const y = centerY - straightHeight / 2 - r * Math.sin(theta);
        dotsForStadium.push({ x, y, angle });
      }

      for (let i = 0; i <= 30; i++) {
        const progress = i / 30;
        const angle = 180 + progress * 90;
        const x = centerX + r;
        const y = centerY - straightHeight / 2 + progress * straightHeight;
        dotsForStadium.push({ x, y, angle });
      }

      for (let i = 0; i <= 72; i++) {
        const angle = 270 + (i * 90) / 72;
        const theta = ((angle - 270) * Math.PI) / 90;
        const x = centerX + r * Math.cos(theta);
        const y = centerY + straightHeight / 2 + r * Math.sin(theta);
        dotsForStadium.push({ x, y, angle });
      }
    };

    generateDots();
    // console.log(
    //   'numberofseats call--------',
    //   numberOfSeats,
    //   rawPositions[numberOfSeats],
    // );
    const initialSeats = rawPositions[numberOfSeats]
      .map((p, i) => {
        const currentIndex = i + 1;
        const targetAngle = seatMap[currentIndex];
        const match = dotsForStadium.find(
          e => Math.round(e.angle) === targetAngle,
        );

        if (!match) return null;

        const angleValue = new Animated.Value(targetAngle);
        const animatedXY = new Animated.ValueXY({ x: match.x, y: match.y });

        angleValue.addListener(({ value }) => {
          const { x, y } = getPositionAtAngle(p.id, value, layout);
          animatedXY.setValue({ x, y });
        });

        return {
          id: p.id,
          x: match.x,
          y: match.y,
          angle: targetAngle,
          animatedValue: angleValue,
          animatedXY,
          currentIndex: i,
        };
      })
      .filter(Boolean);
    console.log('seat postions from inital useeffect');
    setSeatPositions(initialSeats);
    console.log('intails seat s-----', initialSeats);
    seats.current = initialSeats;
    setOriginalPositions(initialSeats);
    setCalculateDone(true);

    return () => {
      initialSeats.forEach(seat => seat.animatedValue.removeAllListeners());
    };
  }, [layout, numberOfSeats]);

  //Add -on timer
//   useEffect(() => {
//     let unsubscribe;

//     if (!currentTour?.addOnExp) return;

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTour.addOnExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setShowAddOn(prev => (prev ? false : prev));
//         return;
//       }

//       // ❌ remove buffer & ceil
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       const hours = Math.floor(totalSeconds / 3600);
//       const minutes = Math.floor((totalSeconds % 3600) / 60);
//       const seconds = totalSeconds % 60;

//       setTimeLeftAddon(prev => {
//         if (
//           prev?.totalSeconds === totalSeconds &&
//           prev?.hours === hours &&
//           prev?.minutes === minutes &&
//           prev?.seconds === seconds
//         )
//           return prev;

//         return { totalSeconds, hours, minutes, seconds };
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTour?.addOnExp]);
//   //Break - timer
//   useEffect(() => {
//     let unsubscribe;

//     if (!currentTour?.breakExp) return;

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTour.breakExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setShowBreak(prev => (prev ? false : prev));
//         return;
//       }

//       // ❌ remove buffer & ceil
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       const hours = Math.floor(totalSeconds / 3600);
//       const minutes = Math.floor((totalSeconds % 3600) / 60);
//       const seconds = totalSeconds % 60;

//       setTimeLeftBreak(prev => {
//         if (
//           prev?.totalSeconds === totalSeconds &&
//           prev?.hours === hours &&
//           prev?.minutes === minutes &&
//           prev?.seconds === seconds
//         )
//           return prev;

//         return { totalSeconds, hours, minutes, seconds };
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTour?.breakExp]);

  // commuity cards changes
  useEffect(() => {
    const runAnimations = async () => {
      if (
        !currentTable?.board ||
        currentTable?.board?.length === 0 
        //||
        // (currentTable?.isEndWithoutShowDown &&
        //   lastScoketEvent != GET_RABBIT_CARDS)
      )
        return;

      let board = currentTable?.board;
      let board2 = currentTable?.board2;
      let board3 = currentTable?.board3;

      ['board', 'board2', 'board3'].forEach(key => {
        currentTable[key] = (currentTable?.[key] || []).filter(
          (card, i, arr) =>
            arr.findIndex(c => c.suit === card.suit && c.rank === card.rank) ===
            i,
        );
      });

      const currentLength = flipAnimations.current.length;
      const newCardsCount = board.length - currentLength;

      const currentLength2 = flipAnimations2.current.length;
      const newCardsCount2 = board2.length - currentLength2;

      const currentLength3 = flipAnimations3.current.length;
      const newCardsCount3 = board3.length - currentLength3;

      // === Setup animation refs ===
      const setupAnims = (count, flipRef, slideRef, opacityRef) => {
        if (count > 0) {
          const newFlip = Array(count)
            .fill()
            .map(() => new Animated.Value(0));
          const newSlide = Array(count)
            .fill()
            .map(() => new Animated.Value(0));
          const newOpacity = Array(count)
            .fill()
            .map(() => new Animated.Value(0));
          flipRef.current.push(...newFlip);
          slideRef.current.push(...newSlide);
          opacityRef.current.push(...newOpacity);
        }
      };

      setupAnims(newCardsCount, flipAnimations, slideAnimations, opacities);
      setupAnims(newCardsCount2, flipAnimations2, slideAnimations2, opacities2);
      setupAnims(newCardsCount3, flipAnimations3, slideAnimations3, opacities3);

      if (newCardsCount > 0 || newCardsCount2 > 0 || newCardsCount3 > 0) {
        console.log('call to trigger animations-------', board3.length);

        if (currentTable?.isRit && currentWindetails && board2.length > 0) {
          await swapBoardRit(
            currentWindetails,
            board3.length > 0 ? 3 : board2.length > 0 ? 2 : 1,
          );
          await new Promise(res => setTimeout(res, 200));
        }

        setTriggerAnimation(true);
      }
    };

    runAnimations(); //  safely call async logic here
  }, [currentTable?.board, currentTable?.board2, currentTable?.board3]);

  useEffect(() => {
    if (triggerAnimation) {
      console.log('call to open coummunity cards -------');
      if (!currentTable?.isRit) {
        if (Platform.OS == 'android' || Platform.OS=="web") {
          openCommunityCards();
        } else {
          openCommunityCardsIos();
        }
      } else {
   if (Platform.OS == 'android' || Platform.OS=="web") {
          openCommunityCardsRit();
        } else {
        }
      }

      setTriggerAnimation(false); // Reset
    }
  }, [triggerAnimation]);

  // Buy-in timer
//   useEffect(() => {
//     if (!isModalVisible.buyin && !showMTTRebuy) {
//       setCountdown(null);
//       return;
//     }

//     let startTime = 0;
//     let baseNativeTime = 0;

//     const duration = 60 * 1000; // 60 sec

//     const unsubscribe = subscribeNativeTimer(nativeTime => {
//       // ✅ first sync
//       if (!baseNativeTime) {
//         baseNativeTime = nativeTime;
//         startTime = Date.now();
//         return;
//       }

//       // ✅ elapsed time
//       const elapsed = nativeTime - baseNativeTime;

//       const remainingMs = duration - elapsed;

//       if (remainingMs <= 0) {
//         setShowMTTRebuy(false);
//         setIsModalVisible(prev => ({ ...prev, buyin: false }));
//         setCountdown(null);
//         return;
//       }

//       const seconds = Math.ceil(remainingMs / 1000);

//       // ✅ prevent re-render spam
//       setCountdown(prev => (prev === seconds ? prev : seconds));
//     });

//     return () => {
//       if (unsubscribe) unsubscribe();

//       baseNativeTime = 0;
//       startTime = 0;
//     };
//   }, [isModalVisible.buyin, showMTTRebuy]);

  const resetGame = () => {
    console.log('setting curren win idex----');
    setShowAIcon(false);
    setShowRabbit(false);
    setCurrentWinObj(null);
    setTotalWinObj(null);
    setWinIndex(null);
    setCurrentWinDetails(null);
    setHandDesc(false);
    setWinMsg(false);
  };

  const onResetSeats = async () => {
    if (!layout) return;
    console.log('Reset seats to original positions with id === 1 at index 0');

    const totalSeats = seatPositions.length;

    // Find the index of the seat with id === 1
    const indexOfSeatWithId1 = seatPositions.findIndex(s => s.id === 1);
    if (indexOfSeatWithId1 === -1) {
      console.warn('No seat found with id === 1');
      return;
    }

    // Rotate the array to make seat with id 1 the first element
    const newSeatOrder = [
      ...seatPositions.slice(indexOfSeatWithId1),
      ...seatPositions.slice(0, indexOfSeatWithId1),
    ];

    // Animate to original positions
    newSeatOrder.forEach((seat, i) => {
      const targetAngle = Number(originalPostion[i].angle);
      const currentAngle = seat.animatedValue.__getValue() % 360;
      const clockwiseTarget =
        ((targetAngle - currentAngle + 360) % 360) + currentAngle;

      Animated.timing(seat.animatedValue, {
        toValue: clockwiseTarget,
        duration: 0,
        useNativeDriver: false,
      }).start(() => {
        const finalAngle = clockwiseTarget % 360;
        const newPos = getPositionAtAngle(seat.id, finalAngle, layout);

        seat.animatedValue.setValue(finalAngle);
        console.log('seat postions from reset seats');
        setSeatPositions(prev =>
          prev.map(s =>
            s.id === seat.id
              ? {
                  ...s,
                  x: newPos.x,
                  y: newPos.y,
                  angle: finalAngle,
                  currentIndex: i,
                }
              : s,
          ),
        );
      });
    });

    console.log('End of reset angles function');
  };

  const handleSeatPress = async clickedIndex => {
    if (!layout) return;
    console.log('handle press', seatPositions[clickedIndex], clickedIndex);

    //already bottom center no need to rotate
    if (seatPositions[clickedIndex].angle == 315) {
      console.log('already angle 315 return ----');
      return;
    }

    const totalSeats = seatPositions.length;
    const newSeatOrder = [];

    for (let i = 0; i < totalSeats; i++) {
      const fromIndex = (clickedIndex + i) % totalSeats;
      newSeatOrder.push(seatPositions[fromIndex]);
    }

    newSeatOrder.forEach((seat, i) => {
      const targetAngle = Number(originalPostion[i].angle);
      const currentAngle = seat.animatedValue.__getValue() % 360;
      const clockwiseTarget =
        ((targetAngle - currentAngle + 360) % 360) + currentAngle;

      Animated.timing(seat.animatedValue, {
        toValue: clockwiseTarget,
        duration: currentSelectedSeatBuyIn ? 400 : 0,
        useNativeDriver: false,
      }).start(() => {
        const finalAngle = clockwiseTarget % 360;
        const newPos = getPositionAtAngle(seat.id, finalAngle, layout);

        seat.animatedValue.setValue(finalAngle);
        console.log('seat postions from seat press');
        setSeatPositions(prev =>
          prev.map(s =>
            s.id === seat.id
              ? {
                  ...s,
                  x: newPos.x,
                  y: newPos.y,
                  angle: finalAngle,
                  currentIndex: i,
                }
              : s,
          ),
        );
      });
    });
  };

  // Debounce ref to prevent multiple rapid sticker sends (also guards against re-opening modal on pass-through touches)
  const stickerSendingRef = useRef(false);

  // Open PlayerProfileModal when a seat is tapped
  const openProfileModal = (seat, seatIndex) => {
    if (
      !seat ||
      !seat.player ||
      stickerSendingRef.current ||
      isProfileModalVisible
    )
      return;
    const isOwn = myPlayer && seat.id === myPlayer.id;
    console.log('myplayer data', myPlayer);
    console.log('seat data', seat);

    setModalType(isOwn ? 'own' : 'opponent');
    setProfileModalTargetSeatId(seat.id);
    setProfileModalData({
      name:
        seat.player?.displayName?.username ??
        seat.player?.displayName ??
        'Player',
      id: seat.player?.id,
      pokerId: seat.player?.pokerId,
      avatar: seat.player?.profilePic ?? seat.player?.avatar ?? null,
      disconnectProtection: seat.disconnectProtection ?? 0,
      timeBank: seat.timeBank ?? 0,
    });
    setIsProfileModalVisible(true);
  };






 

  // const debugDots = [];

  // //Only for reference to see stadium shape dots
  // if (layout) {
  //   const centerX = (layout.width - 5) / 2;
  //   const centerY = (layout.height - 80) / 2;
  //   const r = (layout.width - 5) * 0.4;
  //   const straightHeight = (layout.height - 80) * 0.32;

  //   const createDot = (x, y, angle, key, color) => {
  //     debugDots.push(
  //       <View
  //         key={`dot-${key}`}
  //         style={{
  //           position: 'absolute',
  //           top: y - 3,
  //           left: x - 3,
  //           zIndex: 1000,
  //         }}
  //       >
  //         <View
  //           style={{
  //             width: 6,
  //             height: 6,
  //             borderRadius: 3,
  //             backgroundColor: color,
  //           }}
  //         />
  //         <Text
  //           style={{
  //             position: 'absolute',
  //             top: 6,
  //             left: 6,
  //             fontSize: 5,
  //             color: 'white',
  //           }}
  //         >
  //           {Math.round(angle)}
  //         </Text>
  //       </View>,
  //     );
  //   };

  //   // 1️⃣ Left vertical line (bottom ➡ top) — RED
  //   for (let i = 0; i <= 30; i++) {
  //     const progress = i / 30;
  //     const angle = 90 * progress; // 0° to 90°
  //     const x = centerX - r;
  //     const y = centerY + straightHeight / 2 - progress * straightHeight;
  //     createDot(x, y, angle, `lv-${i}`, 'red');
  //   }

  //   // 2️⃣ Top semicircle (left ➡ right) — ORANGE
  //   for (let i = 0; i <= 72; i++) {
  //     const angle = 90 + (i * 90) / 72; // 90° to 180°
  //     const theta = ((angle - 90) * Math.PI) / 90;
  //     const x = centerX - r * Math.cos(theta);
  //     const y = centerY - straightHeight / 2 - r * Math.sin(theta);
  //     createDot(x, y, angle, `top-${i}`, 'orange');
  //   }

  //   // 3️⃣ Right vertical line (top ➡ bottom) — GREEN
  //   for (let i = 0; i <= 30; i++) {
  //     const progress = i / 30;
  //     const angle = 180 + progress * 90; // 180° to 270°
  //     const x = centerX + r;
  //     const y = centerY - straightHeight / 2 + progress * straightHeight;
  //     createDot(x, y, angle, `rv-${i}`, 'green');
  //   }

  //   // 4️⃣ Bottom semicircle (right ➡ left) — BLUE
  //   for (let i = 0; i <= 72; i++) {
  //     const angle = 270 + (i * 90) / 72; // 270° to 360°
  //     const theta = ((angle - 270) * Math.PI) / 90;
  //     const x = centerX + r * Math.cos(theta);
  //     const y = centerY + straightHeight / 2 + r * Math.sin(theta);
  //     createDot(x, y, angle, `bottom-${i}`, 'blue');
  //   }
  // }

  const playAudio = type => {
    // try {
    //   console.log('Audio:CALL', type);
    //   if (appState.appState === 'background') return;
    //   const audioMap = {
    //     checkAction: require('../../assets/inGameAssets/audio/checkAction.wav'),
    //     betSliderMove: require('../../assets/inGameAssets/audio/betSliderMove.wav'),
    //     cardUnhide: require('../../assets/inGameAssets/audio/cardUnhide.wav'),
    //     winChipsReceive: require('../../assets/inGameAssets/audio/winChipsReceive.wav'),
    //     cardReveal: require('../../assets/inGameAssets/audio/cardReveal.wav'),
    //     coinsTransfer: require('../../assets/inGameAssets/audio/coinsTransfer.wav'),
    //     bet: require('../../assets/inGameAssets/audio/bet.wav'),
    //     turnReceive: require('../../assets/inGameAssets/audio/turnReceive.wav'),
    //     foldAction: require('../../assets/inGameAssets/audio/foldAction.wav'),
    //     blast: require('../../assets/inGameAssets/audio/blast.wav'),
    //     straddle: require('../../assets/inGameAssets/audio/straddle.wav'),
    //   };
    //   const trackFile = audioMap[type];
    //   if (!trackFile) return;
    //   // Just reset, add, and play — no promises, no return
    //   TrackPlayer.reset()
    //     .then(() =>
    //       TrackPlayer.add({
    //         id: `trackId${Date.now()}`,
    //         url: trackFile,
    //       }),
    //     )
    //     .then(() => TrackPlayer.play())
    //     .catch(e => console.log('Audio:Error', e));
    // } catch (e) {
    //   console.log('Audio:Error', e);
    // }
  };

  const distributeCards = () => {
    try {
      if (currentTable?.endBeforeShowDown) return;
      if (!currentTable) return;
      const { width, height } = Dimensions.get('window');
      const CARD_WIDTH = 20;
      const CARD_HEIGHT = 30;
      const animations = [];
      let completedCount = 0;

      //number of active players who will receive cards
      const activeSeats = Object.entries(currentTable?.seats || {})
        .filter(([_, seatData]) => seatData?.hand?.length > 0)
        .map(([_, seatData]) => seatData);

      let onlySeatIds = activeSeats.map(e => e?.id - 1);

      const totalCards = activeSeats.length * numberOfCards;

      let filteredSeatPostions = seatPositions.filter((item, index) =>
        onlySeatIds.includes(index),
      );
      console.log('onlyFiltered seatIDs----', onlySeatIds);

      // Step 1: create anims
      for (let cardIndex = 0; cardIndex < numberOfCards; cardIndex++) {
        for (
          let seatIndex = 0;
          seatIndex < filteredSeatPostions.length;
          seatIndex++
        ) {
          const seat = filteredSeatPostions[seatIndex];
          const offsetX = cardIndex * (CARD_WIDTH - 15);

          const animatedXY = new Animated.ValueXY({
            x: width / 2 - CARD_WIDTH / 2,
            y: (height - 100) / 2 - CARD_HEIGHT / 2,
          });

          const animObj = { animatedXY, visible: true };
          animations.push(animObj);

          Animated.timing(animatedXY, {
            toValue: {
              x: seat.x + offsetX,
              y: seat.y,
            },
            duration: 100,
            delay:
              cardIndex * filteredSeatPostions.length * 50 + seatIndex * 50,
            useNativeDriver: true,
          }).start(() => {
            completedCount++;
            if (completedCount === totalCards) {
              // Hide cards when all animations are done
              setCardAnims(prev =>
                prev.map(card => ({
                  ...card,
                  visible: false,
                })),
              );
              setTimeout(() => {
                setIsDistributed(true);
              }, 100);
            }
          });
        }
      }

      setCardAnims(animations);
    } catch (e) {
      console.log('error while card distribution-------------', e);
    }
  };

  //Community cards

  const getCardImage = card => {
    if (!card) return null;
    const key = `${card?.suit}-${card?.rank}`;

    return cardImages[key];
  };

  const CARD_WIDTH = 40;
  const CARD_SPACING = 0;

  const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

 const openCommunityCards = async () => {
    try {
      console.log('open communut cards ------');

      const board = currentTable?.board;
      const board2 = currentTable?.board2;
      const board3 = currentTable?.board3;
      console.log('board--------', currentTable?.board);

      const TOTAL_CARDS = 5;
      const CARD_SPACING = 0;
      const screenWidth = layout.width;
      const layoutWidth = screenWidth * 0.6;

      const CARD_WIDTH =
        (layoutWidth - (TOTAL_CARDS - 1) * CARD_SPACING) / TOTAL_CARDS;
      setCommunityCardWidth(CARD_WIDTH);
      const spacing = 43;

      const FLIP_DURATION = 250;
      const SLIDE_DURATION = 150;
      const OPACITY_DURATION = 50;
      //board 1 card 1
      if (board.length >= 1 && lastAnimatedCard.current < 1) {
        console.log('animation 1');

        slideAnimations.current[0].setValue(0 * 43);
        if (board2.length > 0) slideAnimations2.current[0].setValue(0 * 43);
        if (board3.length > 0) slideAnimations3.current[0].setValue(0 * 43);

        await delay(0); // Delay before first flip

        await new Promise(resolve => {
          const animations = [
            Animated.timing(opacities.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ];

          if (board2.length > 0) {
            animations.push(
              Animated.timing(opacities2.current[0], {
                toValue: 1,
                duration: OPACITY_DURATION,
                useNativeDriver: true,
              }),
              Animated.timing(flipAnimations2.current[0], {
                toValue: 180,
                duration: FLIP_DURATION,
                easing: Easing.linear,
                useNativeDriver: true,
              }),
            );
          }

          if (board3.length > 0) {
            animations.push(
              Animated.timing(opacities3.current[0], {
                toValue: 1,
                duration: OPACITY_DURATION,
                useNativeDriver: true,
              }),
              Animated.timing(flipAnimations3.current[0], {
                toValue: 180,
                duration: FLIP_DURATION,
                easing: Easing.linear,
                useNativeDriver: true,
              }),
            );
          }

          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCard.current = 1;
        if (board2.length > 0) lastAnimatedCardB2.current = 1;
        if (board3.length > 0) lastAnimatedCardB3.current = 1;
      }

      // Cards 2 & 3 = board 1
      if (board.length >= 3 && lastAnimatedCard.current < 3) {
        console.log('animation 2 and 3');
        await delay(0); // Delay before flop (2nd & 3rd card)

        flipAnimations.current[1].setValue(180);
        flipAnimations.current[2].setValue(180);

        if (board2.length > 0) {
          flipAnimations2.current[1].setValue(180);
          flipAnimations2.current[2].setValue(180);
        }
        if (board3.length > 0) {
          flipAnimations3.current[1].setValue(180);
          flipAnimations3.current[2].setValue(180);
        }

        // Build animation arrays for all boards
        const animations = [
          // board1
          Animated.timing(opacities.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[1], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations2.current[1], {
              toValue: 1 * spacing,
              duration: SLIDE_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
            Animated.timing(opacities2.current[2], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations2.current[2], {
              toValue: 2 * spacing,
              duration: SLIDE_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }

        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[1], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations3.current[1], {
              toValue: 1 * spacing,
              duration: SLIDE_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
            Animated.timing(opacities3.current[2], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations3.current[2], {
              toValue: 2 * spacing,
              duration: SLIDE_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }

        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCard.current = 3;

        if (board2.length > 0) lastAnimatedCardB2.current = 3;
        if (board3.length > 0) lastAnimatedCardB3.current = 3;
      }

      // Card 4 - board 1
      if (board.length >= 4 && lastAnimatedCard.current < 4) {
        console.log('animation 4');
        await delay(0); // Delay before turn

        slideAnimations.current[3].setValue(3 * 43);
        if (board2.length > 0) {
          slideAnimations2.current[3].setValue(3 * 43);
        }
        if (board3.length > 0) {
          slideAnimations3.current[3].setValue(3 * 43);
        }

        const animations = [
          Animated.timing(opacities.current[3], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[3], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[3], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[3], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }

        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[3], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[3], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }

        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        lastAnimatedCard.current = 4;
        if (board2.length > 0) lastAnimatedCardB2.current = 4;
        if (board3.length > 0) lastAnimatedCardB3.current = 4;
      }

      //card 5 - board 1
      if (board.length >= 5 && lastAnimatedCard.current < 5) {
        console.log('animation 5');
        await delay(0); // Delay before river

        slideAnimations.current[4].setValue(4 * 43);
        if (board2.length > 0) {
          slideAnimations2.current[4].setValue(4 * 43);
        }
        if (board3.length > 0) {
          slideAnimations3.current[4].setValue(4 * 43);
        }

        const animations = [
          Animated.timing(opacities.current[4], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[4], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[4], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[4], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }
        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[4], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[4], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }
        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCard.current = 5;
        if (board2.length > 0) lastAnimatedCardB2.current = 5;
        if (board3.length > 0) lastAnimatedCardB3.current = 5;
      }

      animationCompleted.current = true;

      playAudio('cardReveal');

      //update hand ranks
      console.log(
        'call to open community card handrank',
        backSeatsRef?.current,
      );
      if (backSeatsRef?.current) {
        Object.keys(backSeatsRef?.current).forEach(seatId => {
          let currentSeatToUpdate = backSeatsRef.current[seatId];
          if (currentSeatToUpdate) {
            console.log('before to update', currentSeatToUpdate);
            updateSeatRanks(seatId, {
              handRank: currentSeatToUpdate?.handRank,
              handRank2: currentSeatToUpdate?.handRank2,
              handRank3: currentSeatToUpdate?.handRank3,
            });
          }
        });
      }
    } catch (e) {
      console.log('error community cards----------', e);
    }
  };

  const openCommunityCardsRit = async () => {
    try {
      console.log('open communut cards ------');

      const board = currentTable?.board;
      const board2 = currentTable?.board2;
      const board3 = currentTable?.board3;

      const TOTAL_CARDS = 5;
      const CARD_SPACING = 0;
      const screenWidth = layout.width;
      const layoutWidth = screenWidth * 0.6;

      const CARD_WIDTH =
        (layoutWidth - (TOTAL_CARDS - 1) * CARD_SPACING) / TOTAL_CARDS;
      setCommunityCardWidth(CARD_WIDTH);
      const spacing = 43;

      const FLIP_DURATION = 250;
      const SLIDE_DURATION = 150;
      const OPACITY_DURATION = 50;
      // board 1 first card
      if (board.length >= 1 && lastAnimatedCard.current < 1) {
        console.log('B1: animation 1');

        slideAnimations.current[0].setValue(0 * 43);

        await new Promise(resolve => {
          const animations = [
            Animated.timing(opacities.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ];
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCard.current = 1;
      }

      // board 2 first card
      if (board2.length >= 1 && lastAnimatedCardB2.current < 1) {
        console.log('B2: animation 1', lastAnimatedCardB2.current);

        slideAnimations2.current[0].setValue(0 * 43);
        await delay(0);

        await new Promise(resolve => {
          const animations = [
            Animated.timing(opacities2.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ];
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCardB2.current = 1;
      }

      // board 3 first card
      if (board3.length >= 1 && lastAnimatedCardB3.current < 1) {
        console.log('B3: animation 1');

        slideAnimations3.current[0].setValue(0 * 43);
        await delay(0);

        await new Promise(resolve => {
          const animations = [
            Animated.timing(opacities3.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ];
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCardB3.current = 1;
      }

      // Cards 2 & 3 = board 1
      if (board.length >= 3 && lastAnimatedCard.current < 3) {
        console.log('animation 2 and 3');
        await delay(0); // Delay before flop (2nd & 3rd card)

        flipAnimations.current[1].setValue(180);
        flipAnimations.current[2].setValue(180);

        // Build animation arrays for all boards
        const animations = [
          // board1
          Animated.timing(opacities.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCard.current = 3;
      }
      // Cards 2 & 3 = board 2
      if (board2.length >= 3 && lastAnimatedCardB2.current < 3) {
        console.log('animation 2 and 3');
        await delay(0); // Delay before flop (2nd & 3rd card)

        flipAnimations2.current[1].setValue(180);
        flipAnimations2.current[2].setValue(180);

        const animations = [
          Animated.timing(opacities2.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations2.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities2.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations2.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        if (board2.length > 0) lastAnimatedCardB2.current = 3;
      }

      // Cards 2 & 3 = board 3
      if (board3.length >= 3 && lastAnimatedCardB3.current < 3) {
        console.log('animation 2 and 3');
        await delay(0); // Delay before flop (2nd & 3rd card)

        flipAnimations3.current[1].setValue(180);
        flipAnimations3.current[2].setValue(180);

        const animations = [
          Animated.timing(opacities3.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations3.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities3.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations3.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        if (board3.length > 0) lastAnimatedCardB3.current = 3;
      }

      // Card 4 - board 1
      if (board.length >= 4 && lastAnimatedCard.current < 4) {
        console.log('animation 4');
        await delay(0); // Delay before turn

        slideAnimations.current[3].setValue(3 * 43);

        const animations = [
          Animated.timing(opacities.current[3], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[3], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        lastAnimatedCard.current = 4;
      }

      // Card 4 - board 2
      if (board2.length >= 4 && lastAnimatedCardB2.current < 4) {
        console.log('animation 4 rit');
        await delay(0); // Delay before turn

        slideAnimations2.current[3].setValue(3 * 43);

        const animations = [
          Animated.timing(opacities2.current[3], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations2.current[3], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        if (board2.length > 0) lastAnimatedCardB2.current = 4;
      }

      // Card 4 - board 3
      if (board3.length >= 4 && lastAnimatedCardB3.current < 4) {
        console.log('animation 4');
        await delay(0); // Delay before turn

        slideAnimations3.current[3].setValue(3 * 43);

        const animations = [
          Animated.timing(opacities3.current[3], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations3.current[3], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        if (board3.length > 0) lastAnimatedCardB3.current = 4;
      }

      //card 5 - board 1
      if (board.length >= 5 && lastAnimatedCard.current < 5) {
        console.log('animation 5');
        await delay(0); // Delay before river

        slideAnimations.current[4].setValue(4 * 43);
        if (board2.length > 0) {
          slideAnimations2.current[4].setValue(4 * 43);
        }
        if (board3.length > 0) {
          slideAnimations3.current[4].setValue(4 * 43);
        }

        const animations = [
          Animated.timing(opacities.current[4], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[4], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[4], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[4], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }
        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[4], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[4], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }
        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        lastAnimatedCard.current = 5;
        if (board2.length > 0) lastAnimatedCardB2.current = 5;
        if (board3.length > 0) lastAnimatedCardB3.current = 5;
      }

      //card 5 - board 2
      if (board2.length >= 5 && lastAnimatedCardB2.current < 5) {
        console.log('animation 5');
        await delay(0); // Delay before river

        slideAnimations2.current[4].setValue(4 * 43);

        const animations = [
          Animated.timing(opacities2.current[4], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations2.current[4], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];
        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        if (board2.length > 0) lastAnimatedCardB2.current = 5;
      }

      //card 5 - board 3
      if (board3.length >= 5 && lastAnimatedCardB3.current < 5) {
        console.log('animation 5');
        await delay(0); // Delay before river

        slideAnimations3.current[4].setValue(4 * 43);

        const animations = [
          Animated.timing(opacities3.current[4], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations3.current[4], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];
        // Run everything in parallel
        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });

        if (board3.length > 0) lastAnimatedCardB3.current = 5;
      }

      setTimeout(() => {
        animationCompleted.current = true;

        playAudio('cardReveal');

        //update hand ranks

        if (backSeatsRef?.current) {
          Object.keys(backSeatsRef?.current).forEach(seatId => {
            let currentSeatToUpdate = backSeatsRef.current[seatId];
            if (currentSeatToUpdate) {
              console.log('before to update', currentSeatToUpdate);
              updateSeatRanks(seatId, {
                handRank: currentSeatToUpdate?.handRank,
                handRank2: currentSeatToUpdate?.handRank2,
                handRank3: currentSeatToUpdate?.handRank3,
              });
            }
          });
        }
      }, 100);
    } catch (e) {
      console.log('error community cards----------', e);
    }
  };

  const updateSeatRanks = (seatId, updates) => {
    seatRanksRef.current[seatId] = {
      ...(seatRanksRef.current[seatId] || {}), // existing ranks for this seat
      ...updates, // merge new ranks
    };
  };

  const openCommunityCardsIos = async () => {
    try {
      console.log('openCommunityCardsIos start ----');

      const board = currentTable?.board || [];
      const board2 = currentTable?.board2 || [];
      const board3 = currentTable?.board3 || [];

      const TOTAL_CARDS = 5;
      const CARD_SPACING = 0;
      const screenWidth = layout.width;
      const layoutWidth = screenWidth * 0.6;

      const CARD_WIDTH =
        (layoutWidth - (TOTAL_CARDS - 1) * CARD_SPACING) / TOTAL_CARDS;
      setCommunityCardWidth(CARD_WIDTH);

      const spacing = 45;
      const FLIP_DURATION = 250;
      const SLIDE_DURATION = 150;
      const OPACITY_DURATION = 50;

      // Small utility to delay phases
      const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

      // Helper for safe parallel animation execution
      const runParallel = (animations, label) =>
        new Promise(resolve => {
          InteractionManager.runAfterInteractions(() => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                Animated.parallel(animations, { stopTogether: true }).start(
                  () => {
                    console.log(`✅ ${label} done`);
                    resolve();
                  },
                );
              });
            });
          });
        });

      // 🃏 Phase 1: Card 1
      if (board.length >= 1 && lastAnimatedCard.current < 1) {
        slideAnimations.current[0].setValue(0 * spacing);
        if (board2.length > 0)
          slideAnimations2.current[0].setValue(0 * spacing);
        if (board3.length > 0)
          slideAnimations3.current[0].setValue(0 * spacing);

        const animations = [
          Animated.timing(opacities.current[0], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[0], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }
        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          );
        }

        await runParallel(animations, 'Card 1');
        lastAnimatedCard.current = 1;
        if (board2.length > 0) lastAnimatedCardB2.current = 1;
        if (board3.length > 0) lastAnimatedCardB3.current = 1;
      }

      await wait(300); // 👈 smooth transition delay
      // 🃏 Phase 2: Cards 2 & 3
      if (board.length >= 3 && lastAnimatedCard.current < 3) {
        flipAnimations.current[1].setValue(180);
        flipAnimations.current[2].setValue(180);

        if (board2.length > 0) {
          flipAnimations2.current[1].setValue(180);
          flipAnimations2.current[2].setValue(180);
        }
        if (board3.length > 0) {
          flipAnimations3.current[1].setValue(180);
          flipAnimations3.current[2].setValue(180);
        }

        const animations = [
          Animated.timing(opacities.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(opacities.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[1], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations2.current[1], {
              toValue: 1 * spacing,
              duration: SLIDE_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(opacities2.current[2], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations2.current[2], {
              toValue: 2 * spacing,
              duration: SLIDE_DURATION,
              useNativeDriver: true,
            }),
          );
        }

        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[1], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations3.current[1], {
              toValue: 1 * spacing,
              duration: SLIDE_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(opacities3.current[2], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(slideAnimations3.current[2], {
              toValue: 2 * spacing,
              duration: SLIDE_DURATION,
              useNativeDriver: true,
            }),
          );
        }

        await runParallel(animations, 'Cards 2 & 3');
        lastAnimatedCard.current = 3;
        if (board2.length > 0) lastAnimatedCardB2.current = 3;
        if (board3.length > 0) lastAnimatedCardB3.current = 3;
      }

      await wait(200); // 👈 smooth transition delay

      // 🃏 Phase 3: Card 4
      if (board.length >= 4 && lastAnimatedCard.current < 4) {
        slideAnimations.current[3].setValue(3 * spacing);
        if (board2.length > 0) {
          slideAnimations2.current[3].setValue(3 * spacing);
        }
        if (board3.length > 0) {
          slideAnimations3.current[3].setValue(3 * spacing);
        }
        const animations = [
          Animated.timing(opacities.current[3], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[3], {
            toValue: 180,
            duration: FLIP_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[3], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[3], {
              toValue: 180,
              duration: FLIP_DURATION,
              useNativeDriver: true,
            }),
          );
        }
        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[3], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[3], {
              toValue: 180,
              duration: FLIP_DURATION,
              useNativeDriver: true,
            }),
          );
        }

        await runParallel(animations, 'Card 4');
        lastAnimatedCard.current = 4;
        if (board2.length > 0) lastAnimatedCardB2.current = 4;
        if (board3.length > 0) lastAnimatedCardB3.current = 4;
      }

      await wait(200); // 👈 smooth transition delay

      // 🃏 Phase 4: Card 5
      if (board.length >= 5 && lastAnimatedCard.current < 5) {
        slideAnimations.current[4].setValue(4 * spacing);
        if (board2.length > 0) {
          slideAnimations2.current[4].setValue(4 * spacing);
        }
        if (board3.length > 0) {
          slideAnimations3.current[4].setValue(4 * spacing);
        }
        const animations = [
          Animated.timing(opacities.current[4], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(flipAnimations.current[4], {
            toValue: 180,
            duration: FLIP_DURATION,
            useNativeDriver: true,
          }),
        ];

        if (board2.length > 0) {
          animations.push(
            Animated.timing(opacities2.current[4], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[4], {
              toValue: 180,
              duration: FLIP_DURATION,
              useNativeDriver: true,
            }),
          );
        }
        if (board3.length > 0) {
          animations.push(
            Animated.timing(opacities3.current[4], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[4], {
              toValue: 180,
              duration: FLIP_DURATION,
              useNativeDriver: true,
            }),
          );
        }

        await runParallel(animations, 'Card 5');
        lastAnimatedCard.current = 5;
        if (board2.length > 0) lastAnimatedCardB2.current = 5;
        if (board3.length > 0) lastAnimatedCardB3.current = 5;
      }

      // ✅ Finish all animations
      animationCompleted.current = true;
      playAudio?.('cardReveal');

      // 🧩 Update seat ranks (optional parity with Android)
      if (backSeatsRef?.current) {
        Object.keys(backSeatsRef.current).forEach(seatId => {
          const seat = backSeatsRef.current[seatId];
          if (seat) {
            updateSeatRanks(seatId, {
              handRank: seat?.handRank,
              handRank2: seat?.handRank2,
              handRank3: seat?.handRank3,
            });
          }
        });
      }

      console.log('community cards animation complete ✅');
    } catch (e) {
      console.log('error community cards iOS ----------', e);
    }
  };

  const openCommunityCardsRitIos = async () => {
    try {
      console.log('openCommunityCardsRitIos start ----');

      const board = currentTable?.board || [];
      const board2 = currentTable?.board2 || [];
      const board3 = currentTable?.board3 || [];

      const TOTAL_CARDS = 5;
      const CARD_SPACING = 0;
      const screenWidth = layout.width;
      const layoutWidth = screenWidth * 0.6;

      const CARD_WIDTH =
        (layoutWidth - (TOTAL_CARDS - 1) * CARD_SPACING) / TOTAL_CARDS;
      setCommunityCardWidth(CARD_WIDTH);

      const spacing = 45; // iOS smoother spacing
      const FLIP_DURATION = 120; // iOS smoother flip
      const SLIDE_DURATION = 180;
      const OPACITY_DURATION = 60;

      // ----------- BOARD 1 - CARD 1 -----------
      if (board.length >= 1 && lastAnimatedCard.current < 1) {
        console.log('B1: animation 1');
        slideAnimations.current[0].setValue(0 * spacing);

        await new Promise(resolve => {
          Animated.parallel([
            Animated.timing(opacities.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ]).start(resolve);
        });
        lastAnimatedCard.current = 1;
      }

      // ----------- BOARD 2 - CARD 1 -----------
      if (board2.length >= 1 && lastAnimatedCardB2.current < 1) {
        console.log('B2: animation 1');
        slideAnimations2.current[0].setValue(0 * spacing);
        await delay(50);
        await new Promise(resolve => {
          Animated.parallel([
            Animated.timing(opacities2.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations2.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ]).start(resolve);
        });
        lastAnimatedCardB2.current = 1;
      }

      // ----------- BOARD 3 - CARD 1 -----------
      if (board3.length >= 1 && lastAnimatedCardB3.current < 1) {
        console.log('B3: animation 1');
        slideAnimations3.current[0].setValue(0 * spacing);
        await delay(50);
        await new Promise(resolve => {
          Animated.parallel([
            Animated.timing(opacities3.current[0], {
              toValue: 1,
              duration: OPACITY_DURATION,
              useNativeDriver: true,
            }),
            Animated.timing(flipAnimations3.current[0], {
              toValue: 180,
              duration: FLIP_DURATION,
              easing: Easing.linear,
              useNativeDriver: true,
            }),
          ]).start(resolve);
        });
        lastAnimatedCardB3.current = 1;
      }

      // ----------- BOARD 1 - CARDS 2 & 3 -----------
      if (board.length >= 3 && lastAnimatedCard.current < 3) {
        console.log('B1: animation 2 & 3');
        await delay(100);

        flipAnimations.current[1].setValue(180);
        flipAnimations.current[2].setValue(180);

        const animations = [
          Animated.timing(opacities.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        lastAnimatedCard.current = 3;
      }

      // ----------- BOARD 2 - CARDS 2 & 3 -----------
      if (board2.length >= 3 && lastAnimatedCardB2.current < 3) {
        console.log('B2: animation 2 & 3');
        await delay(100);

        flipAnimations2.current[1].setValue(180);
        flipAnimations2.current[2].setValue(180);

        const animations = [
          Animated.timing(opacities2.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations2.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities2.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations2.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        lastAnimatedCardB2.current = 3;
      }

      // ----------- BOARD 3 - CARDS 2 & 3 -----------
      if (board3.length >= 3 && lastAnimatedCardB3.current < 3) {
        console.log('B3: animation 2 & 3');
        await delay(100);

        flipAnimations3.current[1].setValue(180);
        flipAnimations3.current[2].setValue(180);

        const animations = [
          Animated.timing(opacities3.current[1], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations3.current[1], {
            toValue: 1 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
          Animated.timing(opacities3.current[2], {
            toValue: 1,
            duration: OPACITY_DURATION,
            useNativeDriver: true,
          }),
          Animated.timing(slideAnimations3.current[2], {
            toValue: 2 * spacing,
            duration: SLIDE_DURATION,
            easing: Easing.linear,
            useNativeDriver: true,
          }),
        ];

        await new Promise(resolve => {
          Animated.parallel(animations).start(resolve);
        });
        lastAnimatedCardB3.current = 3;
      }

      // ----------- TURN (CARD 4) -----------
      const animateTurn = async (
        boardArr,
        slideRef,
        opacityRef,
        flipRef,
        tracker,
        label,
      ) => {
        if (boardArr.length >= 4 && tracker.current < 4) {
          console.log(`${label}: animation 4`);
          await delay(150);
          slideRef.current[3].setValue(3 * spacing);
          await new Promise(resolve => {
            Animated.parallel([
              Animated.timing(opacityRef.current[3], {
                toValue: 1,
                duration: OPACITY_DURATION,
                useNativeDriver: true,
              }),
              Animated.timing(flipRef.current[3], {
                toValue: 180,
                duration: FLIP_DURATION,
                easing: Easing.linear,
                useNativeDriver: true,
              }),
            ]).start(resolve);
          });
          tracker.current = 4;
        }
      };
      await Promise.all([
        animateTurn(
          board,
          slideAnimations,
          opacities,
          flipAnimations,
          lastAnimatedCard,
          'B1',
        ),
        animateTurn(
          board2,
          slideAnimations2,
          opacities2,
          flipAnimations2,
          lastAnimatedCardB2,
          'B2',
        ),
        animateTurn(
          board3,
          slideAnimations3,
          opacities3,
          flipAnimations3,
          lastAnimatedCardB3,
          'B3',
        ),
      ]);

      // ----------- RIVER (CARD 5) -----------
      const animateRiver = async (
        boardArr,
        slideRef,
        opacityRef,
        flipRef,
        tracker,
        label,
      ) => {
        if (boardArr.length >= 5 && tracker.current < 5) {
          console.log(`${label}: animation 5`);
          await delay(150);
          slideRef.current[4].setValue(4 * spacing);
          await new Promise(resolve => {
            Animated.parallel([
              Animated.timing(opacityRef.current[4], {
                toValue: 1,
                duration: OPACITY_DURATION,
                useNativeDriver: true,
              }),
              Animated.timing(flipRef.current[4], {
                toValue: 180,
                duration: FLIP_DURATION,
                easing: Easing.linear,
                useNativeDriver: true,
              }),
            ]).start(resolve);
          });
          tracker.current = 5;
        }
      };
      await Promise.all([
        animateRiver(
          board,
          slideAnimations,
          opacities,
          flipAnimations,
          lastAnimatedCard,
          'B1',
        ),
        animateRiver(
          board2,
          slideAnimations2,
          opacities2,
          flipAnimations2,
          lastAnimatedCardB2,
          'B2',
        ),
        animateRiver(
          board3,
          slideAnimations3,
          opacities3,
          flipAnimations3,
          lastAnimatedCardB3,
          'B3',
        ),
      ]);

      // ✅ Animation completed
      setTimeout(() => {
        animationCompleted.current = true;
        playAudio('cardReveal');

        if (backSeatsRef?.current) {
          Object.keys(backSeatsRef.current).forEach(seatId => {
            const seat = backSeatsRef.current[seatId];
            if (seat) {
              updateSeatRanks(seatId, {
                handRank: seat?.handRank,
                handRank2: seat?.handRank2,
                handRank3: seat?.handRank3,
              });
            }
          });
        }
      }, 100);
    } catch (e) {
      console.log('error community cards (iOS Rit) ----------', e);
    }
  };

  //turn play timer

const REPLAY_SPEED = 5; // 5x faster replay

useEffect(() => {
  const currentEvent = replayData?.replay?.[currentAction];
  const nextEvent = replayData?.replay?.[currentAction + 1];

  const eventTimestamp = Number(currentEvent?.eventTimestamp || 0);
  const nextEventTimestamp = Number(nextEvent?.eventTimestamp || 0);

  if (
    !currentTable?.turnExp ||
    !eventTimestamp ||
    currentTable?.handOver ||
    currentTable?.turn == null ||
    currentTable?.isRoundChanging
  ) {
    setRemainTime(0);
    return;
  }

  const target = Number(currentTable.turnExp);
  const timerStartedAt = Date.now();

  const blinkInterval = setInterval(() => {
    setblink(prev => !prev);
  }, 300 / REPLAY_SPEED);

  const timer = setInterval(() => {
    // advance replay clock faster
    const elapsed = (Date.now() - timerStartedAt) * REPLAY_SPEED;
    const now = eventTimestamp + elapsed;

    // stop when next replay event reached
    if (nextEventTimestamp && now >= nextEventTimestamp) {
      clearInterval(timer);
      clearInterval(blinkInterval);
      return;
    }

    const diff = target - now;

    if (diff <= 0) {
      setRemainTime(0);
      clearInterval(timer);
      clearInterval(blinkInterval);
      return;
    }

    const displayTime = Math.max(
      0,
      Math.round((diff / 1000) * 10) / 10,
    );

    setRemainTime(prev => (prev === displayTime ? prev : displayTime));
  }, 100); // smoother updates

  return () => {
    clearInterval(timer);
    clearInterval(blinkInterval);
  };
}, [
  currentAction,
  currentTable?.turnExp,
  currentTable?.turn,
  currentTable?.isRoundChanging,
]);
  //Straddle timer
//   useEffect(() => {
//     if (!currentTable?.straddleTurnExp || !serverTimeOffset) return;

//     if (
//       currentTable?.straddleRunning &&
//       currentTable?.straddleType == 'EVERYONE'
//     ) {
//       let baseNativeTime = 0;
//       let baseServerTime = 0;

//       const target = Number(currentTable.straddleTurnExp);

//       // 🔵 Blink (lightweight, OK to keep)
//       let blinkInterval = setInterval(() => {
//         setblink(prev => !prev);
//       }, 300);

//       const unsubscribe = subscribeNativeTimer(nativeTime => {
//         // ✅ first sync
//         if (!baseNativeTime) {
//           baseNativeTime = nativeTime;
//           baseServerTime = Date.now() + serverTimeOffset;
//           return;
//         }

//         // ✅ convert native → epoch
//         const now = baseServerTime + (nativeTime - baseNativeTime);

//         const diff = target - now;

//         // ✅ handle end
//         if (diff <= 0) {
//           setRemainTime(0);
//           clearInterval(blinkInterval);
//           return;
//         }

//         // ✅ smooth 0.1 sec (same as your old logic)
//         const remaining = diff / 1000;
//         const displayTime = Math.max(0, Math.round(remaining * 10) / 10);

//         // ✅ prevent unnecessary re-renders
//         setRemainTime(prev => (prev === displayTime ? prev : displayTime));
//       });

//       return () => {
//         if (unsubscribe) unsubscribe();
//         clearInterval(blinkInterval);

//         baseNativeTime = 0;
//         baseServerTime = 0;
//       };
//     }
//   }, [
//     currentTable?.straddleTurnExp,
//     serverTimeOffset,
//     currentTable?.straddleRunning,
//     currentTable?.straddleType,
//   ]);
  //RIT timer
//   useEffect(() => {
//     let unsubscribe;

//     if (
//       !currentTable?.ritExp ||
//       !currentTable?.ritAskDetails ||
//       Object.keys(currentTable?.ritAskDetails ?? {}).length === 0 ||
//       currentTable?.ritAskDetails?.to?.toString() !== myPlayer?.id?.toString()
//     )
//       return;

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTable.ritExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setRemainTimeRIT(prev => (prev === 0 ? prev : 0));
//         return;
//       }

//       // ✅ clean seconds
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       setRemainTimeRIT(prev => {
//         if (prev === totalSeconds) return prev;
//         return totalSeconds;
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTable?.ritExp, currentTable?.ritAskDetails]);

  //Risk timer
//   useEffect(() => {
//     let unsubscribe;

//     if (
//       !currentTable?.riskExp ||
//       !currentTable?.ritAskDetails ||
//       Object.keys(currentTable?.ritAskDetails ?? {}).length === 0 ||
//       currentTable?.ritAskDetails?.to?.toString() !== myPlayer?.id?.toString()
//     )
//       return;

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTable.riskExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setRemainTimeRisk(prev => (prev === 0 ? prev : 0));
//         return;
//       }

//       // ✅ clean seconds
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       setRemainTimeRisk(prev => {
//         if (prev === totalSeconds) return prev;
//         return totalSeconds;
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTable?.riskExp, currentTable?.ritAskDetails]);

  //Insurance timer
//   useEffect(() => {
//     let unsubscribe;

//     if (
//       !currentTable?.insExp ||
//       !(
//         lastScoketEvent === INSURANCE_ASK_WINNER ||
//         lastScoketEvent === TABLE_UPDATED ||
//         lastScoketEvent === INSURANCE_STATUS
//       )
//     )
//       return;

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTable.insExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setRemainTimeIns(prev => (prev === 0 ? prev : 0));
//         return;
//       }

//       // ✅ clean seconds
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       setRemainTimeIns(prev => {
//         if (prev === totalSeconds) return prev;
//         return totalSeconds;
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTable?.insExp, lastScoketEvent]);
  // Level Timer
  const formatTime = totalSeconds => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(
      2,
      '0',
    )}`;
  };

  //FT deal Timer
  // Level Timer
//   const formatTimeFTDeal = totalSeconds => {
//     const minutes = Math.floor(totalSeconds / 60);
//     const seconds = totalSeconds % 60;

//     return `${String(seconds).padStart(2, '0')}`;
//   };

  //MTT - level timer

//   useEffect(() => {
//     let unsubscribe;

//     if (!currentTour?.levelExp) return;
//     // 🛑 HOLD TIMER DURING BREAK
//     if (currentTour?.breakRunning) {
//       return; // freeze UI, keep last value
//     }

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTour.levelExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       // ✅ handle end
//       if (diff <= 0) {
//         setRemainTimeLevel(0);
//         return;
//       }

//       // ❌ remove ceil + buffer
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       setRemainTimeLevel(prev => {
//         if (prev === totalSeconds) return prev;
//         return formatTime(totalSeconds);
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTour?.levelExp, currentTour?.breakRunning]);

//   //FT-DEAL TIMER
//   useEffect(() => {
//     let unsubscribe;

//     if (!currentTour?.ftDealExp) return;

//     // ✅ get global base (Redux)
//     const { baseNativeTime, baseServerTime } = store.getState().time;

//     if (!baseNativeTime) return;

//     const target = Number(currentTour.ftDealExp);

//     unsubscribe = subscribeNativeTimer(nativeTime => {
//       // 🔥 global synced time
//       const now = baseServerTime + (nativeTime - baseNativeTime);

//       const diff = target - now;

//       if (diff <= 0) {
//         setShowFTModal2(false);
//         return;
//       }

//       // ✅ handle end
//       if (diff <= 0) {
//         const zero = formatTimeFTDeal(0);
//         setShowFTModal2(false);
//         setRemainTimeFTDEAL(prev => (prev === zero ? prev : zero));
//         return;
//       }

//       // ❌ remove ceil + buffer
//       const totalSeconds = Math.max(0, Math.floor(diff / 1000));

//       const formatted = formatTimeFTDeal(totalSeconds);

//       setRemainTimeFTDEAL(prev => {
//         if (prev === formatted) return prev;
//         return formatted;
//       });
//     });

//     return () => unsubscribe?.();
//   }, [currentTour?.ftDealExp]);

  const isIncludedInFavourite = seatId => {
    return currentTable?.insAskDetails
      .filter(e => e?.key === 'mainpot')
      .map(e => e?.favouriteSeat)
      .includes(seatId);
  };
  const isAnyFavourite = seatId => {
    console.log(
      'is any favourite ---->',
      currentTable?.insAskDetails.map(e => e?.favouriteSeat).includes(seatId),
    );
    return currentTable?.insAskDetails

      .map(e => e?.favouriteSeat)
      .includes(seatId);
  };
  function checkAllInsuranceActionsTaken() {
    if (!currentTable) return false;

    const insAskDetails = currentTable?.insAskDetails || [];
    const actions = currentTable?.insuranceRoundWiseAction || [];

    const boardLen = currentTable?.board?.length;
    const gameRound = boardLen === 3 ? 'FLOP' : boardLen === 4 ? 'TURN' : null;

    if (!gameRound) return false;

    return insAskDetails.every(ask =>
      actions.some(
        action =>
          action.round === gameRound &&
          action.pot === ask.key &&
          action.seatId?.toString() === ask.favouriteSeat?.toString(),
      ),
    );
  }

  function checkMyAllInsuranceActionsTaken() {
    if (!currentTable || !myPlayer) return false;

    const insAskDetails = currentTable.insAskDetails || [];
    const actions = currentTable.insuranceRoundWiseAction || [];

    // detect round from board
    const boardLen = currentTable?.board?.length;
    const gameRound = boardLen === 3 ? 'FLOP' : boardLen === 4 ? 'TURN' : null;

    if (!gameRound) return false;

    // only asks meant for ME
    const myAsks = insAskDetails.filter(
      ask => ask?.favouriteSeat?.toString() === myPlayer?.id?.toString(),
    );

    // if nothing was asked to me → I already did everything
    if (myAsks.length === 0) return true;

    // check all MY actions are taken
    return myAsks.every(ask =>
      actions.some(
        action =>
          action.round === gameRound &&
          action.pot === ask.key &&
          action.seatId?.toString() === myPlayer?.id?.toString(),
      ),
    );
  }



 
  const checkTableAlreadyTakenSeat = () => {
    const isSeatAlreadyTaken = Object.values(currentTable?.seats || {}).some(
      seat => String(seat?.player?.id) === String(user?.id),
    );
    return isSeatAlreadyTaken;
  };

 
  //my player intialization
  const checkMyPlayer = async () => {
    try {
      console.log('inside checkmy player----------00',user?.user?.id?.toString());
      if (!currentTable) return;
      let isSeatAtBottom = true;
      if(user==null){return}

      //check my player has seat
      const mySeatCheck = Object.entries(currentTable?.seats || {})
        .filter(([seatKey, seatDsata]) => {
          console.log('user------', user);
          console.log(
            `Seat ${seatKey} Player ID:`,
            seatDsata?.player?.id,
            user?.user?.id,
          );
          return (
            seatDsata?.player?.id?.toString() === user?.user?.id?.toString()
          );
        })
        .map(([seatKey, seatData]) => {
          return {
            ...seatData,
            seatKey, // Include the seat number if needed
          };
        });

      console.log('my seat check------', myPlayer, mySeatCheck);

      //check is at bottom
      if (mySeatCheck.length > 0) {
        const seatId = mySeatCheck[0]?.id;

        let checkmySeatCurrentIndex = seatPositions
          .filter(e => e?.id?.toString() == seatId?.toString())
          .map(e => e.currentIndex);
        // .toString();
        console.log(
          'check current index-----------',
          checkmySeatCurrentIndex,
          checkmySeatCurrentIndex,
        );
        if (checkmySeatCurrentIndex != 0) {
          isSeatAtBottom = false;
        }
      }

      //if my player not intialized
      if (myPlayer == null || !isSeatAtBottom) {
        if (mySeatCheck.length > 0) {
          console.log(
            'hand and folded=====',
            mySeatCheck[0],
            mySeatCheck[0]?.folded?.toString(),
            mySeatCheck[0]?.hand?.toString(),
          );
          const seatId = mySeatCheck[0]?.id;

          let checkmySeatCurrentIndex = seatPositions
            .filter(e => e?.id?.toString() == seatId?.toString())
            .map(e => e.currentIndex);
          // .toString();
          console.log(
            'check current index-----------',
            checkmySeatCurrentIndex,
            checkmySeatCurrentIndex,
          );

          console.log('before check sushi-----');
          if (checkmySeatCurrentIndex != 0) {
            await handleSeatPress(Number(seatId) - 1);
          }

          console.log('checking sushi', mySeatCheck[0]?.hand?.length);
          if (
            mySeatCheck[0]?.hand?.length == 0 ||
            typeof mySeatCheck[0]?.hand == 'undefined'
          ) {
            showSushiFirstMsg(mySeatCheck[0]?.stack);
          }

          if (currentTable?.isSquid && lastScoketEvent == ACTION_SITTED) {
            setMsg(
              `Squid deposit paid: ${mySeatCheck[0]?.squidDeposit} chips `,
            );
            setAlertVisible(true);
          }
          setMyplayer(mySeatCheck[0]);
          // console.log('my player-------------', mySeatCheck[0]);
        } else {
          setMyplayer(null);
          await onResetSeats();
        }
      }
      //if my player already intialized but now seat cleared
      else {
        console.log('inside elese of my player',mySeatCheck);
        if (mySeatCheck.length == 0) {
          setMyplayer(null);
          await onResetSeats();
        } else {
          setMyplayer(mySeatCheck[0]);
        }
      }

      setCheckedPlayer(true);

      //for torunament check is myPlayer Earn Ko. boutny and current my player not sitted
      if (tableData?.table?.tournamentId != null) {
        const isMyPlayerSitted = Object.values(currentTable?.seats || {}).some(
          seatData =>
            seatData?.player?.id?.toString() === user?.user?.id?.toString(),
        );

        const myPlayerNotSitted = !isMyPlayerSitted;
        if (myPlayerNotSitted) {
        }
      }
    } catch (e) {
      console.log('error in check my player-------', e);
    }
  };

  const showSushiFirstMsg = stack => {
    console.log('call to show shushi msg', currentTable?.sushiPot);
    if (currentTable?.isSushi && currentTable?.sushiPot == 0) {
      setMsg(
        `Buy-in ${stack} chips, of which ${
          currentTable?.initAnte * currentTable?.bigBlind
        } chips are initial ante.`,
      );
      setAlertVisible(true);
    }
  };





 





  //alert messages
  useEffect(() => {
    if (alertVisible) {
      setTimeout(function () {
        setAlertVisible(false);
      }, 2000);
    }
  }, [alertVisible]);

  //squid alert
  //
  useEffect(() => {
    if (showSquidWin) {
      setTimeout(function () {
        setSquidWinTxt(``);

        setShowSquidWin(false);
      }, 1000);
    }
  }, [showSquidWin]);

  // useEffect(() => {
  //   if (flash) {
  //    // sendFlash(true);
  //     setTimeout(function () {
  //       setFlash(false);
  //       sendFlash(false);
  //     }, 600);
  //   }
  // }, [flash]);

  useEffect(() => {
    return () => {
      stopFlipAnimations();
    };
  }, []);
  const stopFlipAnimations = () => {
    try {
      Object.values(flipAnims.current).forEach(cards => {
        cards.forEach(anim => anim.stopAnimation());
      });
    } catch (e) {}
  };

  useEffect(() => {
    if (!currentTable) return;

    initializeFlipAnims();
    stopFlipAnimations(); // <-- IMPORTANT

    const seats = currentTable?.seats ?? {};
    const seatsWithCard = Object.values(seats).filter(
      s => s?.player && s?.hand?.length > 0,
    );

    if (!currentTable || seatsWithCard.length === 0) return;

    if (
      (currentTable.handOver || currentTable.endBeforeShowDown) &&
      !currentTable.isEndWithoutShowDown &&
      !showdownReveal
    ) {
      let totalFlips = 0;
      let completedFlips = 0;

      Object.entries(currentTable.seats).forEach(([_, seat]) => {
        if (seat?.hand?.length) totalFlips += seat.hand.length;
      });

      Object.entries(currentTable.seats).forEach(([seatId, seat]) => {
        if (!seat?.hand) return;

        seat.hand.forEach((_, cardIndex) => {
          const anim = flipAnims.current[seatId]?.[cardIndex];
          if (!anim) return; // SAFETY

          Animated.timing(anim, {
            toValue: 180,
            duration: 1000,
            useNativeDriver: true,
          }).start(() => {
            completedFlips++;
            if (completedFlips === totalFlips) {
              setShowdownReveal(true);
            }
          });
        });
      });
    }
  }, [
    currentTable?.handOver,
    currentTable?.endBeforeShowDown,
    currentTable?.isEndWithoutShowDown,
  ]);



  //reset Componets
  const resetCompoenents = () => {
    console.log('yes call to reset ');
    animationCompleted.current = true;
    setCurrentSelectedPrePlay('');
    //prePlayCall('');

    setRaiseBarValue(0);
    setRaiseCompVisible({ multiplier: true, slider: false, keypad: false });
    setIsModalVisible({ ...isModalVisible, raise: false });

    if (!currentTable?.board) return;

    // 🆕 New round detected — board cleared
    if (currentTable.board.length === 0) {
      board1Conainter.setValue(0);
      board2Conainter.setValue(55);
      board3Conainter.setValue(110);

      lastAnimatedCard.current = 0;

      lastAnimatedCardB2.current = 0;
      lastAnimatedCardB3.current = 0;

      flipAnimations.current.forEach(anim => anim.setValue(0));
      slideAnimations.current.forEach(anim => anim.setValue(0));
      opacities.current.forEach(anim => anim.setValue(0));
      flipAnimations2.current.forEach(anim => anim.setValue(0));
      slideAnimations2.current.forEach(anim => anim.setValue(0));
      opacities2.current.forEach(anim => anim.setValue(0));
      flipAnimations3.current.forEach(anim => anim.setValue(0));
      slideAnimations3.current.forEach(anim => anim.setValue(0));
      opacities3.current.forEach(anim => anim.setValue(0));

      // Optional: Clear animations if you want to recreate them later
      flipAnimations.current = [];
      slideAnimations.current = [];
      opacities.current = [];
      flipAnimations2.current = [];
      slideAnimations2.current = [];
      opacities2.current = [];
      flipAnimations3.current = [];
      slideAnimations3.current = [];
      opacities3.current = [];

      return;
    }
  };








  //socket - game play (table)
  useEffect(() => {
    if (!replayData?.replay?.length) return;
 
    console.log(
      'call to updates using global socket inside table.js',
       currentAction,replayData?.replay,replayData?.replay?.[currentAction]?.type ,replayData?.replay?.[currentAction]?.message
    );

    const handleTableUpdated = data => {
      try {
        setLastSocketEvent(TABLE_UPDATED);
        //console.log('TABLEUPDATED listeners:', socket.listeners().length);

        const { table, tableId, from, message, eventTimestamp } = data;

     
        if (Number(table?.id) == Number(currentTableId)) {
   console.log('-- onTableUpdated:', data);
        console.log(
          'before table update-------',
          Number(table?.id),
          Number(currentTableId),
        );
          if (eventTimestamp == lastEventTimeStamp) return;
          setLastEventTimeStamp(eventTimestamp);
          setTableReady(true);
          setShowPotInfo(true);

          setCurrentTable(table);

          setCurrentMessage(message);

          backSeatsRef.current = table.seats;
          if (
            tableData?.table?.tournamentId != null &&
            currentTour.breakRunning &&
            table?.pot == 0
          ) {
            setShowBreak(true);
          }
        }
      } catch (e) {
        console.log('tableUpdateException---', e);
      } finally {
        console.log('table---');
      }
    };

    const handleStraddleUpdate = data => {
      setLastSocketEvent(STRADDLE_UPDATE);

      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onStraddleUpdate:', data);
      console.log(
        'before table update-------',
        Number(table?.id),
        Number(currentTableId),
      );
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // If seats exist in the incoming `table` update
          if (table.seats) {
            // Ensure `updatedTable.seats` is initialized
            updatedTable.seats = { ...prevTables?.seats };

            // Iterate over each seat in the incoming `table.seats`
            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // ✅ if seat is null keep null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }
              // Update only the specific seat properties for `seatId`
              updatedTable.seats[seatId] = {
                ...(prevTables.seats[seatId] || {}), // Preserve previous seat values
                ...table.seats[seatId], // Apply only new updates for the seat
              };
            });
          }

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

    const handleBuyInCancel = data => {
      setLastSocketEvent(BUY_IN_CANCEL);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- on buyin cancel:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setShowMTTRebuy(false);
        setIsModalVisible({ ...isModalVisible, buyin: false });
      }
    };

    const handleRebuy = data => {
      setLastSocketEvent(TABLE_BUY_IN_RES);

      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onRebuy:', data);

      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        if (currentTableRef?.current?.tournamentId == null) {
          console.log('inside buyin');
          setIsModalVisible({ ...isModalVisible, buyin: true });
        } else {
          console.log('inside mtt buyin');
          setShowMTTRebuy(true);
        }

        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          if (table.seats) {
            Object.keys(prevTables.seats).forEach(seatId => {
              const updatedSeat = table.seats[seatId];

              if (updatedSeat) {
                // Merge: keep existing seat data, update only received fields
                updatedTable.seats[seatId] = {
                  ...(prevTables.seats[seatId] || {}),
                  ...updatedSeat,
                };
              }
            });
          }

          return updatedTable;
        });
        //   setCurrentTable(table);

        //   setCurrentMessage(message);
      }
    };

    const handleRealTimeResults = data => {
      setLastSocketEvent(REAL_TIME_RESULTS);

      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onRealTimeResults:', data);
      console.log(
        'before table update-------',
        Number(table?.id),
        Number(currentTableId),
      );
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });

        setCurrentMessage(message);
      }
    };
    const handleLeaveTable = data => {
      setLastSocketEvent(LEAVE_TABLE);

      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onLeaveTablle:', data);
      console.log(
        'before table update-------',
        Number(table?.id),
        Number(currentTableId),
      );
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        // setCurrentTable(table);
        // setCurrentMessage(message);
      }
    };

    const handleActionSitted = data => {
      setLastSocketEvent(ACTION_SITTED);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onActionSitted:', data, tableId);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // If seats exist in the incoming `table` update
          if (table.seats) {
            // Ensure seats initialized
            updatedTable.seats = { ...prevTables.seats };

            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // ✅ if seat is null keep null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }

              // destructure safely
              const { hand, ...restSeatUpdates } = seatData;

              updatedTable.seats[seatId] = {
                ...(prevTables.seats?.[seatId] ?? {}),
                ...restSeatUpdates,
              };
            });
          }
          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
        setCurrentMessage(message);
      }
    };

     const handleBettingAction = async data => {
      try {
        setLastSocketEvent(BETTING_ACTION);
        const { table, tableId, from, message, eventTimestamp } = data;
       
        console.log('-- onBettingAction:', data);
        if (Number(table?.id) == Number(currentTableId)) {
      if (eventTimestamp == lastEventTimeStamp) return;
        
         setLastEventTimeStamp(eventTimestamp);
          console.log(
            'before setting in temp------',
            Object.values(table?.Betting_Action?.Seat),
          );
          seatsTemp.current = Object.values(table?.Betting_Action?.Seat || {});
          console.log(seatsTemp.current);
          // --- Audio Trigger (after state update) ---
          const action = table?.Betting_Action?.Action;
          if (action) {
            if (action === 'CHECK') {
              playAudio('checkAction');
            } else if (action === 'FOLD') {
              setFlash(true);
              playAudio('foldAction');
            } else {
              playAudio('bet');
            }
          }
          setRaiseCompVisible({
            multiplier: false,
            keypad: false,
            slider: false,
          });
          setIsModalVisible({ ...isModalVisible, raise: false });
        

          setCurrentTable(prevTables => {
            // Start with a copy of `prevTables`
            const updatedTable = { ...prevTables };

            // If seats exist in the incoming `table` update
            if (table?.Betting_Action?.Seat) {
              // Iterate over each seat in the incoming `table.seats`
              if (
                updatedTable?.seats &&
                typeof updatedTable.seats === 'object'
              ) {
                Object.keys(updatedTable?.seats).forEach(seatId => {
                  if (seatId && updatedTable.seats[seatId] != null) {
                    updatedTable.seats[seatId] = {
                      ...(prevTables.seats[seatId] || {}),
                      ...(table.Betting_Action.Seat?.[seatId] || {}), // Only apply if it exists

                      ...table.Betting_Action.Seat?.[seatId],
                      turn: false,
                    };
                  }
                });
              }
            }

            // Update other properties in `table`, if any
            Object.keys(table).forEach(key => {
              if (key !== 'seats') {
                if (key == 'Next_Action') {
                  if (table?.Next_Action?.turn) {
                    updatedTable['turn'] = table?.Next_Action?.turn;
                  }
                  if (table?.Next_Action?.remainingTime) {
                    updatedTable['remainingTime'] =
                      table?.Next_Action?.remainingTime;
                  }
                }
                if (key == 'Other') {
                  updatedTable['callAmount'] = table?.Other?.callAmount;

                  // if (table?.Other?.pot) updatedTable['pot'] = table?.Other?.pot;
                  if (table?.Other?.turnExp)
                    updatedTable['turnExp'] = table?.Other?.turnExp;
                  if (table?.Other?.actionBy)
                    updatedTable['actionBy'] = table?.Other?.actionBy;

                  if (table?.Other?.prevStep)
                    updatedTable['prevStep'] = table?.Other?.prevStep;
                  if (table?.Other?.minRaise)
                    updatedTable['minRaise'] = table?.Other?.minRaise;

                  if (table?.Other?.minBet)
                    updatedTable['minBet'] = table?.Other?.minBet;

                  // if (table?.Other?.sidePots)
                  //   updatedTable['sidePots'] = table?.Other?.sidePots;

                  if (table?.Other?.depositSidePot)
                    updatedTable['depositSidePot'] =
                      table?.Other?.depositSidePot;

                  console.log(
                    'round changes betting action-----',
                    table?.Other?.isRoundChanging,
                  );
                  if (table?.Other?.isRoundChanging)
                    updatedTable['isRoundChanging'] =
                      table?.Other?.isRoundChanging;

                  if (table?.Other?.seatsToActLength)
                    updatedTable['seatsToActLength'] =
                      table?.Other?.seatsToActLength;

                  if (table?.Other?.endBeforeShowDown)
                    updatedTable['endBeforeShowDown'] =
                      table?.Other?.endBeforeShowDown;

                  if (table?.Other?.tablePot)
                    updatedTable['tablePot'] = table?.Other?.tablePot;
                }
              }
            });

            return updatedTable;
          });

          if (
            !table?.isRoundChanging &&
            table?.turn != null &&
            !table.handOver
          ) {
            if (table?.turn == myPlayer?.id) {
              playAudio('turnReceive');
            }
          }

          setCurrentMessage(message);
        }
      } catch (e) {
        console.log('betting action error----------', e);
      }
    };

    const handleSeatExit = data => {
      setLastSocketEvent(SEAT_EXIT_TABLE);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onActionSeatExit:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prev => {
          if (!table?.seats) return prev;

          const updated = {
            ...prev,
            seats: { ...prev?.seats },
          };

          Object.keys(table.seats).forEach(seatId => {
            const incoming = table.seats[seatId];

            // CASE 1: seat is null -> clear it
            if (incoming === null) {
              updated.seats[seatId] = null;
              return;
            }
          });

          return updated;
        });

        setCurrentMessage(message);
      }
    };

    const handleSeatUpdate = data => {
      setLastSocketEvent(SEATS_UPDATE);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onActionSeatUpdate:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTable => {
          let seatsChanged = false;

          const newSeats = { ...prevTable.seats };

          if (table.seats) {
            Object.entries(table.seats).forEach(([seatId, updatedSeat]) => {
              if (!updatedSeat) return;

              const prevSeat = prevTable.seats?.[seatId] || {};

              // 🔑 shallow compare only incoming keys
              const hasChange = Object.keys(updatedSeat).some(
                key => prevSeat[key] !== updatedSeat[key],
              );

              if (hasChange) {
                seatsChanged = true;
                newSeats[seatId] = {
                  ...prevSeat,
                  ...updatedSeat,
                };
              }
            });
          }

          // 🔥 NOTHING changed → return same object (NO re-render)
          if (!seatsChanged) return prevTable;

          return {
            ...prevTable,
            seats: newSeats,
          };
        });

        if (message.toLowerCase().includes('sitting out')) {
          console.log('Yes, it contains sitting out');
          setFlash(true);
        }
        if (
          message == 'You will stand up after this hand' ||
          message == 'You canceled standing up' ||
          message == 'Stood up successfully'
        ) {
          setMsg(message);
          setAlertVisible(true);
        }
        setCurrentMessage(message);
      }
    };
    const handleSeatsRebuy = data => {
      setLastSocketEvent(SEATS_REBUY);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onActionSeatsRebuy:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          if (table.seats) {
            Object.keys(prevTables.seats).forEach(seatId => {
              const updatedSeat = table.seats[seatId];

              if (updatedSeat) {
                // Merge: keep existing seat data, update only received fields
                updatedTable.seats[seatId] = {
                  ...(prevTables.seats[seatId] || {}),
                  ...updatedSeat,
                };
              }
            });
          }

          return updatedTable;
        });
      }
    };

    const handleSwitchTable = data => {
      setLastSocketEvent(SWITCH_TABLE);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onSwitchtable:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        setMyplayer(null);
        setCurrentTable(table);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          if (table.seats) {
            Object.keys(prevTables.seats).forEach(seatId => {
              const updatedSeat = table.seats[seatId];

              if (updatedSeat) {
                // Merge: keep existing seat data, update only received fields
                updatedTable.seats[seatId] = {
                  ...(prevTables.seats[seatId] || {}),
                  ...updatedSeat,
                };
              }
            });
          }

          return updatedTable;
        });
      }
    };

    const handleSushiStart = data => {
      setLastSocketEvent(SUSHI_START);
      const { table, tableId, from, message, eventTimestamp } = data;

      console.log('-- onActionSuhsiStart:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          if (table.seats) {
            // Ensure seats initialized
            updatedTable.seats = { ...prevTables.seats };

            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // ✅ if seat is null keep null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }

              // destructure safely
              const { hand, ...restSeatUpdates } = seatData;

              updatedTable.seats[seatId] = {
                ...(prevTables.seats?.[seatId] ?? {}),
                ...restSeatUpdates,
              };
            });
          }

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });

        setCurrentMessage(message);
      }
    };

    const handleBBPosted = data => {
      setLastSocketEvent(BB_POSTED);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('-- onBBPosted', data);

      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTable => {
          let seatsChanged = false;

          const newSeats = { ...prevTable.seats };

          if (table.seats) {
            Object.entries(table.seats).forEach(([seatId, updatedSeat]) => {
              if (!updatedSeat) return;

              const prevSeat = prevTable.seats?.[seatId] || {};

              // 🔑 shallow compare only incoming keys
              const hasChange = Object.keys(updatedSeat).some(
                key => prevSeat[key] !== updatedSeat[key],
              );

              if (hasChange) {
                seatsChanged = true;
                newSeats[seatId] = {
                  ...prevSeat,
                  ...updatedSeat,
                };
              }
            });
          }

          // 🔥 NOTHING changed → return same object (NO re-render)
          if (!seatsChanged) return prevTable;

          return {
            ...prevTable,
            seats: newSeats,
          };
        });

        setCurrentMessage(message);
      }
    };

    const handleEndHand = async data => {
      setLastSocketEvent(END_HAND);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('-- onActionEndHand:', data);
      console.log(
        'is end without showdown----------',
        data?.table?.isEndWithoutShowDown,
      );

      //take replica of of current table before round changed
      // const oldCopy = JSON.parse(JSON.stringify(currentTableRef.current));
      // setCurrentTableReplica(oldCopy);

      // if (
      //   Number(table?.id) == Number(currentTableId) &&
      //   table?.isEndWithoutShowDown
      // ) {
      //   await slideSeatToPot();
      // }
      if (Number(table?.id) === Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setIsInsuranceAnimationCompleted(false);
        setIsPlayCrackCard(false);
      }

      setTimeout(() => {
        if (Number(table?.id) === Number(currentTableId)) {
          // console.log("crack condition ",
          //      table.insuranceLosers.length > 0,
          //   table.insuranceLosers.length ,currentTable?.insuranceLosers.length
          // )
          // if (
          //   table.insuranceLosers.length > 0 &&
          //   table.insuranceLosers.length > currentTable?.insuranceLosers.length
          // ) {
          //   setIsPlayCrackCard(true);
          // }
          setCurrentTable(prevTables => {
            const updatedTable = { ...prevTables };

            // Object.keys(table?.seats).forEach(seatId => {
            //   if (prevTables?.seats?.[seatId]) {
            //     // Destructure to exclude `last_action` and `stack`
            //     let cleanedSeatData;

            //     if (!table.isEndWithoutShowDown) {
            //       const { stack, ...rest } = table.seats[seatId];
            //       cleanedSeatData = rest;
            //     } else {
            //       const { hand, stack, ...rest } = table.seats[seatId];
            //       // Include everything if showdown happened
            //       cleanedSeatData = rest;
            //     }

            //     updatedTable.seats[seatId] = {
            //       ...prevTables.seats[seatId],
            //       ...cleanedSeatData,
            //     };
            //   }
            // });

            Object.keys(table).forEach(key => {
              if (
                key !== 'seats' &&
                key !== 'board' &&
                key !== 'board2' &&
                key !== 'board3'
              ) {
                updatedTable[key] = table[key];
              }
            });

            return updatedTable;
          });

          setCurrentWinDetails(table);
          setCurrentMessage(message);
          setFlash(true);

          //play ko Bounty
          //loser seats (stack 0)
          let koBountyTimeout;
          const seatKeys = Object.keys(table?.seats).filter(
            i => Number(table?.seats[i]?.stack) === 0,
          );

          //check my Player Earn Ko
          const isMatched = Object.keys(table?.seats || {}).some(i => {
            const player = table?.seats[i];

            return (
              player?.player?.id.toString() == user?.user?.id.toString() &&
              player?.koBountyEarn > 0
            );
          });
          if (isMatched) {
            setMyplayerKoEarn(true);
          }

          //  only 1 main pot winner
          const mainPotWinners = table?.winDetails?.filter(
            e => e.pot === 'mainpot',
          );

          if (mainPotWinners.length == 1 && seatKeys.length > 0) {
            //show Ko Bounty animations
            if (
              tableData?.table?.tournamentId != null &&
              currentTour?.koBounty
            ) {
              if (!koBountyPlayedRef.current) {
                console.log('call to show kobounty');
                koBountyPlayedRef.current = true;
                setIsPlayKoBounty(true);

                clearTimeout(koBountyTimeout);
                koBountyTimeout = setTimeout(() => {
                  setIsPlayKoBounty(false);
                }, 1000);
              }
            }
          }
        }
      }, 1000);
    };

    const handleAckEndHand = data => {
      setLastSocketEvent(ACK_END_HAND);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('--onAckEndHand:', data);

      if (Number(table?.id) === Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        if (!table?.endBeforeShowDown && !table.isEndWithoutShowDown) {
          slideSeatToPotEnd();
        }
        if (table?.isEndWithoutShowDown) {
          slideSeatToPot();
        }

        setCurrentTable(prevTables => {
          const updatedTable = {
            ...prevTables,
            seats: { ...prevTables?.seats },
          };

          Object.keys(table?.seats || {}).forEach(seatId => {
            const seat = table?.seats?.[seatId];

            if (!seat) {
              return; // seat is null (player left)
            }
            if (prevTables?.seats?.[seatId]) {
              let cleanedSeatData;

              if (!table.isEndWithoutShowDown) {
                const { stack, bet, lastAction, earnSquid, mttRank, ...rest } =
                  table.seats[seatId];
                cleanedSeatData = rest;
              } else {
                const {
                  hand,
                  bet,
                  stack,
                  lastAction,
                  earnSquid,
                  mttRank,
                  ...rest
                } = table.seats[seatId];
                cleanedSeatData = rest;
              }

              updatedTable.seats[seatId] = {
                ...prevTables.seats[seatId],
                ...cleanedSeatData,
              };
            }
          });

          // Copy other table props except seats
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });

        setCurrentMessage(message);
      }
    };

    const handleInsurancePurchase = data => {
      try {
        setLastSocketEvent(INSURANCE_PURCHASED);
        console.log('--onInsurancePurchased:', data);

        const { table, eventTimestamp } = data;
        if (Number(table?.id) === Number(currentTableId)) {
          if (eventTimestamp == lastEventTimeStamp) return;
          setLastEventTimeStamp(eventTimestamp);
          //check if multiple pots favbourite switch to next pot
          //where not purchaseed

          setCurrentTable(prevTables => {
            const updatedTable = { ...prevTables };

            if (table.seats) {
              backSeatsRef.current = table.seats;
              updatedTable.seats = { ...prevTables.seats };

              Object.keys(table.seats).forEach(seatId => {
                const seat = table?.seats?.[seatId];

                if (!seat) {
                  return; // seat is null (player left)
                }
                updatedTable.seats[seatId] = {
                  ...(prevTables.seats?.[seatId] || {}),
                  insuranceLastAction: table.seats[seatId]?.insuranceLastAction,
                  insurance: table.seats[seatId]?.insurance, //
                };
              });
            }

            // Update other properties in `table`, if any
            Object.keys(table).forEach(key => {
              if (key !== 'seats') {
                updatedTable[key] = table[key];
              }
            });

            return updatedTable;
          });
        }
      } catch (e) {
        console.log('error while insurance purchase update -----', e);
      }
    };
    const handleInsuranceClaim = data => {
      try {
        setLastSocketEvent(INSURANCE_CLAIM);
        console.log('--onInsuranceClaim:', data);

        const { table, eventTimestamp } = data;

        if (Number(table?.id) !== Number(currentTableId)) return;
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);

        setCurrentTable(prevTable => {
          const prevInsuranceLosersLen =
            prevTable?.insuranceLosers?.length ?? 0;

          const newInsuranceLosersLen = table?.insuranceLosers?.length ?? 0;
          console.log(
            'prevous and current',
            prevInsuranceLosersLen,
            newInsuranceLosersLen,
          );

          // ✅ Trigger crack card ONLY when new loser added
          if (
            newInsuranceLosersLen > 0 &&
            newInsuranceLosersLen > prevInsuranceLosersLen
          ) {
            console.log('yes call to crack card =->');
            setIsPlayCrackCard(true);
            setShowClaimReturn(true);
          } else {
            setIsPlayCrackCard(false);
            setIsInsuranceAnimationCompleted(false);
          }

          const updatedTable = { ...prevTable };

          // ✅ Update seats safely
          if (table.seats) {
            backSeatsRef.current = table.seats;
            updatedTable.seats = { ...prevTable?.seats };

            Object.keys(table.seats).forEach(seatId => {
              const seat = table?.seats?.[seatId];

              if (!seat) {
                return; // seat is null (player left)
              }
              updatedTable.seats[seatId] = {
                ...(prevTable?.seats?.[seatId] || {}),
                // stack: table.seats[seatId]?.stack,
              };
            });
          }

          // ✅ Update remaining table fields
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      } catch (e) {
        console.log('error while insurance claim update -----', e);
      }
    };

      const handleRoundChanged = data => {
      try {
        console.log('call to round chagned')
        setLastSocketEvent(ROUND_CHANGED);

        const { table, tableId, message, eventTimestamp } = data;

        //take replica of of current table before round changed
        if (Number(table?.id) == Number(currentTableId)) {
           if (eventTimestamp == lastEventTimeStamp) return;
        
         setLastEventTimeStamp(eventTimestamp);
          console.log(
            'before call to slide',
            currentTableRef.current?.isBombPot,
            currentTable?.board.length,
            currentTable?.bombValue,
          );

          if (currentTableRef.current?.isBombPot) {
            if (
              currentTableRef.current?.board.length == 0 &&
              currentTableRef.current?.bombValue > 0
            ) {
            } else {
              slideSeatToPot();
            }
          } else {
            console.log('inside trun yes animations');
            if (!table?.endBeforeShowDown) {
              slideSeatToPot();
            }

            if (
              table?.turn != null &&
              !table?.handOver &&
              !table?.endBeforeShowDown
            ) {
              setTimeout(() => {
                playAudio('turnReceive');
              }, 600);
            }
          }
        }

        console.log('-- onActionRoundChanged:', data);

        setTimeout(() => {
          if (Number(table?.id) == Number(currentTableId)) {
           
            animationCompleted.current = false;
            const prevTables = currentTableRef.current || {};

            const updatedTable = { ...prevTables };

            if (table.seats) {
              backSeatsRef.current = table.seats;
              updatedTable.seats = { ...prevTables.seats };

              Object.keys(table.seats).forEach(seatId => {
                const { handRank, handRank2, handRank3, stack, ...rest } =
                  table.seats[seatId];

                console.log('res copy to update--------', rest);

                updatedTable.seats[seatId] = {
                  ...(prevTables.seats?.[seatId] || {}),
                  ...rest, // update everything except handRank, handRank2, handRank3
                };
              });
            }
            // Handle other table keys
            const copyKeys = [
              'isRoundChanging',
              'seatsToActLength',
              'remainingTime',
              'turn',
              'callAmount',
              'turnExp',
              'pot',
              'sidePots',
              'tablePot',
              'isEndWithoutShowDown',
              'isAnyActionComplete',
              'endBeforeShowDown',
              'ritMsg',
              'insExp',
              'insMsg',
              'insAskDetails',
            ];

            copyKeys.forEach(key => {
              if (table[key] !== undefined) {
                updatedTable[key] = table[key];
              }
            });

            ['board', 'board2', 'board3'].forEach(key => {
              if (table[key]) {
                updatedTable[key] = updatedTable[key]
                  ? [...updatedTable[key], ...table[key]]
                  : [...table[key]];
              }
            });

            //         ['board', 'board2', 'board3'].forEach(key => {
            //   if (Array.isArray(table[key])) {
            //     updatedTable[key] = updatedTable[key] || [];

            //     table[key].forEach(card => {
            //       const exists = updatedTable[key].some(
            //         c => c.suit === card.suit && c.rank === card.rank
            //       );
            //       if (!exists) {
            //         updatedTable[key].push(card);
            //       }
            //     });
            //   }
            // });

            // Set both state and ref
            currentTableRef.current = updatedTable;

            setCurrentTable(updatedTable);

            setCurrentMessage(message);
            setCurrentSelectedPrePlay('');
           
          }
        }, 700);
      } catch (e) {
        console.log('error while round change data update=-----', e);
      }
    };

    const handleDepositRelease = data => {
      try {
        console.log('handle deposit release', data);
        setLastSocketEvent(DEPOSIT_RELEASE);
        const { table, tableId, message, eventTimestamp } = data;
        //take replica of of current table before round changed
        if (Number(table?.id) == Number(currentTableId)) {
          if (eventTimestamp == lastEventTimeStamp) return;
          setLastEventTimeStamp(eventTimestamp);

          const prevTables = currentTableRef.current || {};

          const updatedTable = { ...prevTables };

          if (table.seats) {
            updatedTable.seats = { ...prevTables.seats };

            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // keep null as null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }

              if (typeof seatData === 'object') {
                const { handRank, handRank2, handRank3, bet, hand, ...rest } =
                  table.seats[seatId];
                console.log('res copy to update--------', rest);
                updatedTable.seats[seatId] = {
                  ...(prevTables.seats?.[seatId] || {}),
                  ...rest, // update everything except handRank, handRank2, handRank3
                };
              }
            });
          }

          // Update other properties in `table`, if any
          // Handle other table keys
          const copyKeys = ['pot', 'sidePots', 'tablePot'];

          copyKeys.forEach(key => {
            if (table[key] !== undefined) {
              updatedTable[key] = table[key];
            }
          });

          // Set both state and ref
          currentTableRef.current = updatedTable;
          backSeatsRef.current = table.seats;
          setCurrentTable(updatedTable);

          setCurrentMessage(message);
        }
      } catch (e) {
        console.log('error while deposit release data update=-----', e);
      }
    };

    const handleBombpot = async data => {
      setLastSocketEvent(BOMB_POT);
      const { table, tableId, message, eventTimestamp } = data;

      console.log('-- onActionBombPot:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);

        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // If seats exist in the incoming `table` update
          if (table.seats) {
            // Ensure `updatedTable.seats` is initialized
            updatedTable.seats = { ...prevTables.seats };

            // Iterate over each seat in the incoming `table.seats`
            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // keep null as null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }

              // Update only the specific seat properties for `seatId`
              updatedTable.seats[seatId] = {
                ...(prevTables.seats[seatId] || {}), // Preserve previous seat values
                ...table.seats[seatId], // Apply only new updates for the seat
              };
            });
          }
          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable['turn'] = table?.turn;

              updatedTable.seats[table?.turn] = {
                ...updatedTable.seats[table?.turn], // Preserve current seat values
                turn: true, // Set 'turn' to true for the specific seat
              };
              //make other seat turn to false
            }
          });

          return updatedTable;
        });
      }
    };

    const handleSquidStart = async data => {
      setLastSocketEvent(SQUID_ROUND_START);
      const { table, tableId, message, eventTimestamp } = data;

      console.log('-- onActionSquidStart:', data);
      if (Number(table?.id) === Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          if (table?.seats) {
            // Ensure `updatedTable.seats` is initialized
            updatedTable.seats = { ...prevTables.seats };

            // Iterate over each seat in the incoming `table.seats`
            Object.keys(table?.seats).forEach(seatId => {
              // Update only the specific seat properties for `seatId`
              updatedTable.seats[seatId] = {
                ...(prevTables.seats[seatId] || {}), // Preserve previous seat values
                ...table.seats[seatId], // Apply only new updates for the seat
                bet: 0,
                hand: [],
              };
            });
          }

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });

        setSquidWinTxt(``);

        setShowSquidWin(false);
      }
    };

    const handleCardReveal = data => {
      setLastSocketEvent(CARD_REVEAL);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('-- onActionCardReveal:', currentTableId, data);

      if (Number(table?.id) === Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // If seats exist in the incoming `table` update
          if (table.seats) {
            // Ensure `updatedTable.seats` is initialized
            updatedTable.seats = { ...prevTables.seats };

            // Iterate over each seat in the incoming `table.seats`
            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // keep null as null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }

              if (typeof seatData === 'object') {
                if (table.seats[seatId]) {
                  // Destructure to exclude stack and bet
                  const { stack, bet, lastAction, ...restSeatData } =
                    table.seats[seatId];

                  updatedTable.seats[seatId] = {
                    ...(prevTables.seats?.[seatId] || {}), // Preserve old seat data
                    ...restSeatData, // Merge new data except stack and bet
                  };
                }
              }
            });
          }

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });

        slideSeatToPot();

        setCurrentMessage(message);
      }
    };

    const handleToggleStraddle = data => {
      setLastSocketEvent(TOGGLE_STRADDLE);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('-- onActionToggleStraddle:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // If seats exist in the incoming `table` update
          if (table.seats) {
            // Ensure `updatedTable.seats` is initialized
            updatedTable.seats = { ...prevTables.seats };

            // Iterate over each seat in the incoming `table.seats`
            Object.keys(table.seats).forEach(seatId => {
              // Update only the specific seat properties for `seatId`
              updatedTable.seats[seatId] = {
                ...(prevTables.seats[seatId] || {}), // Preserve previous seat values
                ...table.seats[seatId], // Apply only new updates for the seat
              };
            });
          }
          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
        setCurrentMessage(message);
      }
    };

    const handleGetRabbitCards = data => {
      setLastSocketEvent(GET_RABBIT_CARDS);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('-- onActionGetRabbitCards:', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key == 'board') {
              updatedTable[key] = updatedTable[key]
                ? [...updatedTable[key], ...table[key]]
                : [...table[key]];
            }
            if (key == 'board2') {
              updatedTable[key] = updatedTable[key]
                ? [...updatedTable[key], ...table[key]]
                : [...table[key]];
            }
            if (key == 'board3') {
              updatedTable[key] = updatedTable[key]
                ? [...updatedTable[key], ...table[key]]
                : [...table[key]];
            }
          });

          return updatedTable;
        });
        setCurrentMessage(message);
      }
    };

    const handleRITAskWinner = data => {
      setLastSocketEvent(RIT_ASK_WINNER);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onRitAskWinner----------', data);
      if (Number(table?.id) == Number(currentTableId)) {
       // if (eventTimestamp == lastEventTimeStamp) return;
        //setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

    
    const handleAskRisk = data => {
      setLastSocketEvent(RISK_CONTROL);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onRiskControl----------', data);
      if (Number(table?.id) == Number(currentTableId)) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

       const handleRiskStauts = data => {
    
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onRiskControl----------', data);
      if (Number(table?.id) == Number(currentTableId)) {
      
       
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

    const handleRITAskPlayer = data => {
      setLastSocketEvent(RIT_ASK_PLAYERS);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onRitAskPlayer----------', data);
      if (Number(table?.id) == Number(currentTableId)) {
        //if (eventTimestamp == lastEventTimeStamp) return;
      //  setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

    const handleRITStatus = data => {
      // setLastSocketEvent(RIT_STATUS);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onRitStatus----------', data);

      if (Number(table?.id) == Number(currentTableId)) {
        // if (eventTimestamp == lastEventTimeStamp) return;
        // setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

    const handleAskInsurance = data => {
      setLastSocketEvent(INSURANCE_ASK_WINNER);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onInsuranceAskPlayer----------', data);
      if (Number(table?.id) == Number(currentTableId)) {
        //  if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
           
          if (table.seats) {
            // Ensure seats initialized
            updatedTable.seats = { ...prevTables.seats };

            Object.keys(table.seats).forEach(seatId => {
              const seatData = table.seats[seatId];

              // ✅ if seat is null keep null
              if (seatData === null) {
                updatedTable.seats[seatId] = null;
                return;
              }

              // destructure safely
              const { hand, ...restSeatUpdates } = seatData;

              updatedTable.seats[seatId] = {
                ...(prevTables.seats?.[seatId] ?? {}),
                ...restSeatUpdates,
              };
            });
          }

          });

          return updatedTable;
        });
      }
    };

    const handleInsuranceStatus = data => {
      setLastSocketEvent(INSURANCE_STATUS);
      const { table, tableId, from, message, eventTimestamp } = data;
      console.log('onInsuranceStatus----------', data);

      if (
        Number(table?.id) == Number(currentTableId) &&
        lastScoketEvent != INSURANCE_ASK_WINNER
      ) {
        if (eventTimestamp == lastEventTimeStamp) return;
        setLastEventTimeStamp(eventTimestamp);
        setCurrentTable(prevTables => {
          // Start with a copy of `prevTables`
          const updatedTable = { ...prevTables };
          if (table.seats) {
            backSeatsRef.current = table.seats;
            updatedTable.seats = { ...prevTables.seats };

            Object.keys(table.seats).forEach(seatId => {
              const seat = table?.seats?.[seatId];

              if (!seat) {
                return; // seat is null (player left)
              }
              updatedTable.seats[seatId] = {
                ...(prevTables.seats?.[seatId] || {}),
              };
            });
          }

          // Update other properties in `table`, if any
          Object.keys(table).forEach(key => {
            if (key !== 'seats') {
              updatedTable[key] = table[key];
            }
          });

          return updatedTable;
        });
      }
    };

    let type = replayData?.replay?.[currentAction]?.type;
    console.log("type ---",type)

    if (type == TABLE_UPDATED) {
      handleTableUpdated(replayData?.replay?.[currentAction]);
    }
    if (!currentTable?.seats) {
      return;
    }

   
    if (type == ACTION_SITTED) {
      handleActionSitted(replayData?.replay?.[currentAction]);
    }

    if (type == BETTING_ACTION) {
      handleBettingAction(replayData?.replay?.[currentAction]);
    }

    if (type == ROUND_CHANGED) {
      handleRoundChanged(replayData?.replay?.[currentAction]);
    }

    if (type == DEPOSIT_RELEASE) {
      handleDepositRelease(replayData?.replay?.[currentAction]);
    }

    if (type == SEAT_EXIT_TABLE) {
      handleSeatExit(replayData?.replay?.[currentAction]);
    }

    if (type == SEATS_UPDATE) {
      handleSeatUpdate(replayData?.replay?.[currentAction]);
    }
    if (type == CARD_REVEAL) {
      handleCardReveal(replayData?.replay?.[currentAction]);
    }

    if (type == GET_RABBIT_CARDS) {
      handleGetRabbitCards(replayData?.replay?.[currentAction]);
    }

    if (type == END_HAND) {
      handleEndHand(replayData?.replay?.[currentAction]);
    }
    if (type == BB_POSTED) {
      handleBBPosted(replayData?.replay?.[currentAction]);
    }

    if (type == REAL_TIME_RESULTS) {
      handleRealTimeResults(replayData?.replay?.[currentAction]);
    }

    if (type == LEAVE_TABLE) {
      handleLeaveTable(replayData?.replay?.[currentAction]);
    }

    if (type == TABLE_BUY_IN_RES) {
      handleRebuy(replayData?.replay?.[currentAction]);
    }
    if (type == BUY_IN_CANCEL) {
      handleBuyInCancel(replayData?.replay?.[currentAction]);
    }

    if (type == ACK_END_HAND) {
      handleAckEndHand(replayData?.replay?.[currentAction]);
    }
    if (type == ACK_END_HAND) {
      handleAckEndHand(replayData?.replay?.[currentAction]);
    }

    if (type == STRADDLE_UPDATE) {
      handleStraddleUpdate(replayData?.replay?.[currentAction]);
    }

    if (type == BOMB_POT) {
      handleBombpot(replayData?.replay?.[currentAction]);
    }

    if (type == RIT_ASK_WINNER) {
      handleRITAskWinner(replayData?.replay?.[currentAction]);
    }
     if (type == RISK_CONTROL) {
      handleAskRisk(replayData?.replay?.[currentAction]);
    }

    if (type == RISK_STATUS) {
      handleRiskStauts(replayData?.replay?.[currentAction]);
    }
    if (type == RIT_ASK_PLAYERS) {
      handleRITAskPlayer(replayData?.replay?.[currentAction]);
    }

    if (type == RIT_STATUS) {
      handleRITStatus(replayData?.replay?.[currentAction]);
    }

    if (type == GET_TABLE) {
      handleTableUpdated(replayData?.replay?.[currentAction]);
    }

    if (type == SUSHI_START) {
      handleSushiStart(replayData?.replay?.[currentAction]);
    }

    if (type == SQUID_ROUND_START) {
      handleSquidStart(replayData?.replay?.[currentAction]);
    }

    if (type == INSURANCE_ASK_WINNER) {
      handleAskInsurance(replayData?.replay?.[currentAction]);
    }

    if (type == INSURANCE_STATUS) {
      handleInsuranceStatus(replayData?.replay?.[currentAction]);
    }

    if (type == INSURANCE_PURCHASED) {
      handleInsurancePurchase(replayData?.replay?.[currentAction]);
    }

    if (type == INSURANCE_CLAIM) {
      handleInsuranceClaim(replayData?.replay?.[currentAction]);
    }

    if (type == SEATS_REBUY) {
      handleSeatsRebuy(replayData?.replay?.[currentAction]);
    }
    if (type == SWITCH_TABLE) {
      handleSwitchTable(replayData?.replay?.[currentAction]);
    }
  }, [currentAction]);

  //socket - game play (tournament)
//   useEffect(() => {
//     console.log(
//       'call to updates using global socket inside table.js',
//       tableData,
//     );

//     const handleTournamentJoined = data => {
//       try {
//         setLastSocketEvent(JOINED_TOURNAMENT);
//         // console.log('JOINED_TOURNAMENT listeners:', socket.listeners().length);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//           setFinalTime(tour?.startAt);
//         }

//         console.log('-- onTournamentJoined:', data);
//       } catch (e) {
//         console.log('onTournamentJoined---', e);
//       } finally {
//         console.log('onTournamentJoined---');
//       }
//     };
//     const handleTournamentRemoved = data => {
//       try {
//         // setLastSocketEvent(MTT_PLAYERS_REMOVED);
//         console.log('MTT_PLAYERS_REMOVED:', data);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           // Split values
//           console.log('yes inside block MTT_PLAYERS_REMOVED');

//           const [isActive, currentTableId, tableIdsStr] = message.split('-');

//           // Convert if needed
//           const activeStatus = isActive === 'true';
//           const parsedTableIds = tableIdsStr ? tableIdsStr.split(',') : [];

//           console.log('activeStatus', activeStatus);
//           console.log('parsedTableIds', parsedTableIds);
//           console.log('currentTableId', currentTableId);

//           if (!activeStatus) {
//             const socket = getSocket();
//             if (!socket) return;
//             socket.emit(DO_SWITCH_TABLE, {
//               fromTableId: currentTableId,
//               toTableId: parsedTableIds,
//             });
//           } else {
//             const socket = getSocket();
//             if (!socket) return;
//             socket.emit(DO_SWITCH_TABLE, {
//               fromTableId: currentTableId,
//               toTableId: parsedTableIds,
//             });

//             if (
//               currentTour?.currentLevel > currentTour?.lateRegistrationLevel
//             ) {
//               setTimeout(() => {
//                 navigation.navigate('RunnerRanking', {
//                   tournamentId: tableData?.table?.tournamentId,
//                 });
//               }, 1200);
//             }
//           }
//         }

//         console.log('-- fromtournament removed:', data);
//       } catch (e) {
//         console.log('fromtournament removed error---', e);
//       } finally {
//         console.log('fromtournament removed---');
//       }
//     };

//     const handleTorunamentEnd = data => {
//       try {
//         setLastSocketEvent(TOURNAMENT_END);
//         // console.log('JOINED_TOURNAMENT listeners:', socket.listeners().length);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           const socket = getSocket();

//           if (!socket) {
//             return;
//           }
//           socket.emit(LEAVE_TABLE, currentTableId);
//           if (tableData?.table?.clubId) {
//             dispatch(removeClubTable({ id: currentTableId }));
//           } else {
//             dispatch(removeTable({ id: currentTableId }));
//           }
//           dispatch(deleteTableGlobal({ tableId: currentTableId }));

//           if (myPlayer?.mttRank > 0) {
//             navigation.replace('MyRanking', {
//               tournamentId: tableData?.table?.tournamentId,
//             });
//           } else {
//             navigation.replace('MttRanking', {
//               tournamentId: tableData?.table?.tournamentId,
//             });
//           }
//         }

//         console.log('-- onTournamentJoined:', data);
//       } catch (e) {
//         console.log('onTournamentJoined---', e);
//       } finally {
//         console.log('onTournamentJoined---');
//       }
//     };

//     const handleAddonWillStart = data => {
//       try {
//         setLastSocketEvent(ADDON_WILL_START);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setMsg('Add-on period after this hand');
//           setAlertVisible(true);
//           setCurrentTour(tour);
//           setShowAIcon(true);
//         }

//         console.log('-- onAddonWillStart:', data);
//       } catch (e) {
//         console.log('onAddonWillStart---', e);
//       } finally {
//         console.log('onAddonWillStart---');
//       }
//     };

//     const handleAddonStarted = data => {
//       try {
//         setLastSocketEvent(ADDON_STARTED);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//           resetGame();
//         }

//         console.log('-- onAddonStarted:', data);
//       } catch (e) {
//         console.log('onAddonStarted---', e);
//       } finally {
//         console.log('onAddonStarted---');
//       }
//     };

//     const handleAddonEnd = data => {
//       try {
//         setLastSocketEvent(ADDON_END);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//           setShowAddOn(false);
//         }

//         console.log('-- onAddonEnd:', data);
//       } catch (e) {
//         console.log('onAddonEnd---', e);
//       } finally {
//         console.log('onAddonEnd---');
//       }
//     };

//     const handleFTDealUpdate = data => {
//       try {
//         setLastSocketEvent(FTDEAL_UPDATE);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           if (message == 'FT-DEAL-CANCEL') {
//             setMsg('A player refuses to deal, the game continues.');
//             setAlertVisible(true);
//           }
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//         }

//         console.log('-- onFTDEALUpdate:', data);
//       } catch (e) {
//         console.log('onFTDEALUpdate---', e);
//       } finally {
//         console.log('onFTDEALUpdate---');
//       }
//     };

//     const handleFTDealAsk = data => {
//       try {
//         setLastSocketEvent(FTDEAL_ASK);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//         }

//         console.log('-- onFTDEALAsk:', data);
//       } catch (e) {
//         console.log('onFTDEALAsk---', e);
//       } finally {
//         console.log('onFTDEALAsk---');
//       }
//     };

//     const handleBreakStart = data => {
//       try {
//         setLastSocketEvent(BREAK_START);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//           if (!tableData?.table?.handOver) {
//             setMsg('Break time after this hand');
//             setAlertVisible(true);
//           }
//         }

//         console.log('-- onBreakStart:', data);
//       } catch (e) {
//         console.log('onBreakStart---', e);
//       } finally {
//         console.log('onBreakStart---');
//       }
//     };

//     const handleBreakEnd = data => {
//       try {
//         setLastSocketEvent(BREAK_END);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//         }

//         console.log('-- onBreakEnd:', data);
//       } catch (e) {
//         console.log('onBreakEnd---', e);
//       } finally {
//         console.log('onBreakend---');
//       }
//     };

//     const handleTournamentDetails = data => {
//       try {
//         setLastSocketEvent(TOURNAMENT_DETAILS);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         console.log(
//           'received tour on table',
//           tour,
//           tour?.id?.toString() == tableData?.table?.tournamentId.toString(),
//         );
//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//           setFinalTime(tour?.startAt);

//           console.log('while setting final time', tour?.startAt);
//         }
//         console.log('-- onTournamentDetails:', data);
//       } catch (e) {
//         console.log('onTournamentDetails---', e);
//       } finally {
//         console.log('onTournamentDetails---');
//       }
//     };

//     const handleTournamentCancel = data => {
//       try {
//         setLastSocketEvent(TOURNAMENT_CANCELLED);

//         const { tour, from, message, eventTimestamp } = data;

//         console.log(
//           'before check MTT CANCEL----',
//           tour?.id?.toString(),
//           currentTable?.tournamentId.toString(),
//         );
//         if (tour?.id?.toString() == currentTable?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);
//           setMsg('Not enough players, Tourney cancelled');
//           setAlertVisible(true);
//           setTimeout(() => {
//             const socket = getSocket();

//             if (!socket) {
//               return;
//             }
//             socket.emit(LEAVE_TABLE, currentTableId);
//             if (currentTable?.clubId) {
//               dispatch(removeClubTable({ id: currentTableId }));
//             } else {
//               dispatch(removeTable({ id: currentTableId }));
//             }
//             dispatch(deleteTableGlobal({ tableId: currentTableId }));
//           }, 1000);
//         }
//         console.log('-- onTournamentCancelled:', data);
//       } catch (e) {
//         console.log('onTournamentCancelled---', e);
//       } finally {
//         console.log('onTournamentCancelled---');
//       }
//     };

//     const handleBubbleStart = data => {
//       try {
//         setLastSocketEvent(BUBBLE_STARTED);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);

//           setMttMsg('On the bubble');
//           setTimeout(() => {
//             setMttMsg('');
//           }, 1000);
//         }

//         console.log('-- onBubbleStart:', data);
//       } catch (e) {
//         console.log('onBubbleStart---', e);
//       } finally {
//         console.log('onBubbleStart---');
//       }
//     };

//     const handleITMStart = data => {
//       try {
//         setLastSocketEvent(ITM_STARTED);

//         const { tour, tableId, from, message, eventTimestamp } = data;

//         if (tour?.id?.toString() == tableData?.table?.tournamentId.toString()) {
//           if (eventTimestamp == lastEventMTTTimeStamp) return;
//           setLastEventMTTTimeStamp(eventTimestamp);
//           setCurrentTour(tour);

//           let itmTimeout;

//           if (!itmPlayedRef.current) {
//             console.log('call to show kobounty');
//             itmPlayedRef.current = true;
//             setIsPlayITM(true);

//             clearTimeout(itmTimeout);
//             itmTimeout = setTimeout(() => {
//               setIsPlayITM(false);
//             }, 1500);
//           }
//         }

//         console.log('-- onITMStart:', data);
//       } catch (e) {
//         console.log('onITMStart---', e);
//       } finally {
//         console.log('onITMStart---');
//       }
//     };

//     let mttType = tourData?.type;

//     //MTT

//     console.log('yes tour Data change lets go====', tourData, mttType);
//     if (mttType == JOINED_TOURNAMENT) {
//       handleTournamentJoined(tourData);
//     }

//     if (mttType == MTT_PLAYERS_REMOVED) {
//       handleTournamentRemoved(tourData);
//     }

//     if (mttType == TOURNAMENT_DETAILS) {
//       handleTournamentDetails(tourData);
//     }

//     if (mttType == TOURNAMENT_CANCELLED) {
//       handleTournamentCancel(tourData);
//     }
//     if (mttType == TOURNAMENT_END) {
//       handleTorunamentEnd(tourData);
//     }

//     if (mttType == ADDON_WILL_START) {
//       handleAddonWillStart(tourData);
//     }
//     if (mttType == ADDON_STARTED) {
//       handleAddonStarted(tourData);
//     }
//     if (mttType == ADDON_END) {
//       handleAddonEnd(tourData);
//     }
//     if (mttType == FTDEAL_UPDATE) {
//       handleFTDealUpdate(tourData);
//     }

//     if (mttType == FTDEAL_ASK) {
//       handleFTDealAsk(tourData);
//     }

//     if (mttType == BREAK_END) {
//       handleBreakEnd(tourData);
//     }
//     if (mttType == BREAK_START) {
//       handleBreakStart(tourData);
//     }

//     if (mttType == BUBBLE_STARTED) {
//       handleBubbleStart(tourData);
//     }

//     if (mttType == ITM_STARTED) {
//       handleITMStart(tourData);
//     }
//   }, [tourData]);



  //on current table data changes
  useEffect(() => {
    console.log('first effect--');
    if (!currentTable) return;

    currentTableRef.current = currentTable;

    if (currentTable?.turn == null) {
      setCurrentSelectedPrePlay('');
      //prePlayCall('');
      resetCompoenents();
    }

    if (currentTable?.winDetails?.length == 0) {
      console.log('call to reset game-----------------');
      resetGame();
    }

    setActionTime(currentTable?.actionTime);
    console.log('calling from here to layout');

    setNumberOfSeats(currentTable?.maxPlayers);

    setNumberOfCards(currentTable?.noOfHoleCards);
  }, [currentTable]);

  useEffect(() => {
    if (!currentTable || !calculateDone) return;

    const init = async () => {
      try {
        console.log('call to parent 1');
        console.log('Layout + table setup done, now initializing player');

        checkMyPlayer();

        // if (lastScoketEvent == SUSHI_START && currentTable?.isSushiDeposit) {
        //   slideSushiAllPlayers();
        // }

        //INSURANCE STATUS MSG
        if (currentTable?.insMsg) {
          console.log('currentTable insurance msg---->', currentTable?.insMsg);
          if (
            myPlayer == null ||
            checkMyAllInsuranceActionsTaken(myPlayer?.id)
          ) {
            setInsMsg(currentTable?.insMsg);
          } else {
            setInsMsg('');
          }
        } else {
          setInsMsg('');
        }

        if (currentTable?.insuranceLosers.length > 0) {
          if (lastScoketEvent == INSURANCE_CLAIM) {
            setIsInsuranceAnimationCompleted(false);
            if (isPlayCrackCard) {
              setTimeout(() => {
                setIsPlayCrackCard(false);
                setIsInsuranceAnimationCompleted(true);
              }, 800);
            }
          }
        }

        //END HAND

        // if (currentTable?.insuranceLosers.length > 0) {
        //   if (lastScoketEvent == END_HAND) {
        //     setIsInsuranceAnimationCompleted(false);
        //     if (isPlayCrackCard) {
        //       setTimeout(() => {
        //         setIsPlayCrackCard(false);
        //         setIsInsuranceAnimationCompleted(true);
        //       }, 800);
        //     }
        //   }
        // }

        //insurance
        if (lastScoketEvent == INSURANCE_PURCHASED) {
          console.log(
            'inside getting left pot to purchase mktest -------',
            myPlayer,
            myPlayer?.id,
          );

          // --------------------------------------------------
          // 2️⃣ Check if THIS player is a favourite seat
          // --------------------------------------------------
          const myFavSeatEntry = currentTable?.insAskDetails?.find(
            e => e?.favouriteSeat?.toString() === myPlayer?.id?.toString(),
          );

          if (!myFavSeatEntry) {
            // 🚫 Not eligible → never show modal
            setInsuranceModalVisible(false);
            return;
          }

          //already take all action
          function checkAllActionsTaken({ currentTable, myPlayer }) {
            if (!currentTable || !myPlayer) return false;

            const favSeatWithKey =
              currentTable?.insAskDetails?.map(e => ({
                key: e.key,
                seat: e.favouriteSeat,
              })) || [];

            const boardLen = currentTable?.board?.length;
            const gameRound =
              boardLen === 3 ? 'FLOP' : boardLen === 4 ? 'TURN' : null;

            if (!gameRound) return false;

            return favSeatWithKey.every(({ key, seat }) => {
              // only check for this player
              if (seat?.toString() !== myPlayer.id?.toString()) return true;

              // check if action exists
              return currentTable?.insuranceRoundWiseAction?.some(
                e =>
                  e.round === gameRound &&
                  e.pot === key &&
                  e.seatId?.toString() === seat?.toString(),
              );
            });
          }
          const allTaken = checkAllActionsTaken({
            currentTable,
            myPlayer,
          });

          if (allTaken) {
            setInsuranceModalVisible(false);
            return;
            console.log('✅ All insurance actions taken');
          } else {
            console.log('⏳ Waiting for remaining actions');
          }

          //take

          const favSeatWithKey = currentTable?.insAskDetails?.map(e => ({
            key: e.key,
            favouriteSeat: e.favouriteSeat,
          }));

          let gameRound = currentTable?.board.length == 3 ? 'FLOP' : 'TURN';

          //loop throgh
          for (let i = 0; i < favSeatWithKey.length; i++) {
            let key = favSeatWithKey[i].key;
            let seat = favSeatWithKey[i].favouriteSeat;

            if (seat.toString() == myPlayer?.id.toString()) {
              //check took action or not
              let tookAction = currentTable?.insuranceRoundWiseAction.filter(
                e =>
                  e.round == gameRound &&
                  e.pot == key &&
                  e.seatId.toString() == seat.toString(),
              );

              if (tookAction.length == 0) {
                const leftPot = currentTable?.insAskDetails?.filter(
                  e =>
                    e.key == key &&
                    e?.favouriteSeat?.toString() === myPlayer?.id?.toString() &&
                    e?.totalOuts > 0,
                );
                console.log('left pot------', leftPot);

                if (leftPot.length > 0) {
                  setChopCards(leftPot[0]?.chop);
                  setInsSelectedPot(leftPot[0].key);
                  const potAmount = Number(leftPot?.[0]?.amount);
                  const odd = Math.abs(Number(leftPot?.[0]?.odd));
                  const EPS = 0.01;

                  if (!potAmount || !odd) {
                    console.log('Invalid pot or odd', potAmount, odd);
                    return;
                  }

                  // Pot cap (TURN vs FLOP)
                  const potCap = potAmount; // FLOP

                  const turnMax = potAmount / 3; // TURN

                  // Raw premium (Xpoker uses pot first, odds second)
                  let premium = potCap / odd;
                  if (currentTable?.board?.length === 3) {
                    if (premium > turnMax) {
                      premium = turnMax;
                    }
                  }

                  //  Apply platform factor (0.83) AFTER cap
                  premium = premium * 0.8325;

                  //if turn round
                  // temp premium should be greather than flop premium

                  //check if insurance take of flop of pot

                  if (!Number.isInteger(premium)) {
                    premium = Number(premium.toFixed(2));
                  }
                  //  Final rounding
                  premium = Math.round(premium.toFixed(2));

                  // Claim calculation
                  const claim = Number((premium * odd).toFixed(2));

                  setPremium(premium);
                  setTempPremium(premium);
                  setIsValueChanged(true);
                  setClaim(formatNumber(claim));
                  setSliderINSKey(prev => prev + 1);
                  console.log('insurance modal showing step 1');
                  setInsuranceModalVisible(true);
                } else {
                  console.log('making false modal-----');

                  setInsuranceModalVisible(false);
                }
                return;
              } else {
              }
            }
          }
        }

        //squid winner update
        const currentLen = currentTable?.squidWinners?.length ?? 0;
        const prevLen = prevSquidWinnerLenRef.current;

        if (lastScoketEvent == STRADDLE_UPDATE) {
          if (currentTable?.isStraddlePerfomed) {
            console.log('call to play straddle audio-----');
            playAudio('straddle');
          }
        }

        //call to squid table animation
        if (currentTable?.isSquid && currentTable?.squidRunning) {
          showSquidTable();
        }

        //call to remove squid table animation
        if (currentTable?.isSquid && !currentTable?.squidRunning) {
          hideSquidTable();
        }

        //insurace claim return
        // if(currentTable?.insuranceLosers.length>0){
        //   setShowClaimReturn(true)
        // }

        if (
          currentTable?.isSquid &&
          currentTable?.squidWinDetails?.length == 0
        ) {
          setShowSquidSettlement(false);
        }
        //squid round win Msg
        if (
          currentTable?.isSquid &&
          currentTable?.handOver &&
          lastScoketEvent == END_HAND &&
          currentTable?.squidWinners?.length > 0 &&
          prevSquidWinnerLenRef.current != currentLen
        ) {
          let currentWinner = currentTable?.squidWinners?.find(
            e => e.round == currentTable?.squidCurrentCount + 1,
          )?.name;

          prevSquidWinnerLenRef.current = currentLen;

          const { winDetails } = currentWindetails;

          //get main pot winner seat and update last action
          const mainPotWinner = winDetails
            ?.filter(e => e?.pot?.toString().toLowerCase() == 'mainpot')
            ?.map(e => e?.seatId);

          if (mainPotWinner?.length == 1 && currentTable?.multiBoard == 1) {
            setSquidWinTxt(`${currentWinner} won a squid`);
            setShowSquidWin(true);
          }
        }

        //Squid start
        if (currentTable?.squidStart) {
          console.log('squid about to start ----------');
          setSquidWinTxt('Squid Game is about to start');
          setShowSquidWin(true);
        }

        if (currentMessage === 'New hand started') {
          //MTT

          //check ranking are avaialble
          //  if(currentTour?.rankings.length>0){
          //   setShowRanking(true);
          //  }
          setShowBreak(false);
          setSushiWinner([]);
          setRemainTimeFTDEAL(0);

          setShowClaimReturn(true);
          setInsuranceModalVisible(false);
          setShowSquidSettlement(false);
          //setTempPremium(0);
          bombPotPlayedRef.current = false;
          koBountyPlayedRef.current = false;
          itmPlayedRef.current = false;
          InsurancePlayedRef.current = false;
          setShowSushiDeposit(false);
          resetFlipAnims();

          if (!currentTable?.isBombPot && !currentTable?.isBombPotPerform) {
            playAudio('bet');
            playAudio('bet');
            playAudio('turnReceive');
          }

          lastAnimatedCard.current = 0;
          opacityBouunceL.setValue(0);

          animationCompleted.current = true;
          flipAnimShowDown.setValue(0);

          setShowdownReveal(false);
          setCurrentTableReplica(null);
          seatRanksRef.current = {}; // clear all seat ranks

          setIsMultiBoard(false);
          backSeatsRef.current = null;
          depositHandled.current = false;
          resetCompoenents();
          //resetOnNewGame();
          if (!currentTable?.isBombPot) {
            distributeCards(); // only after player is ready
          }

          if (currentTable?.isBombPot && lastScoketEvent == BOMB_POT) {
            distributeCards();
          }
          //if is bombpot and performing bomb explosion
          let bombPotTimeout;

          if (
            currentTable?.isBombPot &&
            currentTable?.isBombPotPerform &&
            lastScoketEvent == BOMB_POT &&
            !bombPotPlayedRef.current
          ) {
            console.log('call to show bombpot');
            bombPotPlayedRef.current = true;
            setIsPlayBombPot(true);
            playAudio('blast');

            clearTimeout(bombPotTimeout);
            bombPotTimeout = setTimeout(() => {
              setIsPlayBombPot(false);
            }, 800);
          }

          //sushi

          if (currentTable?.isSushi && currentTable?.isSushiDeposit) {
            setMsg('New Sushi round starts');
            setAlertVisible(true);
          }

          //Squid last
          if (
            currentTable?.isSquid &&
            currentTable?.squidRunning &&
            currentTable?.squidCurrentCount == 1
          ) {
            setSquidWinTxt('The last squid!');
            setShowSquidWin(true);
          }
        } else {
          setIsDistributed(true);
        }

        //RIT STATUS MSG
        if (currentTable?.ritMsg) {
          setRitMsg(currentTable?.ritMsg);
        } else {
          setRitMsg('');
        }

        // RISK STATUS MSG
        if (currentTable?.riskMsg) {
          setRiskMsg(currentTable?.riskMsg);
        } else {
          setRiskMsg('');
        }

        //ask for RIT CHOICE
        if (
          Object.keys(currentTable?.ritAskDetails ?? {}).length > 0 &&
          currentTable?.ritAskDetails?.to?.toString() == myPlayer?.id.toString()
        ) {
          console.log('found rit ask details-------', currentTable?.ritExp);

          if (!ritModalVisible && currentTable?.ritExp) {
            setRitModalVisible(true);
          }
        }
        if (
          currentTable?.ritExp == null ||
          currentTable?.ritAskDetails == {} ||
          currentTable?.ritAskDetails?.to?.toString() != myPlayer?.id.toString()
        ) {
          setRitModalVisible(false);
        }

        //Risk Control - RIT

          //ask for RIT CHOICE
        if (
          Object.keys(currentTable?.ritAskDetails ?? {}).length > 0 &&
          lastScoketEvent.toString() == RISK_CONTROL 
        ) {
          console.log('found rit ask details-------', currentTable?.ritExp);

          if (!ritModalVisible && currentTable?.riskExp) {
            setRiskModalVisible(true);
          }
        }
        if (
          currentTable?.riskExp == null ||
          currentTable?.ritAskDetails == {} 
          
        ) {
          setRiskModalVisible(false);
        }


        //Insurance

        // if (lastScoketEvent != INSURANCE_PURCHASED) {
        //   [...new Set(currentTable?.insAskDetails?.map(e => e?.favouriteSeat))];
        //   if (
        //     Object.keys(currentTable?.insAskDetails ?? {}).length > 0 &&
        //     [
        //       ...new Set(
        //         (currentTable?.insAskDetails ?? []).map(e =>
        //           String(e?.favouriteSeat),
        //         ),
        //       ),
        //     ].includes(String(myPlayer?.id))
        //   ) {
        //     console.log('found rit ask details-------', currentTable?.insExp);
        //     if (currentTable?.insExp) {
        //       let myPots = currentTable?.insAskDetails.filter(
        //         e =>
        //           String(e?.favouriteSeat) == String(myPlayer?.id) &&
        //           e.totalOuts > 0,
        //       );
        //       if (myPots.length > 0) {
        //         setChopCards(myPots[0]?.chop);
        //         setInsSelectedPot(myPots[0]?.key);

        //         const potAmount = Number(myPots?.[0]?.amount);
        //         const odd = Math.abs(Number(myPots?.[0]?.odd));
        //         const EPS = 0.01;

        //         if (!potAmount || !odd) {
        //           console.log('Invalid pot or odd', potAmount, odd);
        //           return;
        //         }

        //         // Pot cap (TURN vs FLOP)
        //         const potCap = potAmount; // FLOP

        //         const turnMax = potAmount / 3; // TURN

        //         // Raw premium (Xpoker uses pot first, odds second)
        //         let premium = potCap / odd;
        //         if (currentTable?.board?.length === 3) {
        //           if (premium > turnMax) {
        //             premium = turnMax;
        //           }
        //         }

        //         //  Apply platform factor (0.83) AFTER cap
        //         premium = premium * 0.8325;

        //         if (!Number.isInteger(premium)) {
        //           premium = Number(premium.toFixed(2));
        //         }

        //         //if already pay by backend
        //         if (
        //           currentTable?.board?.length === 4 &&
        //           Math.abs(
        //             Number(
        //               currentTable?.seats?.[myPlayer?.id]?.insurance
        //                 ?.find(
        //                   i => i.pot === myPots[0]?.key && i.round === 'FLOP',
        //                 )
        //                 ?.premium?.toFixed(2),
        //             ) -
        //               Math.round(
        //                 currentTable?.insAskDetails?.find(
        //                   e => e.key === myPots[0]?.key,
        //                 )?.maxPremium ?? 0,
        //               ) *
        //                 (currentTable?.insAskDetails?.find(
        //                   e => e.key === myPots[0]?.key,
        //                 )?.odd ?? 0),
        //           ) < 0.01
        //         ) {
        //           premium =
        //             currentTable?.insAskDetails?.find(
        //               e => e.key === myPots[0]?.key,
        //             )?.maxPremium ?? 0;
        //         }

        //         //  Final rounding
        //         premium = Math.round(premium.toFixed(2));

        //         // Claim calculation
        //         const claim = Number((premium * odd).toFixed(2));

        //         setPremium(premium);
        //         setTempPremium(premium);
        //         setIsValueChanged(true);

        //         setClaim(formatNumber(claim));

        //         setSliderINSKey(prev => prev + 1);
        //         console.log('set premium from init', premium);
        //       }
        //     }

        //     if (
        //       !InsuranceModalVisible &&
        //       currentTable?.insExp &&
        //       isAnyFavourite(myPlayer?.id) &&
        //       currentTable?.seats[myPlayer?.id]?.insuranceLastAction?.trim()
        //         ?.length == 0
        //     ) {
        //       console.log(
        //         'showing modal step 2',
        //         currentTable?.seats[myPlayer?.id]?.insuranceLastAction?.trim()
        //           ?.length,
        //       );
        //       setTimeout(() => {
        //         setShowKeypad(false);
        //         // setSliderINSKey(prev => prev + 1);
        //         console.log('insurance modal showing step 2');

        //         setInsuranceModalVisible(true);
        //       }, 500);
        //     }
        //   }
        // }

        // if (lastScoketEvent != INSURANCE_PURCHASED) {
        //   if (
        //     currentTable?.insExp == null ||
        //     currentTable?.insAskDetails.length == 0 ||
        //     ![
        //       ...new Set(
        //         (currentTable?.insAskDetails ?? []).map(e =>
        //           String(e?.favouriteSeat),
        //         ),
        //       ),
        //     ].includes(String(myPlayer?.id))
        //   ) {
        //     console.log('hiding modal');
        //
        //     setInsuranceModalVisible(false);
        //   }
        // }

        console.log(
          'before calling to turn timer-----------',
          currentTable?.handOver,
          currentTable?.turn,
        );

        //if my player action done clear pre play
        if (currentTable?.actionBy == myPlayer?.id) {
          setCurrentSelectedPrePlay('');
          //prePlayCall('');
        }

        console.log(
          'checks before turn timer ',
          currentTable?.handOver.toString(),
          (currentTable?.turn != null).toString(),
          currentTable?.isRoundChanging.toString(),
        );

        //pass empty if MTT
        if (
          (currentTable?.turn != null || currentTable?.turn == null) &&
          (currentTable?.isRoundChanging || currentTable?.handOver)
        ) {
          //sendRemainTime(tableIndex, 0);
        }

        if (
          !currentTable?.handOver &&
          currentTable?.turn != null &&
          !currentTable?.isRoundChanging &&
          lastScoketEvent != BB_POSTED &&
          lastScoketEvent != SEATS_UPDATE &&
          lastScoketEvent != ACTION_SITTED
        ) {
          setRemainTime(0);

          setRaiseBarValue(0);

          setTimerKey(prev => prev + 1); // trigger remount (unmount old slider)

          if (myPlayer?.id == currentTable?.turn) {
            btnClickRef.current = false;

            setRaiseCompVisible({
              ...isModalVisible,
              multiplier: true,
              raise: false,
              keypad: false,
            });

            //if my turn came mean no action take by preplay clear preplay
            setTimeout(() => {
              setCurrentSelectedPrePlay('');
              //prePlayCall('');
            }, 500);
          } else {
            setRaiseCompVisible({
              ...isModalVisible,
              multiplier: false,
              raise: false,
              keypad: false,
            });
            setIsModalVisible({ ...isModalVisible, raise: false });
          }
        }

        console.log(
          'before rabbit check-----------',
          currentTable?.isEndWithoutShowDown,
          currentTable?.board?.length < 5,
        );
        if (
          currentTable?.isEndWithoutShowDown &&
          currentTable?.board?.length < 5
        ) {
          console.log('setting rabbit button true--------', lastScoketEvent);
          if (
            //lastScoketEvent == ACK_END_HAND ||
            lastScoketEvent == END_HAND ||
            lastScoketEvent == TABLE_UPDATED
          ) {
            setShowRabbit(true);
          }
        }

        console.log('check current compoent --------', currentTable?.handOver);

        //deposit pot distribution
        if (
          currentTable?.handOver &&
          currentTable?.depositSidePot?.length > 0 &&
          !depositHandled.current
        ) {
          depositHandled.current = true; // Mark it handled
          //depositReturn();
        }

        if (currentTable?.handOver) {
          setRemainTime(0);

          resetCompoenents();
        }
      } catch (e) {
        console.log('error--------', e);
      }
    };

    init();
    // if (
    //   lastScoketEvent == TABLE_UPDATED ||
    //   lastScoketEvent == SEATS_UPDATE ||
    //   lastScoketEvent == SEAT_EXIT_TABLE
    // ) {
    //   const seatDetails = Object.values(currentTable?.seats ?? {}).map(seat => {
    //     if (!seat) return null;

    //     return {
    //       player: seat?.player ?? null,
    //       id: seat?.id ?? null,
    //       hand: seat?.hand ?? null,
    //     };
    //   });

    // const obj = {
    //   'gameType':currentTable?.gameType,
    //   'id': currentTable?.id,
    //   'actionTime':currentTable?.actionTime,
    //   'seats': seatDetails,
    // };

    // dispatch(
    //   updateTable({
    //     id: currentTableId,
    //     table: JSON.parse(JSON.stringify(obj)), // <-- deep copy the NEW object
    //     type: myPlayer == null ? 'temp' : 'perma',
    //   }),
    // );
    // }

    const seatsWithCard = Object.values(currentTable?.seats).filter(
      seat => seat && seat?.player,
    );
    if (seatsWithCard.length >= 2) {
      setShowDealer(true);
    }
  }, [currentTable, currentMessage, calculateDone]);

  // useEffect(() => {
  //   if (currentTable?.tournamentId) {
  //     console.log(
  //       'call to tournament join',
  //       currentTableId,
  //       currentTable?.tournamentId,
  //     );
  //     if (!currentTable) return;
  //     const socket = getSocket();
  //     if (!socket) return;
  //     socket.emit(JOIN_TOURNAMENT, Number(currentTable?.tournamentId));
  //     setTimeout(() => {
  //       socket.emit(GET_TOURNAMENT, Number(currentTable?.tournamentId));
  //     }, 100);
  //   }
  // }, [currentTable?.tournamentId]);

  //on Tournament change
  useEffect(() => {
    //start level timer
    // if (currentTour?.levelExp != null) {
    //   clearTimerMTTLevel();
    //   levelMTTTimer();
    // } else {
    //   clearTimerMTTLevel();
    // }

    //start FT-modal timer

    if (currentTour?.ftDealExp != null) {
      // only restart if value changed
      if (prevFTDealExpRef.current !== currentTour.ftDealExp) {
        if (myPlayer != null) {
          setShowFTModal2(true);
        }

        // update previous value
        prevFTDealExpRef.current = currentTour.ftDealExp;
      }
    } else {
      setShowFTModal2(false);

      prevFTDealExpRef.current = null;
    }

    //if all agrred dont show the modal FT-DEAL confirm
    const allAgreed = currentTour?.ftDeal?.players?.every(
      e => e?.dealAgreeStatus === 'AGREE',
    );

    if (allAgreed) {
      setShowFTModal2(false);

      setMttMsg('');
      prevFTDealExpRef.current = null;
    }

    // if agreed then show message waitinig for other
    if (
      currentTour?.ftDeal?.players?.filter(
        e =>
          e?.id?.toString() == user?.user?.id.toString() &&
          e?.dealAgreeStatus == 'AGREE',
      ).length > 0 &&
      currentTour?.ftDealExp != null
    ) {
      setShowFTModal2(false);
      setMttMsg('Please wait for others to confirm the deal');
    } else {
      setMttMsg('');
    }
  }, [currentTour]);

  useEffect(() => {
    seatPositionsRef.current = seatPositions;
  }, [seatPositions]);

  useEffect(() => {
    if (
      currentTable?.isInsurance &&
      (lastScoketEvent === INSURANCE_ASK_WINNER ||
        lastScoketEvent === INSURANCE_STATUS) &&
      currentTable?.insAskDetails?.length > 0
    ) {
      console.log('call to show insurance', lastScoketEvent);

      setIsPlayInsurance(true);

      setTimeout(() => {
        console.log('call to show insurance make hide');
        setIsPlayInsurance(false);
      }, 800);
    }
  }, [
    lastScoketEvent,
    currentTable?.isInsurance,
    currentTable?.insAskDetails?.length,
  ]);

  //turn blinker
  useEffect(() => {
    if (currentTable?.turn && blink) {
      Animated.loop(
        Animated.sequence([
          Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
          }),
          Animated.timing(fadeAnim, {
            toValue: 0.3,
            duration: 500,
            useNativeDriver: true,
          }),
        ]),
      ).start();
    } else {
      fadeAnim.setValue(0); // reset if not turn
    }
  }, [currentTable?.turn, myPlayer?.id, blink]);

  //checker short deck 6+
  const checkIsRaisedOrBet = () => {
    const seatRaised = Object.values(currentTable?.seats ?? {}).filter(
      seat =>
        seat?.player &&
        seat?.hand?.length > 0 &&
        ['BET', 'All-In'].includes(seat?.lastAction),
    );

    return seatRaised.length > 0;
  };

  // Move Earn Points to seat
  const slideToSeat = seatId => {
    setShowClaimReturn(false);
    // Normalize to array
    const seatIdArray = Array.isArray(seatId) ? seatId : [seatId];
    const uniqueSeatIdArray = [...new Set(seatIdArray)];
    console.log('seatIdArray------------------', seatIdArray);

    if (uniqueSeatIdArray.length > 0) {
      playAudio('winChipsReceive');
    }

    // Animate for each seatId
    uniqueSeatIdArray.forEach(seatId => {
      const target = seatPositions.find(e => e?.id == seatId);
      if (!target) return;

      const chipCount = 2;
      const centerX = Dimensions.get('window').width / 2 - 15; // chip center
      const centerY = Dimensions.get('window').height / 2 - 120;

      for (let i = 0; i < chipCount; i++) {
        const chipId = `${seatId}-${Date.now()}-${i}`;
        const animX = new Animated.Value(centerX);
        const animY = new Animated.Value(centerY);

        const newChip = {
          id: chipId,
          translateX: animX,
          translateY: animY,
        };

        setAnimatedChips(prev => [...prev, newChip]);

        // Animate each chip with staggered timing
        setTimeout(() => {
          Animated.parallel([
            Animated.timing(animX, {
              toValue: target.x,
              duration: 300,
              useNativeDriver: true,
            }),
            Animated.timing(animY, {
              toValue: target.y,
              duration: 300,
              useNativeDriver: true,
            }),
          ]).start(() => {
            // Remove chip after animation
            setAnimatedChips(prev => prev.filter(c => c.id !== chipId));
          });
        }, i * 50); // stagger per chip
      }
    });

    // Optional: one-time bounce animation (can be adjusted if you want per seat)
    translateY.setValue(-30);
    opacityBouunce.setValue(0);

    // Animated.timing(translateY, {
    //   toValue: 0,
    //   duration: 300,
    //   useNativeDriver: true,
    // }).start();
    Animated.parallel([
      Animated.spring(translateY, {
        toValue: -10,
        friction: 4, // more bounce
        tension: 70, // faster spring
        useNativeDriver: true,
      }),
      Animated.timing(opacityBouunce, {
        toValue: 1,
        duration: 150,
        useNativeDriver: true,
      }),
    ]).start();
  };

  const slideSushiAllPlayers = () => {
    playAudio('winChipsReceive');

    //  Find SB seat (Sushi Pot position)
    const sbSeat = Object.values(currentTable.seats).find(
      s => s?.id == currentTable?.SB,
    );
    if (!sbSeat) return;

    const sbTarget = seatPositions.find(e => e?.id == sbSeat.id);
    if (!sbTarget) return;

    const sbSushiLeft =
      rawPositions[numberOfSeats][sbTarget?.currentIndex]?.sushiLeft;

    const sbSushiTop =
      rawPositions[numberOfSeats][sbTarget?.currentIndex]?.sushiTop;

    const finalX = sbSushiLeft < 0 ? sbTarget.x - 48 : sbTarget.x + 48;
    const finalY =
      sbSushiTop < 0 ? sbTarget.y - sbSushiTop : sbTarget.y + sbSushiTop;

    const chipCount = 6;

    // 2️⃣ Loop ALL seats to move chips → SB Pot
    Object.values(currentTable.seats).forEach(seat => {
      if (!seat || seat?.player == null || !seat?.isBBPost || seat?.stack == 0)
        return;

      const target = seatPositions.find(e => e?.id == seat.id);
      if (!target) return;

      const centerX = target.x;
      const centerY = target.y + 60;

      for (let i = 0; i < chipCount; i++) {
        const chipId = `${seat.id}-${Date.now()}-${i}`;

        const animX = new Animated.Value(centerX);
        const animY = new Animated.Value(centerY);

        const newChip = {
          id: chipId,
          translateX: animX,
          translateY: animY,
        };

        setAnimatedChips(prev => [...prev, newChip]);

        setTimeout(() => {
          Animated.parallel([
            Animated.timing(animX, {
              toValue: finalX, // ⭐ EVERYONE moves to SB pot
              duration: 300,
              useNativeDriver: true,
            }),
            Animated.timing(animY, {
              toValue: finalY, // ⭐ vertical pot location
              duration: 300,
              useNativeDriver: true,
            }),
          ]).start(() => {
            setAnimatedChips(prev => prev.filter(c => c.id !== chipId));
          });
        }, i * 50);
      }
    });

    // 3️⃣ Bounce animation
    translateY.setValue(-48);
    opacityBouunce.setValue(0);

    Animated.parallel([
      Animated.spring(translateY, {
        toValue: 0,
        friction: 4,
        tension: 70,
        useNativeDriver: true,
      }),
      Animated.timing(opacityBouunce, {
        toValue: 1,
        duration: 300,
        useNativeDriver: true,
      }),
    ]).start();
  };

  const bounceLoserProfit = () => {
    // 3️⃣ Bounce animation
    translateYL.setValue(-30);
    opacityBouunceL.setValue(0);

    Animated.parallel([
      Animated.spring(translateYL, {
        toValue: -10,
        friction: 4,
        tension: 70,
        useNativeDriver: true,
      }),
      Animated.timing(opacityBouunceL, {
        toValue: 1,
        duration: 300,
        useNativeDriver: true,
      }),
    ]).start();
  };
  // Move Earn Points to seat
  const slideSushi = seatId => {
    // Normalize to array
    const seatIdArray = Array.isArray(seatId) ? seatId : [seatId];
    const uniqueSeatIdArray = [...new Set(seatIdArray)];
    console.log('seatIdArray------------------', seatIdArray);

    if (uniqueSeatIdArray.length > 0) {
      playAudio('winChipsReceive');
    }

    // Animate for each seatId
    uniqueSeatIdArray.forEach(seatId => {
      const target = seatPositions.find(e => e?.id == seatId);
      let sushiLeft =
        rawPositions[numberOfSeats][target?.currentIndex]?.sushiLeft;
      let sushiTop =
        rawPositions[numberOfSeats][target?.currentIndex]?.sushiTop;
      console.log('sushi left------');
      if (!target) return;

      const chipCount = 6;
      const centerX = target?.x; // chip center
      const centerY = target?.y + 60;

      for (let i = 0; i < chipCount; i++) {
        const chipId = `${seatId}-${Date.now()}-${i}`;
        const animX = new Animated.Value(centerX);
        const animY = new Animated.Value(centerY);

        const newChip = {
          id: chipId,
          translateX: animX,
          translateY: animY,
        };

        setAnimatedChips(prev => [...prev, newChip]);

        // Animate each chip with staggered timing
        setTimeout(() => {
          Animated.parallel([
            Animated.timing(animX, {
              toValue: sushiLeft < 0 ? target.x - 48 : target.x + 48,
              duration: 300,
              useNativeDriver: true,
            }),
            Animated.timing(animY, {
              toValue: sushiTop < 0 ? target.y - 40 : target.y + 40,
              duration: 300,
              useNativeDriver: true,
            }),
          ]).start(() => {
            // Remove chip after animation
            setAnimatedChips(prev => prev.filter(c => c.id !== chipId));
          });
        }, i * 50); // stagger per chip
      }
    });

    // Optional: one-time bounce animation (can be adjusted if you want per seat)
    translateY.setValue(-48);
    opacityBouunce.setValue(0);

    // Animated.timing(translateY, {
    //   toValue: 0,
    //   duration: 300,
    //   useNativeDriver: true,
    // }).start();
    Animated.parallel([
      Animated.spring(translateY, {
        toValue: -20,
        friction: 4, // more bounce
        tension: 70, // faster spring
        useNativeDriver: true,
      }),
      Animated.timing(opacityBouunce, {
        toValue: 1,
        duration: 300,
        useNativeDriver: true,
      }),
    ]).start();
  };

  const slideSushiWin = seatId => {
    const seatIdArray = Array.isArray(seatId) ? seatId : [seatId];
    const uniqueSeatIdArray = [...new Set(seatIdArray)];

    if (uniqueSeatIdArray.length > 0) {
      playAudio('winChipsReceive');
    }

    uniqueSeatIdArray.forEach(seatId => {
      const target = seatPositions.find(e => e?.id == seatId);
      const source = seatPositions.find(e => e?.id == currentTable?.SB);

      if (!target) return;

      const sushiLeft =
        rawPositions[numberOfSeats][source?.currentIndex]?.sushiLeft;

      const sushiTop =
        rawPositions[numberOfSeats][source?.currentIndex]?.sushiTop;

      const chipCount = 6;

      const centerXS = Number(source.x);
      const centerYS = Number(source.y) + 60;

      // PLAYER destination (END)
      const centerX = Number(target.x);
      const centerY = Number(target.y) + 60;

      // SUSHI starting (SOURCE)
      const startX =
        typeof sushiLeft === 'number'
          ? centerXS + sushiLeft
          : centerXS + (sushiLeft < 0 ? -48 : 48);

      const startY =
        sushiTop < 0 ? Number(source.y) + 30 : Number(source.y) + 40;

      for (let i = 0; i < chipCount; i++) {
        const chipId = `${seatId}-${Date.now()}-${i}`;

        // ❗ Chips START at SUSHI
        const animX = new Animated.Value(startX);
        const animY = new Animated.Value(startY);

        const newChip = {
          id: chipId,
          translateX: animX,
          translateY: animY,
        };

        setAnimatedChips(prev => [...prev, newChip]);

        // small random jitter
        const jitterX = (Math.random() - 0.5) * 10;
        const jitterY = (Math.random() - 0.5) * 10;

        // animate TO the player
        setTimeout(() => {
          Animated.parallel([
            Animated.timing(animX, {
              toValue: centerX + jitterX,
              duration: 300,
              useNativeDriver: true,
            }),
            Animated.timing(animY, {
              toValue: centerY + jitterY,
              duration: 300,
              useNativeDriver: true,
            }),
          ]).start(() => {
            setAnimatedChips(prev => prev.filter(c => c.id !== chipId));
          });
        }, i * 50);
      }
    });
  };

  const slideSeatToPot = async () => {
    console.log('call to slide-----------------');
    //if (currentTable?.endBeforeShowDown) return;

    const oldCopy = JSON.parse(JSON.stringify(currentTableRef.current));
    console.log('old copy------', oldCopy);

    let seatIdArray;
    if (!oldCopy?.isEndWithoutShowDown) {
      seatIdArray = Object.values(oldCopy?.seats).filter(
        e => e && e?.player && e?.hand?.length > 0 && e?.bet > 0,
      );
    } else {
      seatIdArray =
        oldCopy?.board?.length === 0
          ? Object.values(oldCopy?.seats).filter(
              e => e && e?.player && e?.hand?.length > 0,
            )
          : Object.values(oldCopy?.seats).filter(
              e => e && e?.player && e?.hand?.length > 0 && e?.bet > 0,
            );
    }

    console.log('seat to animate', seatIdArray);

    if (seatIdArray.length > 0) {
      playAudio('coinsTransfer');
    }

    const centerX = Dimensions.get('window').width / 2 - 10;
    const centerY = Dimensions.get('window').height / 2 - 170;

    seatIdArray.forEach(seat => {
      const target = seatPositionsRef?.current?.find(e => e?.id == seat?.id);
      console.log('target------', target, seatPositionsRef?.current, seat?.id);
      if (!target) return;

      const chipCount = 6;

      [...Array(chipCount)].forEach((_, i) => {
        const chipId = `${seat.id}-${performance.now()}-${i}`; // more unique
        const animX = new Animated.Value(target.x);
        const animY = new Animated.Value(target.y);

        const newChip = { id: chipId, translateX: animX, translateY: animY };
        setAnimatedChips2(prev => [...prev, newChip]);

        // Use Animated.sequence + delay instead of setTimeout
        Animated.sequence([
          Animated.delay(i * 80), // ✅ reliable stagger
          Animated.parallel([
            Animated.timing(animX, {
              toValue: centerX,
              duration: 300,
              useNativeDriver: true, // make sure you're using transform
            }),
            Animated.timing(animY, {
              toValue: centerY,
              duration: 300,
              useNativeDriver: true,
            }),
          ]),
        ]).start(() => {
          // remove chip after animation
          setAnimatedChips2(prev => prev.filter(c => c.id !== chipId));
        });
      });
    });
  };

  const slideSeatToPotEnd = async () => {
    console.log('call to slide end-----------------', seatsTemp.current);
    //if (currentTable?.endBeforeShowDown) return;

    let seatIdArray;

    seatIdArray = seatsTemp?.current?.filter(
      e => e && e?.hand?.length > 0 && e?.bet > 0,
    );

    console.log('seat to animate', seatIdArray);

    if (seatIdArray.length > 0) {
      playAudio('coinsTransfer');
    }

    const centerX = Dimensions.get('window').width / 2 - 10;
    const centerY = Dimensions.get('window').height / 2 - 170;

    seatIdArray.forEach(seat => {
      const target = seatPositionsRef?.current?.find(e => e?.id == seat?.id);
      console.log('target------', target, seatPositionsRef?.current, seat?.id);
      if (!target) return;

      const chipCount = 6;

      [...Array(chipCount)].forEach((_, i) => {
        const chipId = `${seat.id}-${performance.now()}-${i}`; // more unique
        const animX = new Animated.Value(target.x);
        const animY = new Animated.Value(target.y);

        const newChip = { id: chipId, translateX: animX, translateY: animY };
        setAnimatedChips2(prev => [...prev, newChip]);

        // Use Animated.sequence + delay instead of setTimeout
        Animated.sequence([
          Animated.delay(i * 80), // ✅ reliable stagger
          Animated.parallel([
            Animated.timing(animX, {
              toValue: centerX,
              duration: 300,
              useNativeDriver: true, // make sure you're using transform
            }),
            Animated.timing(animY, {
              toValue: centerY,
              duration: 300,
              useNativeDriver: true,
            }),
          ]),
        ]).start(() => {
          // remove chip after animation
          setAnimatedChips2(prev => prev.filter(c => c.id !== chipId));
        });
      });
    });
  };

  //win details loop
  useEffect(() => {
    if (currentWindetails?.winDetails?.length) {
      setTimeout(() => {
        const { winDetails } = currentWindetails;
        setTotalWinObj(winDetails);

        let lastBoardId = winDetails[winDetails.length - 1]?.boardId;

        let checkHavingMultiBoardWinners = winDetails.filter(
          e => e.boardId == 2 || e.boardId == 3,
        );

        if (checkHavingMultiBoardWinners.length > 0) {
          console.log('check mutlit borad----', checkHavingMultiBoardWinners);
          setIsMultiBoard(true);
        }

        const tempArray = [...new Set(winDetails.map(e => e?.boardId))];
        console.log('tempArray--------------', tempArray);

        const animateWinners = async () => {
          for (let i = 0; i < tempArray.length; i++) {
            let currentBoard = tempArray[i];

            //if is rit then set board cards
            if (currentTable?.isRit) {
              console.log('in rit loop assign cards');
              setCurrentTable(prevTables => {
                const updatedTable = { ...prevTables };

                // Determine which board key to update
                const boardKey =
                  currentBoard === 1 ? 'board' : `board${currentBoard}`;

                console.log(
                  'rit loop board key---',
                  boardKey,
                  '--',
                  new Date().getTime(),
                );
                // Only update if that board key exists in currentWindetails
                if (currentWindetails[boardKey]) {
                  // Start by clearing board

                  // Show first 3 cards (Flop)
                  setCurrentTable(prev => {
                    // Only set if not already set
                    if (!prev[boardKey] || prev[boardKey].length < 3) {
                      return {
                        ...prev,
                        [boardKey]: currentWindetails[boardKey].slice(0, 3),
                      };
                    }
                    return prev; // keep existing if already has 3+
                  });

                  // Show 4th card (Turn) after delay
                  if (currentWindetails[boardKey].length >= 4) {
                    setTimeout(() => {
                      setCurrentTable(prev => {
                        if (!prev[boardKey] || prev[boardKey].length < 4) {
                          console.log('setting cards: 4 cards');
                          return {
                            ...prev,
                            [boardKey]: currentWindetails[boardKey].slice(0, 4),
                          };
                        }
                        return prev;
                      });

                      // Show 5th card (River) only after 4th is set
                      if (currentWindetails[boardKey].length === 5) {
                        setTimeout(() => {
                          setCurrentTable(prev => {
                            if (!prev[boardKey] || prev[boardKey].length < 5) {
                              console.log('setting cards: 5 cards');
                              return {
                                ...prev,
                                [boardKey]: currentWindetails[boardKey].slice(
                                  0,
                                  5,
                                ),
                              };
                            }
                            return prev;
                          });
                        }, 100); // Delay after Turn
                      }
                    }, 100); // Delay after Flop
                  }
                }

                return updatedTable;
              });

              console.log('RIT:before call timer', new Date().getTime());
              await new Promise(res => setTimeout(res, 3000)); // delay
            }

            console.log('RIT:outside call timer', new Date().getTime());

            console.log(
              'before calling swap board----------',
              currentTable?.isEndWithoutShowDown,
              currentTable?.isRit,
              currentTable?.multiBoard,
              currentBoard,
            );

            //only when double board

            if (
              !currentTable?.isEndWithoutShowDown &&
              !currentTable?.isRit &&
              currentTable?.multiBoard == 2 &&
              currentBoard == 2
            ) {
              swapBoard();
            }

            //winner for current board
            const potsWinDetails = winDetails.filter(
              e => e.boardId == currentBoard,
            );

            //get main pot winner seat and update last action
            const mainPotWinner = winDetails
              .filter(e => e?.pot?.toString().toLowerCase() == 'mainpot')
              .map(e => e?.seatId);
            console.log('main pot winner-----------', mainPotWinner);

            //loop throuugh winner tag update

            console.log(
              'last board and current board---------',
              currentBoard,
              lastBoardId,
            );

            for (let i = 0; i < mainPotWinner.length; i++) {
              let currentSeatId = mainPotWinner[i];

              // multi board winners
              if (
                checkHavingMultiBoardWinners.length > 0 &&
                !currentTable?.isEndWithoutShowDown
              ) {
                console.log('showwinner:condition 1');
                if (currentBoard == lastBoardId) {
                  setCurrentTable(prevTable => {
                    if (!prevTable?.seats) return prevTable;

                    const updatedSeats = Object.keys(prevTable.seats).reduce(
                      (acc, seatId) => {
                        const seat = prevTable.seats[seatId];
                        if (!seat) return acc;

                        acc[seatId] = {
                          ...seat,
                          mttRank:
                            currentWindetails?.seats?.[seatId]?.mttRank ??
                            seat?.mttRank,
                        };

                        return acc;
                      },
                      {},
                    );

                    // Update winner seat separately
                    if (updatedSeats[currentSeatId]) {
                      updatedSeats[currentSeatId] = {
                        ...updatedSeats[currentSeatId],
                        earnSquid:
                          currentWindetails?.seats?.[currentSeatId]
                            ?.earnSquid ??
                          updatedSeats[currentSeatId]?.earnSquid,
                        lastAction: 'WINNER',
                      };
                    }

                    return {
                      ...prevTable,
                      seats: updatedSeats,
                    };
                  });

                  //update stack
                  // // Then update balance + lastAction
                  for (let i = 0; i < winDetails.length; i++) {
                    const { seatId, winningStack, pot } = winDetails[i];
                    console.log('pot----------------', pot);

                    setCurrentTable(prevTable => {
                      const updatedTable = { ...prevTable };
                      if (updatedTable?.seats?.[seatId]) {
                        updatedTable.seats[seatId] = {
                          ...updatedTable.seats[seatId],
                          stack: winningStack,
                          // lastAction: pot=="mainPot"? 'WINNER':null,
                        };
                      }

                      return updatedTable;
                    });
                  }

                  //loop through insurance claim player and update stack

                  const currentDetails =
                    currentTable?.insuranceLosers?.filter(
                      e => e.pot === 'final',
                    ) || [];

                  console.log(
                    'current insurance loser details ',
                    currentDetails,
                    currentTable?.insuranceLosers,
                  );

                  if (currentDetails.length > 0) {
                    setTimeout(() => {
                      setShowClaimReturn(false);
                      bounceLoserProfit();
                    }, 700);
                    setCurrentTable(prevTable => {
                      const updatedTable = { ...prevTable };
                      updatedTable.seats = { ...updatedTable.seats };

                      currentDetails.forEach(detail => {
                        const seatId = detail.seatId;
                        if (!updatedTable.seats?.[seatId]) return;

                        const prevStack =
                          Number(updatedTable.seats[seatId].stack) || 0;
                        const addClaim = Number(detail.claim) || 0;

                        updatedTable.seats[seatId] = {
                          ...updatedTable.seats[seatId],
                          stack: Number((prevStack + addClaim).toFixed(2)),
                        };
                      });

                      return updatedTable;
                    });
                  }

                  //squid settlement
                  if (
                    currentTable?.isSquid &&
                    currentTable?.squidWinDetails?.length > 0
                  ) {
                    setTimeout(() => {
                      setShowSquidSettlement(true);
                    }, 800);
                  }

                  //call sushi update function
                  sushiSbAntePay();
                }
              } else {
                console.log('showwinner:condition 2');

                //loop through insurance claim player and update stack

                setCurrentTable(prevTable => {
                  if (!prevTable?.seats) return prevTable;

                  const updatedSeats = Object.keys(prevTable.seats).reduce(
                    (acc, seatId) => {
                      const seat = prevTable.seats[seatId];
                      if (!seat) return acc;

                      acc[seatId] = {
                        ...seat,
                        mttRank:
                          currentWindetails?.seats?.[seatId]?.mttRank ??
                          seat?.mttRank,
                      };

                      return acc;
                    },
                    {},
                  );

                  // Update winner seat separately
                  if (updatedSeats[currentSeatId]) {
                    updatedSeats[currentSeatId] = {
                      ...updatedSeats[currentSeatId],
                      earnSquid:
                        currentWindetails?.seats?.[currentSeatId]?.earnSquid ??
                        updatedSeats[currentSeatId]?.earnSquid,
                      lastAction: 'WINNER',
                    };
                  }

                  return {
                    ...prevTable,
                    seats: updatedSeats,
                  };
                });

                for (let i = 0; i < winDetails.length; i++) {
                  const { seatId, winningStack, pot } = winDetails[i];
                  console.log('pot----------------', pot);

                  setCurrentTable(prevTable => {
                    const updatedTable = { ...prevTable };
                    if (updatedTable?.seats?.[seatId]) {
                      updatedTable.seats[seatId] = {
                        ...updatedTable.seats[seatId],
                        stack: winningStack,
                        // lastAction: pot=="mainPot"? 'WINNER':null,
                      };
                    }

                    return updatedTable;
                  });
                }

                //loop through insurance claim player and update stack
                const currentDetails =
                  currentTable?.insuranceLosers?.filter(
                    e => e.pot === 'final',
                  ) || [];

                if (currentDetails.length > 0) {
                  setTimeout(() => {
                    setShowClaimReturn(false);
                    bounceLoserProfit();
                  }, 700);
                  setCurrentTable(prevTable => {
                    const updatedTable = { ...prevTable };
                    updatedTable.seats = { ...updatedTable.seats };

                    currentDetails.forEach(detail => {
                      const seatId = detail.seatId;
                      if (!updatedTable.seats?.[seatId]) return;

                      const prevStack =
                        Number(updatedTable.seats[seatId].stack) || 0;
                      const addClaim = Number(detail.claim) || 0;

                      updatedTable.seats[seatId] = {
                        ...updatedTable.seats[seatId],
                        stack: Number((prevStack + addClaim).toFixed(2)),
                      };
                    });

                    return updatedTable;
                  });
                }

                //squid settlement
                if (
                  currentTable?.isSquid &&
                  currentTable?.squidWinDetails?.length > 0
                ) {
                  setTimeout(() => {
                    setShowSquidSettlement(true);
                  }, 800);
                }

                //call sushi update function
                //if break MTT
                if (
                  tableData?.table?.tournamentId != null &&
                  currentTour.breakRunning
                ) {
                  // const socket = getSocket();
                  // if (!socket) return;
                  // socket.emit(CLEAR_TABLE, { tableId: tableId });
                }
                sushiSbAntePay();
              }
            }

            // Update trophy state

            setCurrentWinObj(potsWinDetails);
            console.log('current win obj------', potsWinDetails);
            console.log('yes resetting it-----------', winDetails[i]?.handDesc);

            if (potsWinDetails?.[0]?.handDesc) {
              setHandDesc(true);
            }

            if (potsWinDetails?.[0]?.message) {
              setWinMsg(true);
            }

            if (
              checkHavingMultiBoardWinners.length > 0 &&
              !currentTable?.isEndWithoutShowDown
            ) {
              if (currentBoard == lastBoardId) {
                setWinIndex(
                  winDetails
                    .filter(e => e?.pot?.toString().toLowerCase() == 'mainpot')
                    .map(e => e?.seatId),
                );
              }
            } else {
              setWinIndex(potsWinDetails.map(e => e.seatId));
            }

            // Slide trophy first

            //if multiboard animate chips only once when last board appering
            //else only once

            if (
              checkHavingMultiBoardWinners.length > 0 &&
              !currentTable?.isEndWithoutShowDown
            ) {
              if (currentBoard == lastBoardId) {
                console.log(
                  'whern last borad then slide',
                  currentBoard,
                  lastBoardId,
                );
                setTimeout(() => {
                  slideToSeat(
                    winDetails
                      .filter(
                        e => e?.pot?.toString().toLowerCase() == 'mainpot',
                      )
                      .map(e => e?.seatId),
                  );
                }, 600);
              }
            } else {
              console.log('slide else');
              slideToSeat(potsWinDetails.map(e => e.seatId));
            }

            // Wait for animation to finish (300ms delay)
            await new Promise(resolve => setTimeout(resolve, 100));

            // // Then update balance + lastAction
            // for (let i = 0; i < potsWinDetails.length; i++) {
            //   const { seatId, winningStack, pot } = potsWinDetails[i];
            //   console.log('pot----------------', pot);

            //   setCurrentTable(prevTable => {
            //     const updatedTable = { ...prevTable };
            //     if (updatedTable?.seats?.[seatId]) {
            //       updatedTable.seats[seatId] = {
            //         ...updatedTable.seats[seatId],
            //         stack: winningStack,
            //         // lastAction: pot=="mainPot"? 'WINNER':null,
            //       };
            //     }

            //     return updatedTable;
            //   });
            // }

            if (currentBoard == lastBoardId) {
              setShowPotInfo(false);
            }

            // Optional delay before next winner
            await new Promise(resolve => setTimeout(resolve, 1200));
          }
        };

        animateWinners();
      }, 100);
    }
  }, [currentWindetails]);

  const sushiSbAntePay = () => {
    if (currentWindetails?.sushiDetails?.length) {
      setTimeout(() => {
        const { sushiDetails } = currentWindetails;

        if (sushiDetails[0]?.pot == 'SUSHI_LOSE') {
          if (currentWindetails?.sushiDetails?.[0]?.loserSeats?.[0]?.amt > 0) {
            slideSushi([sushiDetails[0]?.seatId]);
          }
          setShowSushiDeposit(true);
        }
        if (sushiDetails[0]?.pot == 'SUSHI_WIN') {
          let winner = {
            winAmount: sushiDetails[0]?.winAmount,
            seatId: sushiDetails[0]?.seatId,
          };
          setTotalWinObj(prev =>
            prev?.map(item =>
              item?.seatId === winner?.seatId
                ? {
                    ...item,
                    displayWinAmount: Number(winner?.winAmount),
                  }
                : item,
            ),
          );
          slideSushiWin([sushiDetails[0]?.seatId]);
        }

        //update Stack and Sushipot
        setCurrentTable(prev => {
          const d = sushiDetails[0];
          if (!d) return prev;

          return {
            ...prev,
            sushiPot: d.sushiPot,
            seats: {
              ...prev.seats,
              [d.seatId]: {
                ...prev.seats[d.seatId],
                stack: d.seat.stack,
              },
            },
          };
        });
      }, 1000);
    }
  };

  const swapBoardRit = async (currentWinD, boardNum = 1) => {
    try {
      const { board, board2, board3 } = currentWinD;
      console.log(
        'call to swap board rit -------------------',
        board,
        board2,
        board3,
      );

      // Get indices of board1 cards that exist in board2
      const commonIndicesBoard1 = board
        .map((card, index) => {
          const matchIndex = board2.findIndex(
            c2 => c2.rank === card.rank && c2.suit === card.suit,
          );
          return matchIndex !== -1 ? index : null;
        })
        .filter(idx => idx !== null);

      console.log('common index--------', commonIndicesBoard1);

      // Move boards according to RIT type
      const boardAnimations = [];
      if (currentTable?.isRit) {
        if (
          currentTable?.ritType === 'TWOTIMES' ||
          currentTable?.ritPlayersChoice === 'TWOTIMES'
        ) {
          // Step 1: Show Board 2
          commonIndicesBoard1.forEach(idx => {
            if (opacities2.current[idx]) {
              board2Conainter.setValue(0);
              lastAnimatedCardB2.current = idx + 1;

              slideAnimations2.current[idx].setValue(idx * 43);

              opacities2.current[idx].setValue(1);
              flipAnimations2.current[idx].setValue(180);
            }
          });

          await new Promise(res => setTimeout(res, 200));

          //hide only board 1 card 2 show show instant
          // Step 1: Hide Board 1 immediately
          commonIndicesBoard1.forEach(idx => {
            if (opacities.current[idx]) {
              opacities.current[idx].setValue(0);
            }
          });

          await new Promise(res => setTimeout(res, 200));
          boardAnimations.push(
            Animated.timing(board1Conainter, {
              toValue: 55,
              duration: 500,
              useNativeDriver: false,
            }),
          );

          //if no similar cards then swap both cards
          if (commonIndicesBoard1.length === 0) {
            boardAnimations.push(
              Animated.timing(board2Conainter, {
                toValue: 0,
                duration: 500,
                useNativeDriver: false,
              }),
            );
          }
        } else if (
          currentTable?.ritType === 'THREETIMES' ||
          currentTable?.ritPlayersChoice === 'THREETIMES'
        ) {
          console.log('current board ', boardNum);

          if (boardNum === 2) {
            // Step 1: Show Board 2
            commonIndicesBoard1.forEach(idx => {
              if (opacities2.current[idx]) {
                board2Conainter.setValue(0);
                lastAnimatedCardB2.current = idx + 1;

                slideAnimations2.current[idx].setValue(idx * 43);

                opacities2.current[idx].setValue(1);
                flipAnimations2.current[idx].setValue(180);
              }
            });

            await new Promise(res => setTimeout(res, 200));

            //hide only board 1 card 2 show show instant
            // Step 1: Hide Board 1 immediately
            commonIndicesBoard1.forEach(idx => {
              if (opacities.current[idx]) {
                opacities.current[idx].setValue(0);
              }
            });

            await new Promise(res => setTimeout(res, 200));
            boardAnimations.push(
              Animated.timing(board1Conainter, {
                toValue: 110,
                duration: 500,
                useNativeDriver: false,
              }),
            );

            //if no similar cards then swap both cards
            if (commonIndicesBoard1.length === 0) {
              boardAnimations.push(
                Animated.timing(board2Conainter, {
                  toValue: 0,
                  duration: 500,
                  useNativeDriver: false,
                }),
              );
            }
          } else if (boardNum === 3) {
            // Step 1: Show Board 3
            commonIndicesBoard1.forEach(idx => {
              if (opacities3.current[idx]) {
                board3Conainter.setValue(0);
                lastAnimatedCardB3.current = idx + 1;

                slideAnimations3.current[idx].setValue(idx * 43);

                opacities3.current[idx].setValue(1);
                flipAnimations3.current[idx].setValue(180);
              }
            });

            await new Promise(res => setTimeout(res, 200));

            //hide only board 1 card 2 show show instant
            // Step 1: Hide Board 1 immediately
            commonIndicesBoard1.forEach(idx => {
              if (opacities2.current[idx]) {
                opacities2.current[idx].setValue(0);
              }
              if (opacities.current[idx]) {
                opacities.current[idx].setValue(0);
              }
            });

            await new Promise(res => setTimeout(res, 200));
            boardAnimations.push(
              Animated.timing(board2Conainter, {
                toValue: 55,
                duration: 500,
                useNativeDriver: false,
              }),
            );

            //if no similar cards then swap both cards
            if (commonIndicesBoard1.length === 0) {
              boardAnimations.push(
                Animated.timing(board3Conainter, {
                  toValue: 0,
                  duration: 500,
                  useNativeDriver: false,
                }),
              );
            }
          }
        }
      }

      if (boardAnimations.length > 0) {
        await new Promise(resolve =>
          Animated.parallel(boardAnimations).start(() => {
            console.log('Board animations finished!');
            resolve();
          }),
        );
      }
    } catch (e) {
      console.log('error in swapBoardRit ---------------------------', e);
    }
  };

  const swapBoard = () => {
    try {
      console.log('call to swap board-------------------');
      Animated.parallel([
        Animated.timing(board1Conainter, {
          toValue: 55, // move red down or back up
          duration: 500,
          useNativeDriver: false,
        }),
        Animated.timing(board2Conainter, {
          toValue: 0, // move blue up or back down
          duration: 500,
          useNativeDriver: false,
        }),
      ]).start(() => {});
    } catch (e) {
      console.log('error---------------------------', e);
    }
  }; //In game chat message if user not taken seat
  
  const isReceiverSeated = Object.values(currentTable?.seats || {}).some(
    seat => seat?.player && String(seat.player.id) === String(receiverId),
  );

  return (
    <View
      onLayout={e => {
        setLayoutHeight(e.nativeEvent.layout.height);
      }}
      onContentSizeChange={(width, height) => {
        setContentHeight(height);

        // Set initial margin (distance from bottom)
        const initialMargin = height - layoutHeight;
        setMarginRaiseBar(initialMargin > 0 ? initialMargin : 0);
      }}
      onScroll={event => {
        const { contentOffset, layoutMeasurement, contentSize } =
          event.nativeEvent;

        const distanceFromBottom =
          contentSize.height - layoutMeasurement.height - contentOffset.y;

        console.log('Distance from bottom:', distanceFromBottom);
        setMarginRaiseBar(distanceFromBottom);

        // You can do something when near bottom
        if (distanceFromBottom < 100) {
          console.log('Near the bottom!');
        }
      }}
      scrollEnabled={
        !isModalVisible['raise']
        // && !raiseCompVisible['slider']
      }
      style={styles.rootConatiner}
      contentContainerStyle={{ flexGrow: 1 }}
      keyboardShouldPersistTaps="handled"
    >
      <View
        style={[
          {
            height:
              Dimensions.get('window').height ,
          },
          styles.container,
        ]}
        onLayout={e => setLayout(e.nativeEvent.layout)}
      >
        {/* MTT SpotLight - Final Table */}
        {/* {currentTour?.ftDeal && Object.keys(currentTour?.ftDeal).length > 0 ? (
          <SpotLight />
        ) : null} */}

        {currentTable?.squidRunning && (
          <Image
            source={require('../assets/inGameAssets/sea.png')}
            style={{ flex: 1, position: 'absolute', top: -50 }}
            resizeMode="cover"
          />
        )}
      

        {currentTable?.isSushi && (
          <Image
            source={require('../assets/inGameAssets/sushiBackground.png')}
            style={{
              height: '100%',
              width: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 0,
            }}
            resizeMode="cover"
          />
        )}

       

     
        <View
          style={
            currentTable?.squidRunning || currentTable?.isSushi
              ? styles.tableContainerSquid
              : styles.tableContainer
          }
        >
          {!currentTable?.isSushi ? (
            <Image
              source={require('../assets/images/table.png')}
              style={{ height: '100%', width: '100%' }}
              resizeMode="contain"
              resizeMethod='resize'
            />
          ) : null}
        

          {/* Bomb pot Image GIF */}

          {isPlayBombpot ? (
            <View style={styles.bombpotCon}>
              <Image
                source={require('../assets/inGameAssets/bombPot.gif')}
                style={{ width: 180, height: 180 }}
              />
            </View>
          ) : null}

          {/*  KO Bounty Image GIF */}

          {isPlayKoBounty && currentTour?.koBountyType != 'MYSTERY' ? (
            <View style={styles.bombpotCon}>
              <Image
                source={require('../assets/inGameAssets/koBounty.gif')}
                style={{ width: 180, height: 180 }}
              />
            </View>
          ) : null}

          {isPlayKoBounty && currentTour?.koBountyType == 'MYSTERY' ? (
            <View style={styles.mystryCon}>
              <Image
                resizeMode="contain"
                source={require('../assets/inGameAssets/MystreyShoot.gif')}
                style={{ width: 40, height: 40 }}
              />
            </View>
          ) : null}

          {currentTour?.koBountyType == 'MYSTREY' && !isPlayKoBounty ? (
            <View style={styles.mystryCon}>
              <Image
                resizeMode="contain"
                source={require('../assets/inGameAssets/Mystrey.png')}
                style={{ width: 40, height: 40 }}
              />
            </View>
          ) : null}

          {isPlayITM ? (
            <View style={styles.bombpotCon}>
              <Image
                resizeMode="contain"
                source={require('../assets/inGameAssets/ITMStart.gif')}
                style={{ width: 180, height: 180 }}
              />
            </View>
          ) : null}

          {/* Community cards container  */}
          {!currentTable?.isRit ? (
            <View style={styles.boardContainer}>
              <Animated.View style={[styles.board1, { top: board1Conainter }]}>
                <View style={[styles.boardChild]}>
                  {currentTable?.board?.length > 0 &&
                    currentTable?.board?.map((card, index) => {
                      const flip = flipAnimations.current[index];
                      const slide = slideAnimations.current[index];
                      const opacity = opacities.current[index];

                      if (!flip || !slide || !opacity) return null; // Skip rendering if animation values not ready

                      const rotateYBack = flipAnimations.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['0deg', '180deg'],
                      });

                      const rotateYFront = flipAnimations.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['180deg', '360deg'],
                      });

                      return (
                        <Animated.View
                          key={index}
                          style={{
                            // ...(Platform.OS === 'android'
                            //   ? { position: 'absolute' }
                            //   : {}),
                            top: 0,
                            left: 0,
                            opacity: opacities.current[index],
                            transform: [
                              { translateX: slideAnimations.current[index] },
                            ],
                          }}
                        >
                          {/* Back Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYBack },
                                ],
                              },
                            ]}
                          >
                            <Image
                              source={require('../assets/cards/hidden/hidden.png')}
                              style={[styles.card]}
                            />
                          </Animated.View>

                          {/* Front Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                borderColor:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? colors.lemonFlash
                                    : 'transparent',
                                borderWidth:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 1.5
                                    : 0,
                                elevation:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 10
                                    : 0,
                                borderRadius: 5,
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYFront },
                                ],
                              },
                            ]}
                          >
                            <Image
                              resizeMode="contain"
                              source={getCardImage(card)}
                              style={[styles.card]}
                            />
                            {index == 3 &&
                            isPlayCrackCard &&
                            currentTable.board.length == 4 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrak.gif')}
                              />
                            ) : null}

                            {index == 3 &&
                            !isPlayCrackCard &&
                            isInsuranceAnimationCompleted &&
                            currentTable.board.length == 4 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrack.png')}
                              />
                            ) : null}

                            {index == 4 &&
                            isPlayCrackCard &&
                            currentTable.board.length == 5 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrak.gif')}
                              />
                            ) : null}

                            {index == 4 &&
                            !isPlayCrackCard &&
                            isInsuranceAnimationCompleted &&
                            currentTable.board.length == 5 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrack.png')}
                              />
                            ) : null}
                          </Animated.View>
                        </Animated.View>
                      );
                    })}
                </View>
              </Animated.View>
              {/* board 2 */}

              <Animated.View style={[styles.board2, { top: board2Conainter }]}>
                <View style={styles.boardChild}>
                  {currentTable?.board2?.length > 0 &&
                    currentTable?.board2?.map((card, index) => {
                      const flip = flipAnimations2.current[index];
                      const slide = slideAnimations2.current[index];
                      const opacity = opacities2.current[index];

                      if (!flip || !slide || !opacity) return null; // Skip rendering if animation values not ready

                      const rotateYBack = flipAnimations2.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['0deg', '180deg'],
                      });

                      const rotateYFront = flipAnimations2.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['180deg', '360deg'],
                      });

                      return (
                        <Animated.View
                          key={index}
                          style={{
                            // ...(Platform.OS === 'android'
                            //   ? { position: 'absolute' }
                            //   : {}),
                            top: 0,
                            left: 0,
                            opacity: opacities2.current[index],
                            transform: [
                              { translateX: slideAnimations2.current[index] },
                            ],
                          }}
                        >
                          {/* Back Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYBack },
                                ],
                              },
                            ]}
                          >
                            <Image
                              source={require('../assets/cards/hidden/hidden.png')}
                              style={[styles.card]}
                            />
                          </Animated.View>

                          {/* Front Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                borderColor:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? colors.lemonFlash
                                    : 'transparent',
                                borderWidth:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 1.5
                                    : 0,
                                elevation:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 10
                                    : 0,
                                borderRadius: 5,
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYFront },
                                ],
                              },
                            ]}
                          >
                            <Image
                              resizeMode="contain"
                              source={getCardImage(card)}
                              style={[styles.card]}
                            />
                          </Animated.View>
                        </Animated.View>
                      );
                    })}
                </View>
              </Animated.View>

              {/* board 3 */}
              <View style={styles.board3}>
                <View style={styles.boardChild}>
                  {currentTable?.board3?.length > 0 &&
                    currentTable?.board3?.map((card, index) => {
                      const flip = flipAnimations3.current[index];
                      const slide = slideAnimations3.current[index];
                      const opacity = opacities3.current[index];

                      if (!flip || !slide || !opacity) return null; // Skip rendering if animation values not ready

                      const rotateYBack = flipAnimations3.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['0deg', '180deg'],
                      });

                      const rotateYFront = flipAnimations3.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['180deg', '360deg'],
                      });

                      return (
                        <Animated.View
                          key={index}
                          style={{
                            // ...(Platform.OS === 'android'
                            //   ? { position: 'absolute' }
                            //   : {}),
                            top: 0,
                            left: 0,
                            opacity: opacities3.current[index],
                            transform: [
                              { translateX: slideAnimations3.current[index] },
                            ],
                          }}
                        >
                          {/* Back Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYBack },
                                ],
                              },
                            ]}
                          >
                            <Image
                              source={require('../assets/cards/hidden/hidden.png')}
                              style={[styles.card]}
                            />
                          </Animated.View>

                          {/* Front Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                borderColor:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? colors.lemonFlash
                                    : 'transparent',
                                borderWidth:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 1.5
                                    : 0,
                                elevation:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 10
                                    : 0,
                                borderRadius: 5,
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYFront },
                                ],
                              },
                            ]}
                          >
                            <Image
                              resizeMode="contain"
                              source={getCardImage(card)}
                              style={[styles.card]}
                            />
                          </Animated.View>
                        </Animated.View>
                      );
                    })}
                </View>
              </View>
            </View>
          ) : null}

          {/*RIT -  Community cards container  */}
          {currentTable?.isRit ? (
            <View style={styles.boardContainer}>
              <Animated.View style={[styles.board1, { top: board1Conainter }]}>
                <View style={[styles.boardChild]}>
                  {currentTable?.board?.length > 0 &&
                    currentTable?.board?.map((card, index) => {
                      const flip = flipAnimations.current[index];
                      const slide = slideAnimations.current[index];
                      const opacity = opacities.current[index];

                      if (!flip || !slide || !opacity) return null; // Skip rendering if animation values not ready

                      const rotateYBack = flipAnimations.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['0deg', '180deg'],
                      });

                      const rotateYFront = flipAnimations.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['180deg', '360deg'],
                      });

                      return (
                        <Animated.View
                          key={index}
                          style={{
                            // ...(Platform.OS === 'android'
                            //   ? { position: 'absolute' }
                            //   : {}),
                            top: 0,
                            left: 0,
                            opacity: opacities.current[index],
                            transform: [
                              { translateX: slideAnimations.current[index] },
                            ],
                          }}
                        >
                          {/* Back Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYBack },
                                ],
                              },
                            ]}
                          >
                            <Image
                              source={require('../assets/cards/hidden/hidden.png')}
                              style={[styles.card]}
                            />
                          </Animated.View>

                          {/* Front Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                borderColor:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? colors.lemonFlash
                                    : 'transparent',
                                borderWidth:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 1.5
                                    : 0,
                                elevation:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 10
                                    : 0,
                                borderRadius: 5,
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYFront },
                                ],
                              },
                            ]}
                          >
                            <Image
                              resizeMode="contain"
                              source={getCardImage(card)}
                              style={[styles.card]}
                            />

                              {index == 3 &&
                            isPlayCrackCard &&
                            currentTable.board.length == 4 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrak.gif')}
                              />
                            ) : null}

                            {index == 3 &&
                            !isPlayCrackCard &&
                            isInsuranceAnimationCompleted &&
                            currentTable.board.length == 4 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrack.png')}
                              />
                            ) : null}

                            {index == 4 &&
                            isPlayCrackCard &&
                            currentTable.board.length == 5 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrak.gif')}
                              />
                            ) : null}

                            {index == 4 &&
                            !isPlayCrackCard &&
                            isInsuranceAnimationCompleted &&
                            currentTable.board.length == 5 ? (
                              <Image
                                //resizeMode='contain'
                                style={{
                                  height: '100%',
                                  width: '100%',
                                  position: 'absolute',
                                  top: 0,
                                }}
                                source={require('../assets/inGameAssets/cardCrack.png')}
                              />
                            ) : null}
                          </Animated.View>
                        </Animated.View>
                      );
                    })}
                </View>
              </Animated.View>
              {/* board 2 */}

              <Animated.View style={[styles.board1, { top: board2Conainter }]}>
                <View style={styles.boardChild}>
                  {currentTable?.board2?.length > 0 &&
                    currentTable?.board2?.map((card, index) => {
                      const flip = flipAnimations2.current[index];
                      const slide = slideAnimations2.current[index];
                      const opacity = opacities2.current[index];

                      if (!flip || !slide || !opacity) return null; // Skip rendering if animation values not ready

                      const rotateYBack = flipAnimations2.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['0deg', '180deg'],
                      });

                      const rotateYFront = flipAnimations2.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['180deg', '360deg'],
                      });

                      return (
                        <Animated.View
                          key={index}
                          style={{
                            // ...(Platform.OS === 'android'
                            //   ? { position: 'absolute' }
                            //   : {}),
                            top: 0,
                            left: 0,
                            opacity: opacities2.current[index],
                            transform: [
                              { translateX: slideAnimations2.current[index] },
                            ],
                          }}
                        >
                          {/* Back Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYBack },
                                ],
                              },
                            ]}
                          >
                            <Image
                              source={require('../assets/cards/hidden/hidden.png')}
                              style={[styles.card]}
                            />
                          </Animated.View>

                          {/* Front Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                borderColor:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? colors.lemonFlash
                                    : 'transparent',
                                borderWidth:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 1.5
                                    : 0,
                                elevation:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 10
                                    : 0,
                                borderRadius: 5,
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYFront },
                                ],
                              },
                            ]}
                          >
                            <Image
                              resizeMode="contain"
                              source={getCardImage(card)}
                              style={[styles.card]}
                            />
                          </Animated.View>
                        </Animated.View>
                      );
                    })}
                </View>
              </Animated.View>

              {/* board 3 */}
              <Animated.View style={[styles.board1, { top: board3Conainter }]}>
                <View style={styles.boardChild}>
                  {currentTable?.board3?.length > 0 &&
                    currentTable?.board3?.map((card, index) => {
                      const flip = flipAnimations3.current[index];
                      const slide = slideAnimations3.current[index];
                      const opacity = opacities3.current[index];

                      if (!flip || !slide || !opacity) return null; // Skip rendering if animation values not ready

                      const rotateYBack = flipAnimations3.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['0deg', '180deg'],
                      });

                      const rotateYFront = flipAnimations3.current[
                        index
                      ].interpolate({
                        inputRange: [0, 180],
                        outputRange: ['180deg', '360deg'],
                      });

                      return (
                        <Animated.View
                          key={index}
                          style={{
                            // ...(Platform.OS === 'android'
                            //   ? { position: 'absolute' }
                            //   : {}),
                            top: 0,
                            left: 0,
                            opacity: opacities3.current[index],
                            transform: [
                              { translateX: slideAnimations3.current[index] },
                            ],
                          }}
                        >
                          {/* Back Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYBack },
                                ],
                              },
                            ]}
                          >
                            <Image
                              source={require('../assets/cards/hidden/hidden.png')}
                              style={[styles.card]}
                            />
                          </Animated.View>

                          {/* Front Face */}
                          <Animated.View
                            style={[
                              styles.cardWrapper,
                              {
                                borderColor:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? colors.lemonFlash
                                    : 'transparent',
                                borderWidth:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 1.5
                                    : 0,
                                elevation:
                                  currentWinObj?.filter(
                                    obj =>
                                      obj.pot === 'mainpot' &&
                                      obj.playingCards?.filter(
                                        e =>
                                          e.suit === card.suit &&
                                          e.rank === card.rank,
                                      ).length > 0,
                                  ).length > 0
                                    ? 10
                                    : 0,
                                borderRadius: 5,
                                position: 'absolute',
                                backfaceVisibility: 'hidden',
                                transform: [
                                  { perspective: 1000 },
                                  { rotateY: rotateYFront },
                                ],
                              },
                            ]}
                          >
                            <Image
                              resizeMode="contain"
                              source={getCardImage(card)}
                              style={[styles.card]}
                            />
                          </Animated.View>
                        </Animated.View>
                      );
                    })}
                </View>
              </Animated.View>
            </View>
          ) : null}

          {/*MTT countdown*/}
          {Date.parse(finalTime) - Date.now() > 0 ? (
            <View style={styles.mttCountdownContainer}>
              <ImageBackground
                style={styles.mttCountDownImage}
                resizeMode="contain"
                source={require('../assets/inGameAssets/mttCountdown.png')}
              >
                {/* Minutes */}
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeft?.minutes ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[0]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeft?.minutes ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[1]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>

                <View style={{ width: 10 }}></View>

                {/* Seconds */}
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeft?.seconds ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[0]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeft?.seconds ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[1]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
              </ImageBackground>

              <Text style={styles.mttStartTxt}>
                Tournament is about to start
              </Text>
            </View>
          ) : null}

          {/*AddOn countdown*/}
          {currentTour?.addOnExp != null &&
          currentTable?.handOver &&
          (timeLeftAddon?.minutes > 0 || timeLeftAddon?.seconds > 0) ? (
            <View style={styles.mttCountdownContainer}>
              <ImageBackground
                style={styles.mttCountDownImage}
                resizeMode="contain"
                source={require('../assets/inGameAssets/mttCountdown.png')}
              >
                {/* Minutes */}
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftAddon?.minutes ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[0]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftAddon?.minutes ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[1]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>

                <View style={{ width: 10 }}></View>

                {/* Seconds */}
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftAddon?.seconds ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[0]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftAddon?.seconds ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[1]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
              </ImageBackground>

              <Text style={styles.mttStartTxt}>Add-On</Text>
            </View>
          ) : null}

          {/*Break countdown*/}
          {currentTour?.breakExp != null &&
          currentTable?.handOver &&
          showBreak &&
          currentWindetails == null &&
          (timeLeftBreak?.minutes > 0 || timeLeftBreak?.seconds > 0) ? (
            <View style={styles.mttCountdownContainer}>
              <ImageBackground
                style={styles.mttCountDownImage}
                resizeMode="contain"
                source={require('../assets/inGameAssets/mttCountdown.png')}
              >
                {/* Minutes */}
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftBreak?.minutes ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[0]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftBreak?.minutes ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[1]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>

                <View style={{ width: 10 }}></View>

                {/* Seconds */}
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftBreak?.seconds ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[0]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
                <View style={styles.blackBoxTime}>
                  <Text style={styles.timertxt}>
                    {(() => {
                      const m = (timeLeftBreak?.seconds ?? 0)
                        .toString()
                        .padStart(2, '0');
                      return (
                        <>
                          <Text style={styles.timertxt}>{m[1]}</Text>
                        </>
                      );
                    })()}
                  </Text>
                </View>
              </ImageBackground>

              <Text style={styles.mttStartTxt}>Break</Text>
            </View>
          ) : null}

          {/*Table Info*/}
          <View style={styles.tableInfoContainer}>
             <TableInfo
              data={currentTable}
              tour={currentTour}
              levelTime={remainTimeLevel}
              showITM={!isPlayITM && currentTour?.isItmStarted}
            /> 
          </View>
        </View>

        {/* Squid and Sea Image */}

        {/* <Animated.View
          style={{
            transform: [{ translateY: translateYSquidTable }],
            height: '100%',
            width: '100%',
            position: 'absolute',
            bottom: 0,
            // backgroundColor:"red"
          }}
        >
          <Image
            source={require('../assets/inGameAssets/squidTable.png')}
            style={{ height: '100%', width: '100%' }}
            resizeMode="contain"
          />
        </Animated.View> */}

        {layout &&
          seatPositions.map((pos, i) => {
            let cI = pos?.currentIndex;

            let seat = currentTable?.seats[i + 1];
            const posCard = cardsPositions[`${numberOfSeats}-${numberOfCards}`];
           
            const cardOffsetPos = verticalOffsets[numberOfCards];

            const getBubbleLeft = (cI, messageWidths, numberOfSeats) => {
              const seatPos = rawPositions[numberOfSeats][cI]?.marginLeft || 0;

              const groups = NLHChatseatGroups[numberOfSeats];

              if (groups?.bottom.includes(cI) || groups?.top.includes(cI)) {
                // center align
                return seatPos + 40 / 2 - messageWidths / 2;
              } else if (groups?.left.includes(cI)) {
                // right of avatar
                return seatPos;
              } else if (groups?.right.includes(cI)) {
                // left of avatar
                return seatPos - messageWidths + 33;
              }
              return seatPos;
            };

            return (
              <>
                {/* chat UI */}
                {seat && latestMsgs[seat?.player?.id] ? (
                  <>
                    <Animated.View
                      key={`msg-${seat?.player?.id}`}
                      style={{
                        position: 'absolute',
                        transform: [
                          { translateX: pos?.animatedXY?.x },
                          { translateY: pos?.animatedXY?.y },
                        ],
                        maxWidth: SCREEN_W * 0.4,
                        maxHeight: SCREEN_W * 0.3,

                        // left: getBubbleLeft(i, messageWidth, numberOfSeats, cI),
                        // top:

                        //   rawPositions[numberOfSeats][cI]?.marginTop -
                        //   bubbleHeights -
                        //   10,
                        left: getBubbleLeft(
                          cI,
                          messageWidths[seat?.id] || 0,
                          numberOfSeats,
                        ),
                        top:
                          rawPositions[numberOfSeats][cI]?.marginTop -
                          (bubbleHeights[seat?.id] || 0) -
                          10,

                        alignItems: 'center',
                        paddingHorizontal: 10,
                        paddingVertical: 6,
                        backgroundColor: colors.toggleBg,
                        borderRadius: 8,
                        zIndex: 9999, // 👈 force chat bubble always on top
                        elevation: 10, // 👈 for Android (works with zIndex)
                      }}
                      onLayout={e => {
                        const { height, width } = e.nativeEvent.layout;
                        setBubbleHeights(prev => ({
                          ...prev,
                          [seat?.id]: height,
                        }));
                        setMessageWidths(prev => ({
                          ...prev,
                          [seat?.id]: width,
                        }));
                      }}
                    >
                    
                      {/* <Text style={styles.msg}>tcccccccccccccccccccccccccc</Text> */}
                    </Animated.View>
                    {/* Tail */}
                    <Animated.View
                      style={[
                        styles.tailBottom,
                        {
                          transform: [
                            { translateX: pos?.animatedXY?.x },
                            { translateY: pos?.animatedXY?.y },
                          ],
                          left:
                            rawPositions[numberOfSeats][cI]?.marginLeft +
                            40 / 2 -
                            6, // 👈 profile center - half tail width
                          top: rawPositions[numberOfSeats][cI]?.marginTop - 10, // 👈 just above profile
                          zIndex: 9999, // 👈 force chat bubble always on top
                          elevation: 10, // 👈 for Android (works with zIndex)
                        },
                      ]}
                    />
                  </>
                ) : null}
                <Animated.View
                  onPre
                  key={i}
                  style={{
                    position: 'absolute',
                    transform: [
                      { translateX: pos?.animatedXY?.x },

                      { translateY: pos?.animatedXY?.y },
                    ],
                    width: 40,
                    height: 40,
                    marginLeft: rawPositions[numberOfSeats][cI]?.marginLeft,
                    marginTop: rawPositions[numberOfSeats][cI]?.marginTop,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => openProfileModal(seat, i)}
                    style={{
                      flex: 1,
                      width: '100%',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {/* Player with seat */}

                    {/* Cloud with details */}

                    {/* Sushi Pot for SB */}
                    {currentTable?.isSushi &&
                    Number(i + 1) == Number(currentTable?.SB) &&
                    currentTable?.sushiPot > 0 ? (
                      <View
                        style={{
                          left:
                            rawPositions[numberOfSeats][cI]?.sushiLeft < 0
                              ? rawPositions[numberOfSeats][cI]?.sushiLeft + 13
                              : rawPositions[numberOfSeats][cI]?.sushiLeft - -8,
                          top:
                            rawPositions[numberOfSeats][cI]?.sushiTop == -15
                              ? rawPositions[numberOfSeats][cI]?.sushiTop - 10
                              : rawPositions[numberOfSeats][cI]?.sushiTop == 80
                              ? rawPositions[numberOfSeats][cI]?.sushiTop + 15
                              : rawPositions[numberOfSeats][cI]?.sushiTop + -15,
                          position: 'absolute',
                        }}
                      >
                        {showSushiDeposit ? (
                          <Text
                            style={{
                              color: colors.white,
                              fontSize: 6,
                              position: 'absolute',
                              top: -5,
                              left: 3,
                              fontFamily: 'Averta-Bold',
                              textAlign: 'center',
                              fontWeight: 'bold',
                            }}
                          >
                            {(() => {
                              const amt =
                                currentWindetails?.sushiDetails?.[0]
                                  ?.loserSeats?.[0]?.amt;

                              if (amt == null || isNaN(amt) || amt <= 0)
                                return ''; // ← AND greater than 0 check added

                              const bbValue = amt / currentTable?.bigBlind;

                              if (showBB) {
                                return `+ ${
                                  bbValue % 1 === 0
                                    ? `${bbValue} BB`
                                    : `${bbValue.toFixed(2)} BB`
                                }`;
                              }

                              return `+ ${
                                amt % 1 === 0 ? amt : Number(amt).toFixed(2)
                              }`;
                            })()}
                          </Text>
                        ) : null}
                        <Image
                          style={{
                            height: 25,
                            width: 25,
                          }}
                          source={require('../assets/inGameAssets/sushi.png')}
                        />
                        <View
                          style={{
                            justifyContent: 'center',
                            alignItems: 'center',

                            height: 15,

                            zIndex: 1000,
                            marginTop: -5,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={{
                              color: colors.white,
                              fontSize: 6,
                              fontFamily: 'Averta-Bold',
                              textAlign: 'center',
                              fontWeight: 'bold',
                            }}
                          >
                            {showBB
                              ? Number(
                                  currentTable?.sushiPot /
                                    currentTable?.bigBlind,
                                ) %
                                  1 ==
                                0
                                ? `${Number(
                                    currentTable?.sushiPot /
                                      currentTable?.bigBlind,
                                  )} BB `
                                : `${Number(
                                    currentTable?.sushiPot /
                                      currentTable?.bigBlind,
                                  ).toFixed(2)} BB`
                              : Number(currentTable?.sushiPot) % 1 == 0
                              ? currentTable?.sushiPot
                              : Number(currentTable?.sushiPot).toFixed(2)}
                          </Text>
                        </View>
                      </View>
                    ) : null}

                    {currentTable?.button == Number(i + 1) && showDealer ? (
                      currentTable?.squidRunning ? (
                        <View style={styles.dealerPosition}>
                          <Image
                            style={{ width: 20, height: 20 }}
                            resizeMode="contain"
                            source={require('../assets/inGameAssets/squidDealerButton.png')}
                          />
                        </View>
                      ) : (
                        <View style={styles.dealerContainer}>
                          <Text style={styles.dealerTxt}>D</Text>
                        </View>
                      )
                    ) : null}

                    {seat && checkedPlayer ? (
                      <View
                        style={{
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {currentTour?.koBounty &&
                        currentTour?.koBountyType != 'MYSTERY' ? (
                          <View
                            style={{
                              position: 'absolute',
                              top: -10,
                              right: cI == 0 ? -40 : 0,
                            }}
                          >
                            {/* <KoBountySeat
                              value={
                                Number(seat?.koBounty) > 0 &&
                                Date.now() > Date.parse(finalTime)
                                  ? seat?.koBounty
                                  : 0
                              }
                            /> */}
                          </View>
                        ) : null}

                        {isIncludedInFavourite(seat?.id) &&
                        currentTable?.insExp != null &&
                        !checkAllInsuranceActionsTaken() ? (
                          <Image
                            style={{
                              height: 20,
                              width: 20,
                              position: 'absolute',
                              top: -20,
                            }}
                            resizeMode="contain"
                            source={require('../assets/inGameAssets/insuranceTaking.gif')}
                          />
                        ) : null}
                        <View style={[styles.profileContainer]}>
                          <Image
                            source={{ uri: seat?.player?.profileFrame }}
                            style={styles.frame}
                          />
                          <Image
                            source={{ uri: seat?.player?.profilePic }}
                            style={styles.profile}
                          />
                          {(!currentTable?.wentToShowdown &&
                            seat?.mttRank > 0 &&
                            currentTable?.tournamentId != null) ||
                          (currentTour?.addOnExp != null &&
                            currentTable?.handOver &&
                            seat?.mttRank > 0 &&
                            currentTable?.tournamentId != null) ? (
                            <ImageBackground
                              resizeMode="contain"
                              source={
                                seat?.mttRank == 1
                                  ? require('../assets/inGameAssets/goldRank.png')
                                  : require('../assets/inGameAssets/silverRank.png')
                              }
                              style={styles.rankBadge}
                            >
                              <Text style={styles.seatRankTxt}>
                                {seat?.mttRank}
                              </Text>
                            </ImageBackground>
                          ) : null}

                          {/* Insurance claim profit on Seat */}
                          {(currentTable?.insuranceLosers
                            ?.filter(
                              e => e.seatId.toString() == seat?.id?.toString(),
                            )
                            ?.slice(-1)[0]?.profit ?? 0) > 0 &&
                          currentWindetails?.winDetails?.filter(
                            e =>
                              e?.pot?.toString().toLowerCase() == 'mainpot' &&
                              e?.seatId?.toString() == seat?.id.toString(),
                          ).length == 0 ? (
                            <Animated.View
                              style={[
                                styles.winPointCon,

                                {
                                  transform: [{ translateY: translateYL }],
                                  opacity: opacityBouunceL,
                                },
                              ]}
                            >
                              <Text style={styles.winTxt}>
                                +
                                {(() => {
                                  const raw =
                                    currentTable?.insuranceLosers
                                      ?.filter(
                                        e =>
                                          e.seatId.toString() ===
                                            seat?.id.toString() &&
                                          e.pot == 'final',
                                      )
                                      ?.slice(-1)[0]?.profit || 0;

                                  // normalize profit first
                                  let amount = Number(raw);
                                  amount = Number(amount.toFixed(2));

                                  const bb = Number(
                                    currentTable?.bigBlind || 1,
                                  );

                                  if (showBB) {
                                    let val = amount / bb;
                                    val = Number(val.toFixed(2)); // normalize again after division

                                    return Number.isInteger(val)
                                      ? `${val} BB`
                                      : `${val.toFixed(2)} BB`;
                                  } else {
                                    return Number.isInteger(amount)
                                      ? amount
                                      : amount.toFixed(2);
                                  }
                                })()}
                              </Text>
                            </Animated.View>
                          ) : null}

                          {/* Winning amount on Seat */}
                          {winIndex &&
                          winIndex.length > 0 &&
                          (totalWinObj
                            ?.filter(
                              e =>
                                e.seatId == seat?.id &&
                                e?.pot?.toString().toLowerCase() == 'mainpot',
                            )
                            ?.slice(-1)[0]?.displayWinAmount ?? 0) > 0 &&
                          winIndex.includes(seat?.id) ? (
                            <Animated.View
                              style={[
                                styles.winPointCon,

                                {
                                  transform: [{ translateY }],
                                  opacity: opacityBouunce,
                                },
                              ]}
                            >
                              <Text style={styles.winTxt}>
                                +
                                {(() => {
                                  const raw =
                                    totalWinObj
                                      ?.filter(
                                        e =>
                                          e.seatId === seat?.id &&
                                          e?.pot?.toString().toLowerCase() ===
                                            'mainpot',
                                      )
                                      ?.slice(-1)[0]?.displayWinAmount || 0;

                                  // normalize money first
                                  let amount = Number(raw);
                                  amount = Number(amount.toFixed(2));

                                  const bb = Number(
                                    currentTable?.bigBlind || 1,
                                  );

                                  if (showBB) {
                                    let val = amount / bb;
                                    val = Number(val.toFixed(2)); // normalize again after division

                                    return Number.isInteger(val)
                                      ? `${val} BB`
                                      : `${val.toFixed(2)} BB`;
                                  } else {
                                    return Number.isInteger(amount)
                                      ? amount
                                      : amount.toFixed(2);
                                  }
                                })()}
                              </Text>
                            </Animated.View>
                          ) : null}

                          {seat?.bet > 0 &&
                          !currentTable?.handOver &&
                          !currentTable?.endBeforeShowDown ? (
                            <Image
                              style={{
                                height: 15,
                                width: 15,
                                left:
                                  rawPositions[numberOfSeats][cI]?.chipLeft < 0
                                    ? rawPositions[numberOfSeats][cI]
                                        ?.chipLeft + 13
                                    : rawPositions[numberOfSeats][cI]
                                        ?.chipLeft - -5,
                                top:
                                  rawPositions[numberOfSeats][cI]?.chipTop ==
                                  -15
                                    ? rawPositions[numberOfSeats][cI]?.chipTop -
                                      10
                                    : rawPositions[numberOfSeats][cI]
                                        ?.chipTop == 90
                                    ? rawPositions[numberOfSeats][cI]?.chipTop +
                                      15
                                    : rawPositions[numberOfSeats][cI]?.chipTop +
                                      -15,
                                position: 'absolute',
                              }}
                              source={require('../assets/inGameAssets/singleRedChip.png')}
                            />
                          ) : null}

                          {seat?.bet > 0 &&
                          !currentTable?.handOver &&
                          !currentTable?.endBeforeShowDown ? (
                            <View
                              style={{
                                left: rawPositions[numberOfSeats][cI]?.chipLeft,
                                top: rawPositions[numberOfSeats][cI]?.chipTop,
                                position: 'absolute',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: 'grey',
                                height: 15,
                                width: 30,
                                zIndex: 1000,
                                borderRadius: 5,
                              }}
                            >
                              <Text
                                style={{
                                  color: colors.white,
                                  fontSize: 6,
                                  textAlign: 'center',
                                  fontWeight: 'bold',
                                }}
                              >
                                {(() => {
                                  // normalize bet first
                                  let amount = Number(seat?.bet || 0);
                                  amount = Number(amount.toFixed(2));

                                  const bb = Number(
                                    currentTable?.bigBlind || 1,
                                  );

                                  if (showBB) {
                                    let val = amount / bb;
                                    val = Number(val.toFixed(2)); // normalize again after division

                                    return Number.isInteger(val)
                                      ? `${val} BB`
                                      : `${val.toFixed(2)} BB`;
                                  } else {
                                    return Number.isInteger(amount)
                                      ? amount
                                      : amount.toFixed(2);
                                  }
                                })()}
                              </Text>
                            </View>
                          ) : null}

                          {/* Squid Earn Count by Seat */}
                          {seat?.earnSquid > 0 ? (
                            <View
                              style={{
                                left: cI == 0 ? 40 : 10,
                                top: cI == 0 ? -10 : 0,
                                position: 'absolute',
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#FF000099',
                                height: 8,
                                width: 30,
                                zIndex: 1000,
                                borderRadius: 5,
                                flexDirection: 'row',
                              }}
                            >
                              <Image
                                resizeMode="contain"
                                style={{ width: 12, height: 12 }}
                                source={require('../assets/inGameAssets/squidEarnSeat.png')}
                              />
                              <Text
                                style={{
                                  color: colors.white,
                                  fontSize: 6,
                                  //textAlign: 'center',
                                  fontWeight: 'bold',
                                  marginLeft: 1,
                                }}
                              >
                                ×{seat?.earnSquid}
                              </Text>
                            </View>
                          ) : null}

                          {/* Insurance claim by seat */}
                          {currentTable?.insuranceLosers.filter(
                            e => e?.seatId.toString() == seat?.id?.toString(),
                          ).length > 0 && showClaimReturn ? (
                            <View
                              style={{
                                //left: cI == 0 ? 40 : 10,
                                top: -15,
                                position: 'absolute',
                                justifyContent: 'center',
                                alignItems: 'center',

                                height: 20,
                                width: 50,
                                zIndex: 1000,
                                borderRadius: 5,
                                flexDirection: 'row',
                              }}
                            >
                              {/* <Ionicons
                                name="briefcase"
                                size={12}
                                style={{ marginLeft: 5 }}
                                color={'#964B00'}
                              /> */}
                              <Text
                                style={{
                                  color: colors.white,
                                  fontSize: 8,
                                  //textAlign: 'center',
                                  fontWeight: 'bold',
                                  marginLeft: 1,
                                }}
                              >
                                {
                                  currentTable?.insuranceLosers.filter(
                                    e =>
                                      e?.seatId.toString() ==
                                      seat?.id?.toString(),
                                  )[0]?.claim
                                }
                              </Text>
                            </View>
                          ) : null}

                          {seat?.isStraddle ? (
                            <View style={styles.straddleTagCon}>
                              <View style={styles.staddleBanner}>
                                <Text style={styles.starddleTagTxt}>
                                  Straddle
                                </Text>
                              </View>

                              <View style={styles.starddleTagStick}></View>
                            </View>
                          ) : null}

                          {!currentTable?.endBeforeShowDown &&
                          !currentTable?.handOver &&
                          seat?.lastAction == null &&
                          currentTable?.straddledBy?.length > 0 &&
                          currentTable?.straddledBy?.filter(
                            s => s?.seatId == seat?.id,
                          ).length > 0 ? (
                            <View style={styles.straddleActionCon}>
                              <Text style={styles.straddleActionTxt}>
                                {currentTable?.straddledBy?.filter(
                                  s => s?.seatId == seat?.id,
                                ).length > 1 ||
                                currentTable?.straddledBy[0]?.seatId != seat?.id
                                  ? seat?.stack > 0
                                    ? 'Re-Str'
                                    : 'All-In'
                                  : 'Straddle'}
                              </Text>
                            </View>
                          ) : null}

                          {(!seat?.sittingOut && seat?.lastAction != null) ||
                          (seat?.sittingOut && seat?.lastAction == 'WINNER') ? (
                            <View
                              style={[
                                styles.lastActionContainer,
                                {
                                  borderColor:
                                    seat?.lastAction === 'FOLD'
                                      ? colors.betRedBorder
                                      : ['CALL', 'CHECK', 'All-in'].includes(
                                          seat?.lastAction,
                                        )
                                      ? colors.betYellowBorder
                                      : ['RAISE', 'BET'].includes(
                                          seat?.lastAction,
                                        )
                                      ? colors.betBlueBorder
                                      : colors.betYellowBorder,
                                  backgroundColor:
                                    seat?.lastAction === 'FOLD'
                                      ? colors.betRedBg
                                      : ['CALL', 'CHECK', 'All-in'].includes(
                                          seat?.lastAction,
                                        )
                                      ? colors.betYellowBg
                                      : ['RAISE', 'BET'].includes(
                                          seat?.lastAction,
                                        )
                                      ? colors.betBlueBg
                                      : colors.betYellowBg,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.lastActionTxt,
                                  {
                                    color:
                                      seat?.lastAction === 'FOLD'
                                        ? colors.betRedBorder
                                        : ['CALL', 'CHECK', 'All-in'].includes(
                                            seat?.lastAction,
                                          )
                                        ? colors.betYellowBorder
                                        : ['RAISE', 'BET'].includes(
                                            seat?.lastAction,
                                          )
                                        ? colors.betBlueBorder
                                        : colors.betYellowBorder,
                                  },
                                ]}
                              >
                                {seat?.lastAction}
                              </Text>
                            </View>
                          ) : null}

                          {(currentTable?.board?.length < 5 ||
                            (currentTable?.board?.length == 5 &&
                              !animationCompleted.current)) &&
                          currentTable?.insAskDetails?.length > 0 &&
                          seat?.hand?.length > 0 ? (
                            <View
                              style={{
                                left:
                                  rawPositions[numberOfSeats][cI]?.cloudLeft < 0
                                    ? rawPositions[numberOfSeats][cI]
                                        ?.cloudLeft - 15
                                    : rawPositions[numberOfSeats][cI]
                                        ?.cloudLeft,
                                top:
                                  rawPositions[numberOfSeats][cI]?.cloudTop ==
                                  -15
                                    ? rawPositions[numberOfSeats][cI]
                                        ?.cloudTop - 10
                                    : rawPositions[numberOfSeats][cI]
                                        ?.cloudTop == 80
                                    ? rawPositions[numberOfSeats][cI]?.cloudTop
                                    : rawPositions[numberOfSeats][cI]?.cloudTop,
                                position: 'absolute',
                                height: 90,
                                width: 90,
                                //backgroundColor:"red"
                              }}
                            >
                              {!currentTable?.insAskDetails
                                ?.filter(e => e?.key === 'mainpot')
                                ?.map(e => String(e.favouriteSeat))
                                ?.includes(String(seat?.id)) &&
                              !seat?.folded ? (
                                <ImageBackground
                                  style={{
                                    zIndex: 9999,
                                    height: '100%',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                  }}
                                  resizeMode="contain"
                                  source={require('../assets/inGameAssets/blackCloud.png')}
                                >
                                  <View
                                    style={{
                                      flexDirection: 'row',
                                      width: '90%',
                                      flexWrap: 'wrap',
                                      overflow: 'hidden',

                                      maxHeight: 50,
                                      width: '68%',
                                      alignSelf: 'center',
                                    }}
                                  >
                                    {currentTable?.insAskDetails
                                      ?.filter(e => e?.key === 'mainpot')
                                      ?.flatMap(e => e.seats ?? [])
                                      ?.some(
                                        s =>
                                          String(s?.seat?.id) ===
                                            String(seat?.id) &&
                                          (s?.tc?.length ?? 0) === 0 &&
                                          Number(s?.wins ?? 0) === 0,
                                      ) && (
                                      <Image
                                        resizeMode="contain"
                                        style={{
                                          height: 40,
                                          width: 60,
                                          alignSelf: 'center',
                                        }}
                                        source={require('../assets/inGameAssets/drawingDead.png')}
                                      />
                                    )}

                                    {currentTable?.insAskDetails
                                      ?.filter(e => e?.key === 'mainpot')
                                      ?.flatMap(e => e.seats ?? [])
                                      ?.some(
                                        s =>
                                          String(s?.seat?.id) ===
                                            String(seat?.id) &&
                                          (s?.tc?.length ?? 0) === 0 &&
                                          Number(s?.wins ?? 0) > 0,
                                      ) && (
                                      <Image
                                        resizeMode="contain"
                                        style={{
                                          height: 40,
                                          width: 60,
                                          alignSelf: 'center',
                                        }}
                                        source={require('../assets/inGameAssets/runner.png')}
                                      />
                                    )}

                                    {currentTable?.insAskDetails
                                      ?.filter(e => e?.key === 'mainpot')
                                      ?.flatMap(e => e.seats ?? [])
                                      ?.filter(
                                        s =>
                                          String(s?.seat?.id) ===
                                          String(seat?.id),
                                      )
                                      ?.flatMap(s => s.tc ?? [])
                                      ?.map((card, index) => (
                                        <View
                                          key={`${card}-${index}`}
                                          style={{ height: 18, width: 18 }}
                                        >
                                          <Image
                                            resizeMode="contain"
                                            resizeMethod="resize"
                                            source={getCardImage({
                                              rank: card[0],
                                              suit: card[1],
                                            })}
                                            style={styles.card}
                                          />
                                        </View>
                                      ))}
                                  </View>
                                </ImageBackground>
                              ) : null}
                            </View>
                          ) : null}

                          {seat &&
                          seat?.hand?.length > 0 &&
                          (myPlayer?.id == seat?.id || !seat.folded) ? (
                            <View
                              style={{
                                //position: 'absolute',
                                position: 'absolute',
                                overflow: 'visible',
                                transformStyle: 'preserve-3d', // important for iOS
                                flexDirection: 'row',

                                left:
                                  (currentTable?.handOver ||
                                    currentTable?.endBeforeShowDown) &&
                                  !currentTable?.isEndWithoutShowDown
                                    ? 0
                                    : cI == 0
                                    ? 40
                                    : posCard[cI],
                                bottom:
                                  (currentTable?.handOver ||
                                    currentTable?.endBeforeShowDown) &&
                                  !currentTable?.isEndWithoutShowDown
                                    ? 0
                                    : cI == 0
                                    ? 12
                                    : -3,
                                flexDirection: 'row',

                                zIndex: 2,
                              }}
                            >
                             
                              
                              
                              {isDistributed &&
                                 (
    originalReplay?.replay
      ?.find(e => e.type === "PLAYERS_CARDS_UPDATED")
      ?.table
      ?.find(
        e =>
          e?.userId?.toString() ===
          seat?.player?.id?.toString()
      )
      ?.hand?.length > 0
      ? originalReplay?.replay
          ?.find(e => e.type === "PLAYERS_CARDS_UPDATED")
          ?.table
          ?.find(
            e =>
              e?.userId?.toString() ===
              seat?.player?.id?.toString()
          )
          ?.hand
      : seat?.hand || []
  ).map((item, index) => {
                                  const isShowdown =
                                    (currentTable?.handOver ||
                                      currentTable?.endBeforeShowDown) &&
                                    !currentTable?.isEndWithoutShowDown;

                                  // your old `left` choices
                                  const baseLeft = isShowdown
                                    ? numberOfCards == 2
                                      ? 5
                                      : numberOfCards == 4
                                      ? 3
                                      : numberOfCards == 6
                                      ? -10
                                      : -10
                                    : 0;

                                  // your old `marginRight` choices (negative = overlap)
                                  const gap = isShowdown
                                    ? -16
                                    : cI == 0
                                    ? -30
                                    : -15;

                                  // final horizontal offset for THIS card index
                                  const tx = baseLeft + index * gap;
                                  const flipAnim =
                                    flipAnims.current?.[seat?.id]?.[index];
                                  if (!flipAnim) return null;

                                  const rotateYBack = flipAnim.interpolate({
                                    inputRange: [0, 180],
                                    outputRange: ['0deg', '180deg'],
                                  });
                                  const rotateYFront = flipAnim.interpolate({
                                    inputRange: [0, 180],
                                    outputRange: ['180deg', '360deg'],
                                  });

                                  return (
                                    <Animated.View
                                      key={index}
                                      style={{
                                        height:
                                          (currentTable?.handOver ||
                                            currentTable?.endBeforeShowDown) &&
                                          !currentTable?.isEndWithoutShowDown
                                            ? 35
                                            : cI == 0
                                            ? 50
                                            : 30,

                                        width:
                                          (currentTable?.handOver ||
                                            currentTable?.endBeforeShowDown) &&
                                          !currentTable?.isEndWithoutShowDown
                                            ? 26
                                            : cI == 0
                                            ? 50
                                            : 25,

                                        // ...((currentTable?.handOver ||
                                        //   currentTable?.endBeforeShowDown) &&
                                        // !currentTable?.isEndWithoutShowDown
                                        //   ? {
                                        //       left:
                                        //         numberOfCards == 2
                                        //           ? 5
                                        //           : numberOfCards == 4
                                        //           ? 3
                                        //           : numberOfCards == 6
                                        //           ? -10
                                        //           : -10,
                                        //       top: -18,
                                        //     }
                                        //   : {}),

                                        // marginRight:
                                        //   (currentTable?.handOver ||
                                        //     currentTable?.endBeforeShowDown) &&
                                        //   !currentTable?.isEndWithoutShowDown
                                        //     ? -16
                                        //     : cI == 0
                                        //     ? -35
                                        //     : -20,

                                        transform: [
                                          { perspective: 800 }, // iOS 3D fix
                                          { translateX: tx }, // ✅ the only spacing that matters on iOS
                                          {
                                            rotateY: isShowdown
                                              ? '0deg'
                                              : `${index}deg`, // your original tilt
                                          },
                                          ...(cI === 0
                                            ? [
                                                {
                                                  translateY: isShowdown
                                                    ? -10
                                                    : cardOffsetPos?.[index] ??
                                                      0,
                                                },
                                              ]
                                            : [
                                                {
                                                  translateY: isShowdown
                                                    ? -10
                                                    : -3,
                                                },
                                              ]),
                                        ],
                                        // color:"red",

                                        zIndex: index,
                                        position: 'absolute',
                                        overflow: 'visible',
                                        transformStyle: 'preserve-3d',
                                        backfaceVisibility: 'hidden',
                                        //zIndex: seat?.hand?.length - index,

                                        // ✅ Border applied to View
                                        borderColor:
                                          currentWinObj?.filter(
                                            obj =>
                                              obj.pot === 'mainpot' &&
                                              obj.playingCards?.filter(
                                                e =>
                                                  e.suit === item.suit &&
                                                  e.rank === item.rank,
                                              ).length > 0,
                                          ).length > 0
                                            ? colors.lemonFlash
                                            : 'transparent',
                                        borderWidth:
                                          currentWinObj?.filter(
                                            obj =>
                                              obj.pot === 'mainpot' &&
                                              obj.playingCards?.filter(
                                                e =>
                                                  e.suit === item.suit &&
                                                  e.rank === item.rank,
                                              ).length > 0,
                                          ).length > 0
                                            ? 1.5
                                            : 0,

                                        borderRadius: 4,
                                        position: 'relative',
                                      }}
                                    >
                                      {seat?.id == myPlayer?.id ? (
                                        <Image
                                          resizeMode="contain"
                                          source={getCardImage(item)}
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                          }}
                                        />
                                      ) : null}

                                      {seat?.id != myPlayer?.id ? (
                                        <View
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                          }}
                                        >
                                          <Animated.View
                                            style={[
                                              // styles.cardWrapper,
                                              {
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backfaceVisibility: 'hidden',
                                                transform: [
                                                  { perspective: 1000 },

                                                  { rotateY: rotateYBack },
                                                ],
                                              },
                                            ]}
                                          >
                                            <Image
                                              resizeMode="contain"
                                              source={require('../assets/cards/hidden/hidden.png')}
                                              style={{
                                                width: '100%',
                                                height: '100%',
                                              }}
                                            />
                                          </Animated.View>
                                          {/* front Face */}
                                          <Animated.View
                                            style={[
                                              {
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backfaceVisibility: 'hidden',
                                                transform: [
                                                  { perspective: 1000 },

                                                  { rotateY: rotateYFront },
                                                ],
                                              },
                                            ]}
                                          >
                                            <Image
                                              resizeMode="contain"
                                              source={getCardImage(item)}
                                              style={{
                                                width: '100%',
                                                height: '100%',
                                              }}
                                            />
                                          </Animated.View>
                                        </View>
                                      ) : null}
                                    </Animated.View>
                                  );
                                })}
                            </View>
                          ) : null}
                        </View>

                        {seat?.sittingOut ? (
                          !currentTable?.isEndWithoutShowDown &&
                          !currentTable?.wentToShowdown &&
                          !currentTable?.endBeforeShowDown ? (
                            <View style={styles.profileContainerSitOut}>
                           <Image
  source={{ uri: SitOutSvg }}
  style={{ height: 15, width: 15 }}
  resizeMode="contain"
/>
                              <Text style={styles.sitOutTxt}>Sitting Out</Text>
                            </View>
                          ) : (
                            <View style={styles.profileContainerSitOutTrans}>
                              <Text style={styles.sitOutTxt}>Sitting Out</Text>
                            </View>
                          )
                        ) : null}
                        <View>
                          {seat != null ? (
                            <View
                              style={{
                                position: 'absolute',
                                bottom: -38,
                                left: -35,
                              }}
                            >
                              {blink &&
                              remainTime > 0.5 &&
                              currentTable?.turn == seat?.id &&
                              !currentTableId?.handOver &&
                              !currentTable?.isRoundChanging &&
                              !currentTable?.wentToShowdown &&
                              !currentTable?.endBeforeShowDown ? (
                                <Animated.View
                                  style={{
                                    opacity: fadeAnim,
                                    width: 70,
                                    height: 50,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Image
                                    resizeMode="contain"
                                    style={{ height: '100%', width: '200%' }}
                                    source={require('../assets/inGameAssets/turnSeat.png')}
                                  />
                                </Animated.View>
                              ) : (
                                <View
                                  style={{
                                    width: 70,
                                    height: 50,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Image
                                    resizeMode="contain"
                                    style={{ height: '100%', width: '100%' }}
                                    source={require('../assets/inGameAssets/seat.png')}
                                  />
                                </View>
                              )}

                              {/* Timer Slider */}
                              {currentTable?.turn == seat?.id &&
                              !currentTableId?.handOver &&
                              remainTime > 0.5 &&
                              !seat?.sittingOut &&
                              !currentTable?.isRoundChanging &&
                              !currentTable?.isEndWithoutShowDown &&
                              !currentTable?.wentToShowdown &&
                              !currentTable?.endBeforeShowDown ? (
                                <View
                                  style={{
                                    width: '80%',
                                    height: 2,
                                    backgroundColor: colors.gray,
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    alignSelf: 'center',
                                  }}
                                >
                                  <View
                                    style={{
                                      width: `${
                                        (remainTime / actionTime) * 100
                                      }%`,
                                      height: '100%',
                                      backgroundColor:
                                        remainTime < 10.0
                                          ? colors.red
                                          : colors.primary,
                                      borderRadius: 3,
                                    }}
                                  />
                                </View>
                              ) : null}

                              {/*Straddle Timer Slider */}
                              {currentTable?.straddleRunning &&
                              seat?.willStraddle &&
                              seat?.isBBPaid &&
                              seat?.stack > 0 &&
                              currentTable?.straddleType == 'EVERYONE' &&
                              !currentTableId?.handOver &&
                              remainTime > 0.5 &&
                              !seat?.sittingOut &&
                              !currentTable?.isRoundChanging &&
                              !currentTable?.isEndWithoutShowDown &&
                              !currentTable?.wentToShowdown &&
                              !currentTable?.endBeforeShowDown ? (
                                <View
                                  style={{
                                    width: '80%',
                                    height: 2,
                                    backgroundColor: colors.gray,
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    alignSelf: 'center',
                                  }}
                                >
                                  <View
                                    style={{
                                      width: `${(remainTime / 8) * 100}%`,
                                      height: '100%',
                                      backgroundColor: colors.primary,
                                      borderRadius: 3,
                                    }}
                                  />
                                </View>
                              ) : null}
                            </View>
                          ) : null}

                          <View style={styles.detailsContainer}>
                            {/* Favourite / Underdog */}
                            {currentTable?.insAskDetails.length > 0 &&
                            seat?.hand?.length > 0 &&
                            !seat?.folded ? (
                              <View
                                style={[
                                  styles.lastActionContainer2,
                                  {
                                    borderColor: !isIncludedInFavourite(
                                      seat?.id,
                                    )
                                      ? colors.betRedBorder
                                      : colors.betBlueBorder,
                                    backgroundColor: !isIncludedInFavourite(
                                      seat?.id,
                                    )
                                      ? colors.betRedBg
                                      : colors.betBlueBg,
                                  },
                                ]}
                              >
                                <Text
                                  style={[
                                    styles.lastActionTxt,
                                    {
                                      color: !isIncludedInFavourite(seat?.id)
                                        ? colors.betRedBorder
                                        : colors.betBlueBorder,
                                    },
                                  ]}
                                >
                                  {isIncludedInFavourite(seat?.id)
                                    ? 'FAVOURITE'
                                    : 'UNDERDOG'}
                                </Text>
                              </View>
                            ) : null}

                            <Text style={styles.nameTxt} numberOfLines={1}>
                              {seat?.player?.displayName?.hasOwnProperty(
                                'username',
                              )
                                ? seat?.player?.displayName?.username
                                : seat?.player?.displayName}
                            </Text>
                           
<Image
  source={LineSvg}
  style={{ width: 30, height: 5 }}
  resizeMode="contain"
/>
                          
                            {seat?.isRebuy ? (
                              <Text style={styles.stackTxt} numberOfLines={1}>
                                REBUY
                              </Text>
                            ) : (
                              <Text style={styles.stackTxt} numberOfLines={1}>
                                {(() => {
                                  // normalize stack first
                                  let amount = Number(seat?.stack || 0);
                                  amount = Number(amount.toFixed(2));

                                  const bb = Number(
                                    currentTable?.bigBlind || 1,
                                  );

                                  if (showBB) {
                                    let val = amount / bb;
                                    val = Number(val.toFixed(2)); // normalize again after division

                                    return Number.isInteger(val)
                                      ? `${val} BB`
                                      : `${val.toFixed(2)} BB`;
                                  } else {
                                    return Number.isInteger(amount)
                                      ? amount
                                      : amount.toFixed(2);
                                  }
                                })()}
                              </Text>
                            )}
                          </View>
                          {seat?.sittingOut ? (
                            <View style={styles.detailsContainerSitOut}></View>
                          ) : null}
                        </View>
                      </View>
                    ) : null}

                    
                    {/* Take Seat */}
                    {
                    seat == null &&
                    myPlayer == null &&
                checkedPlayer &&
                    currentTable?.tournamentId == null ? (
                      <TouchableOpacity
                        activeOpacity={1}
                        onPress={() => {
                         // takeASeat(i);
                        }}
                      >
                       <Image
  source={{ uri: EmptySeat }}
  style={{
    width: 20,
    height: 20
  }}
/>
                      </TouchableOpacity>
                    ) : null}
                    {/* Empty Seat */}
                    {seat == null &&
                    (myPlayer != null ||
                      (myPlayer == null &&
                        currentTable?.tournamentId != null)) &&
                    checkedPlayer &&
                    (myPlayer?.id != seat?.id ||
                      (myPlayer == null &&
                        currentTable?.tournamentId != null)) ? (
                       <Image
  source={{ uri: EmptySeat }}
  style={{
    width: 20,
    height: 20
  }}
/>
                    ) : null}
                  </TouchableOpacity>

                  {myPlayer &&
                  !currentTable?.handOver &&
                  myPlayer?.id == seat?.id &&
                  currentTable?.endBeforeShowDown &&
                  !currentTable?.isEndWithoutShowDown &&
                  seat?.outcome?.['_1']?.['HI']?.wins > 0 ? (
                    <View style={styles.winPercentage}>
                      <Text style={styles.winPercentageTxt}>
                        Win : {seat?.outcome?.['_1']['HI'].wins}%
                      </Text>
                      <Text style={styles.winPercentageTxt}>
                        Ties : {seat?.outcome?.['_1']['HI'].ties}%
                      </Text>
                    </View>
                  ) : null}

                  {myPlayer &&
                  myPlayer?.id == seat?.id &&
                  !currentTable?.handOver &&
                  !currentTable?.isEndWithoutShowDown ? (
                    <View style={styles.handRanking}>
                      <Text style={styles.handRankTxt}>
                        {seatRanksRef?.current?.[seat?.id]?.handRank
                          ? seatRanksRef.current[seat.id]?.handRank.replace(
                              /\b\w/g,
                              c => c.toUpperCase(),
                            )
                          : ''}
                      </Text>
                    </View>
                  ) : null}

                  {myPlayer &&
                  myPlayer?.id == seat?.id &&
                  !currentTable?.handOver &&
                  seatRanksRef?.current[seat?.id]?.handRank2?.length > 0 &&
                  !currentTable?.isEndWithoutShowDown ? (
                    <View style={styles.handRanking2}>
                      <Text style={styles.handRankTxt}>
                        {seatRanksRef?.current?.[seat?.id]?.handRank2
                          ? seatRanksRef.current[seat.id]?.handRank2.replace(
                              /\b\w/g,
                              c => c.toUpperCase(),
                            )
                          : ''}
                      </Text>
                    </View>
                  ) : null}

                  {myPlayer &&
                  myPlayer?.id == seat?.id &&
                  !currentTable?.handOver &&
                  seatRanksRef?.current[seat?.id]?.handRank3?.length > 0 &&
                  !currentTable?.isEndWithoutShowDown ? (
                    <View style={styles.handRanking3}>
                      <Text style={styles.handRankTxt}>
                        {seatRanksRef?.current?.[seat?.id]?.handRank3
                          ? seatRanksRef.current[seat.id]?.handRank3.replace(
                              /\b\w/g,
                              c => c.toUpperCase(),
                            )
                          : ''}
                      </Text>
                    </View>
                  ) : null}
                </Animated.View>
              </>
            );
          })}

        {/* card distribution */}
        <View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          {cardAnims.map((card, i) =>
            card.visible ? (
              <Animated.Image
                key={i}
                source={require('../assets/cards/hidden/hidden.png')}
                style={{
                  width: 20,
                  height: 30,
                  position: 'absolute',
                  transform: card.animatedXY.getTranslateTransform(),
                  zIndex: 1000,
                }}
              />
            ) : null,
          )}
        </View>

     
       
        {/* <Text style={{ color: 'white' }}>{remainTime.toFixed(1)}s */}

     


     

     
        {/* Win chips Animation */}
        {animatedChips2.map(chip => (
          <Animated.Image
            key={chip.id}
            source={require('../assets/inGameAssets/singleRedChip.png')}
            style={{
              position: 'absolute',
              width: 15,
              height: 15,
              transform: [
                { translateX: chip.translateX },
                { translateY: chip.translateY },
              ],
            }}
          />
        ))}

        {/* Win chips Animation */}
        {animatedChips.map(chip => (
          <Animated.Image
            key={chip.id}
            source={require('../assets/inGameAssets/singleRedChip.png')}
            style={{
              position: 'absolute',
              width: 15,
              height: 15,
              transform: [
                { translateX: chip.translateX },
                { translateY: chip.translateY },
              ],
            }}
          />
        ))}

        {/*Pot Info*/}
        {showPotInfo && currentTable?.tablePot > 0 ? (
          <View style={styles.potContainer}>
          
            <PotInfo
              data={currentTable}
              showBB={showBB}
              message={currentMessage}
            />
          </View>
        ) : null}

       
        {/* <TouchableOpacity style={styles.gameRulesContainer}>
          <Text style={styles.gameRulesTxt}>Game{'\n'}Rules</Text>
        </TouchableOpacity> */}

        <TouchableOpacity style={styles.menuIcon}>
          {/* <MenuSvg /> */}
        </TouchableOpacity>
    
          

        <TouchableOpacity
          style={styles.handHisotryIcon}
          onPress={() => setHandHistoryDrawerVisible(true)}
        >
          {/* <HandHistorySvg /> */}
        </TouchableOpacity>

        {/* Squid Octopus icon */}
        {currentTable?.squidRunning ? (
          <TouchableOpacity
            style={styles.octopusIcon}
            onPress={() => setHandHistoryDrawerVisible(true)}
          >
            <Image
              style={{ height: 50, width: 50 }}
              source={require('../assets/inGameAssets/octopus.gif')}
            />
            <Text
              style={styles.octopusTxt}
            >{`${currentTable?.squidCurrentCount}/${currentTable?.squidCount}`}</Text>
          </TouchableOpacity>
        ) : null}

        {/* MTT Add on */}
        {tableData?.table?.tournamentId != null &&
        showAicon &&
        !myPlayer?.addOn ? (
          <TouchableOpacity
            style={styles.addOnIcon}
            onPress={() => {
              setShowAddOn(true);
            }}
          >
            <Text style={styles.addOnTxt}>A</Text>
          </TouchableOpacity>
        ) : null}

        {/* MTT : FT Deal */}
        {currentTour?.ftDeal && Object.keys(currentTour.ftDeal).length > 0 ? (
          <TouchableOpacity
            style={[styles.ftDealBox]}
            onPress={() => {
              console.log(
                'remainTimeFTDEAL > 0 && !showFtModal2',
                remainTimeFTDEAL > 0,
                showFtModal2,
              );
              // if time left and already aggreed
              if (remainTimeFTDEAL > 0 && !showFtModal2) {
                setShowFTModal2(true);
                return;
              }

              if (currentWindetails != null) {
                setShowFTModal1(false);
                return;
              }
              setShowFTModal1(true);
            }}
          >
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {/* {myPlayer != null &&
              currentTour?.ftDeal?.players?.find(
                e => e?.id?.toString() === user?.user?.id?.toString(),
              )?.dealStatus !== 'NONE' ? (
                <Ionicons
                  name="checkbox-outline"
                  color={colors.white}
                  size={15}
                />
              ) : (
                <Ionicons
                  name="square-outline"
                  color={colors.white}
                  size={15}
                />
              )} */}
              <Text style={styles.ftDealTxt2}> DEAL</Text>
            </View>
            <Text style={styles.ftDealTxt}>
              {(() => {
                const players = currentTour?.ftDeal?.players || [];

                const validPlayers = players.filter(
                  p => p?.dealStatus !== 'NONE',
                );

                if (validPlayers.length === 0) return 0;

                const counts = {};
                validPlayers.forEach(p => {
                  counts[p.dealStatus] = (counts[p.dealStatus] || 0) + 1;
                });

                return Math.max(...Object.values(counts));
              })()}
              /{currentTour?.ftDeal?.players?.length}
            </Text>
            {/* Filled part */}
            <View
              style={{
                height: 2,
                position: 'absolute',
                bottom: 0,
                alignSelf: 'flex-start',
                backgroundColor: colors.primary, // filled color
                width: `${(() => {
                  const players = currentTour?.ftDeal?.players || [];

                  const validPlayers = players.filter(
                    p => p?.dealStatus !== 'NONE',
                  );

                  if (validPlayers.length === 0) return 0;

                  const counts = {};
                  validPlayers.forEach(p => {
                    counts[p.dealStatus] = (counts[p.dealStatus] || 0) + 1;
                  });

                  const max = Math.max(...Object.values(counts));

                  return (max / players.length) * 100;
                })()}%`,
              }}
            />
          </TouchableOpacity>
        ) : null}

      
     
        {!isModalVisible['raise'] ? (
          <TouchableOpacity
            onPress={() => {
              setIsModalVisible({ ...isModalVisible, chat: true });
            }}
            style={styles.chatIcon}
          >
            {/* <ChatSvg /> */}
          </TouchableOpacity>
        ) : null}

        {currentTable?.turn != null && !currentTable?.handOver ? (
          <TouchableOpacity style={styles.clockIcon}>
            <Image
              style={styles.clock}
              source={require('../assets/inGameAssets/Clock.png')}
            ></Image>
            <Text
              style={[styles.clockTxt, { top: Platform.OS == 'ios' ? 12 : 10 }]}
            >
              {currentTable?.actionTime}s
            </Text>
          </TouchableOpacity>
        ) : null}

        {/* stadium shape dots */}
        {/* {debugDots}     */}

       
       

        
       
      
        {/*win hand desc*/}

        {currentWinObj && currentWinObj[0].handRank ? (
          <View style={styles.handDesc}>
            <View style={styles.handDescCon1}>
              <Text style={styles.winTxt}>
                {currentWinObj?.[0]?.handRank
                  ? currentWinObj[0]?.handRank.toString()
                  : ''}

                {isMultiBoard ? ` - Board ${currentWinObj[0]?.boardId}` : ''}
              </Text>
            </View>
          </View>
        ) : null}

        {/* Squid countdown */}
        {squidCountdown > 0 ? (
          <View style={styles.squidCountdown}>
            <Text style={styles.countdownTxt}>{squidCountdown}</Text>
          </View>
        ) : null}

        {showSquidWin ? (
          <View style={styles.squidDesc}>
            <View style={styles.squidDescCon1}>
              <Text style={styles.winTxt}>{squidWinTxt}</Text>
            </View>
          </View>
        ) : null}

        {ritMsg &&
        ritMsg.length > 0 &&
        myPlayer?.id != currentTable?.ritAskDetails?.to?.toString() ? (
          <View style={styles.ritMsg}>
            <View style={styles.handDescCon1}>
              <Text style={[styles.winTxt, { color: 'white' }]}>{ritMsg}</Text>
            </View>
          </View>
        ) : null}


   {riskMsg &&
        riskMsg.length > 0 &&
        myPlayer?.id != currentTable?.ritAskDetails?.to?.toString() ? (
          <View style={styles.ritMsg}>
            <View style={styles.handDescCon1}>
              <Text style={[styles.winTxt, { color: 'white' }]}>{riskMsg}</Text>
            </View>
          </View>
        ) : null}
        {currentTable?.tournamentId != null &&
        Date.parse(finalTime) - Date.now() <= 0 &&
        Object.values(currentTable?.seats).filter(e => e != null).length ===
          1 ? (
          <View style={styles.ritMsg}>
            <View style={styles.handDescCon1}>
              <Text style={[styles.winTxt, { color: 'white' }]}>
                Waiting for other players to join
              </Text>
            </View>
          </View>
        ) : null}

        {ritMsg &&
        ritMsg.length > 0 &&
        myPlayer?.id != currentTable?.ritAskDetails?.to?.toString() ? (
          <View style={styles.ritMsg}>
            <View style={styles.handDescCon1}>
              <Text style={[styles.winTxt, { color: 'white' }]}>{ritMsg}</Text>
            </View>
          </View>
        ) : null}

        {insMsg &&
        insMsg.length > 0 &&
        ((!checkAllInsuranceActionsTaken() &&
          checkMyAllInsuranceActionsTaken(myPlayer?.id)) ||
          myPlayer == null) &&
        animationCompleted.current ? (
          <View style={styles.ritMsg}>
            <View style={styles.handDescCon1}>
              <Text style={[styles.winTxt, { color: 'white' }]}>{insMsg}</Text>
            </View>
          </View>
        ) : null}

        {mttMsg && mttMsg.length > 0 ? (
          <View style={styles.ritMsg}>
            <View style={styles.handDescCon1}>
              <Text style={[styles.winTxt, { color: 'white' }]}>{mttMsg}</Text>
            </View>
          </View>
        ) : null}

        {/* {winMsg ? (
          <View style={styles.handDescBottom}>
            <View style={styles.handDescCon2}>
              <Text style={styles.winTxt2}>
                {currentWinObj[0]?.pot ? currentWinObj[0]?.pot?.toUpperCase(): ''}
              </Text>

              <Text style={styles.winTxt2}>
                {currentWinObj?.length
                  ? currentWinObj
                      .map( obj => {

                        let msg = obj?.message?.toLowerCase().trim();
        if (!msg) return null;

        // Match currency like $3.00 or $5
        msg = msg.replace(/\$\d+(\.\d{1,2})?/g, match => {
          const amount = parseFloat(match.replace('$', ''));
          const bb = showBB
                                ? Number(amount / currentTable?.bigBlind) %
                                    1 ==
                                  0
                                  ? `${Number(amount / currentTable?.bigBlind)} BB ` 
                                  : `${Number(
                                      amount / currentTable?.bigBlind,
                                    ).toFixed(1)} BB`
                                : Number(amount) % 1 == 0
                                ? amount
                                : Number(amount).toFixed(1);
          return `${bb}`;
        });

        return msg;
        })
                      .filter(Boolean)
                      .join(', ')
                  : ''}
              </Text>
            </View>
          </View>
        ) : null} */}

        {/* Squid Settlement */}
        {/* {showSquidSettlement && currentPageTable == currentTableId && (
          <Modal
            isVisible={showSquidSettlement}
            backdropOpacity={0.7}
            onBackdropPress={() => {
              setShowSquidSettlement(false);
            }}
            transparent={true}
            style={[
              styles.fullmodal,
              {
                marginTop: insets.top,
                marginBottom: insets.bottom,
              },
            ]}
            animationIn="slideInLeft"
            animationOut="slideOutLeft"
          >
            <View
              style={{
                width: '85%',
                height: '55%',
                alignSelf: 'center',
                marginTop: '35%',
              }}
            >
              <ImageBackground
                source={require('../../assets/inGameAssets/squidSettlement.png')}
                resizeMode="contain" // or "cover" depending on your design
                style={{ width: '100%', height: '100%' }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setShowSquidSettlement(false);
                  }}
                  style={styles.closeIconSquid}
                >
                  <Ionicons name="close" color="white" size={20} />
                </TouchableOpacity>
                <Text style={styles.goldheading}>Squid Settlement</Text>

                <View style={styles.handCount}>
                  <Text style={styles.handTxt}>
                    Hands: {currentTable?.squidHandCount}
                  </Text>
                </View>

                <View style={styles.squidList}>
                  <ScrollView style={{}}>
                    {[...(currentTable?.squidWinDetails ?? [])]
                      .sort((a, b) => {
                        // Negatives first
                        if (a.amount < 0 && b.amount >= 0) return -1;
                        if (a.amount >= 0 && b.amount < 0) return 1;

                        // Both negative → higher negative first (-1 before -10)
                        if (a.amount < 0 && b.amount < 0) {
                          return b.amount - a.amount;
                        }

                        // Both positive → lower positive first (5 before 20)
                        return a.amount - b.amount;
                      })
                      .map((item, index) => (
                        <View
                          style={[
                            styles.handTxt,
                            {
                              flexDirection: 'row',
                              height: 30,
                              padding: 5,
                              marginTop: 5,
                              width: '100%',
                              justifyContent: 'space-between',
                              backgroundColor:
                                index % 2 === 0
                                  ? 'rgba(0,0,0,0.8)'
                                  : 'transparent',
                              alignItems: 'center',
                            },
                          ]}
                        >
                          <Text style={{ color: 'white' }}>{item?.name} :</Text>

                          <Text
                            style={{
                              color: item?.amount < 0 ? 'red' : 'green',
                              textAlign: 'right',
                              alignSelf: 'flex-end',
                            }}
                          >
                            {item?.amount > 0 ? '+' : ''}
                            {item?.amount}
                          </Text>
                        </View>
                      ))}
                  </ScrollView>
                </View>
                <TouchableOpacity
                  onPress={() => {
                    setShowSquidSettlement(false);
                  }}
                >
                  <LinearGradient
                    colors={['#AA193A', '#8D0422']}
                    style={styles.squidConfirm}
                  >
                    <Text style={styles.squidTxtConfirm}>Confirm</Text>
                  </LinearGradient>
                </TouchableOpacity>
              </ImageBackground>
            </View>
          </Modal>
        )} */}

        {/* Squid Details */}
        {/* <Modal
          isVisible={false}
          backdropOpacity={0.7}
          onBackdropPress={() => {
            //setShowSquidSettlement(false);
          }}
          transparent={true}
          style={[
            styles.fullmodal,
            {
              marginTop: insets.top,
              marginBottom: insets.bottom,
            },
          ]}
          animationIn="slideInLeft"
          animationOut="slideOutLeft"
        >
          <View
            style={{
              width: '85%',
              height: '55%',
              alignSelf: 'center',
              marginTop: '35%',
            }}
          >
            <ImageBackground
              source={require('../../assets/inGameAssets/squidSettlement.png')}
              resizeMode="contain" // or "cover" depending on your design
              style={{ width: '100%', height: '100%' }}
            >
              <TouchableOpacity
                onPress={() => {
                  // setShowSquidSettlement(false);
                }}
                style={styles.closeIconSquid}
              >
                <Ionicons name="close" color="white" size={20} />
              </TouchableOpacity>

              <View style={styles.squidDetailCon}>
                <Text style={styles.goldheading2}>
                  {currentTable?.squidType
                    ? `${
                        currentTable.squidType.charAt(0).toUpperCase() +
                        currentTable.squidType.slice(1).toLowerCase()
                      } Squid`
                    : ''}
                </Text>

                <Text style={styles.squidTxt}>Players who win the squid</Text>

                <Text style={styles.squidTxt}>
                  Players who do not win the squid
                </Text>
              </View>
            </ImageBackground>
          </View>
        </Modal> */}

        {/* Animated sticker overlay — isolated in its own memoized component
            so setAnimatedStickers re-renders don't propagate to Table */}
       

        {/* Side Panel */}
       

      

       

    

      
        
   
      </View>

      <View
        style={{
          backgroundColor: colors.background,
          height: 200,

          width: '100%',
        }}
      >
        {currentTable?.squidRunning && (
          <Image
            source={require('../assets/inGameAssets/sea.png')}
            style={{ flex: 1, position: 'absolute' }}
            resizeMode="cover"
          />
        )}
       
        <View style={{ flexDirection: 'row' }}></View>

       </View>

   
    </View>
  );
});

export default Table;
